import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  Datetime: any;
  JSON: any;
  Time: any;
  _FieldSet: any;
};

export type AddDeleteRolePermissionScopeResult = {
  __typename?: 'AddDeleteRolePermissionScopeResult';
  error?: Maybe<DeleteRolePermissionScopeError>;
  /** Actual results */
  items?: Maybe<Array<RolePermissionScope>>;
};

export type AddDeleteRolePermissionsInput = {
  newRolePermissions: Array<CreateRolePermissionScopeInput>;
  toBeDeleteRolePermissionIds: Array<Scalars['ID']>;
};

export enum AdhocOrderError {
  FAILED_TO_INSERT_ADHOC_ORDER = 'FAILED_TO_INSERT_ADHOC_ORDER',
  ORDER_NO_ALREADY_EXIST = 'ORDER_NO_ALREADY_EXIST',
  REQUESTER_DOESNT_HAVE_TOOL_HOUND_ID = 'REQUESTER_DOESNT_HAVE_TOOL_HOUND_ID',
  USER_DOESNT_HAVE_OUTBOUND_USER_ID = 'USER_DOESNT_HAVE_OUTBOUND_USER_ID'
}

export type AdhocOrderResult = {
  __typename?: 'AdhocOrderResult';
  error?: Maybe<AdhocOrderError>;
  toolOrder?: Maybe<ToolOrder>;
};

export enum AdvanceToolOrderStatusError {
  FAILED_TO_UPDATE_TOOL_ORDER_STATUS = 'FAILED_TO_UPDATE_TOOL_ORDER_STATUS',
  INVALID_ADVANCEMENT_OF_TOOL_ORDER = 'INVALID_ADVANCEMENT_OF_TOOL_ORDER'
}

/** Input for advanceToolOrderStatus mutation */
export type AdvanceToolOrderStatusInput = {
  /** checkedOutBy */
  checkedOutBy?: InputMaybe<Scalars['String']>;
  /** Order id */
  id: Scalars['ID'];
  /** Status id */
  status: ToolOrderStatus;
};

export type AdvanceToolOrderStatusResult = {
  __typename?: 'AdvanceToolOrderStatusResult';
  error?: Maybe<AdvanceToolOrderStatusError>;
  toolOrder?: Maybe<ToolOrder>;
};

/**
 * List of specific permissions which are available in the application.
 * These have to be replicated in all sub graphs requiring the use of permission checks
 */
export enum AuthPermission {
  ADD_FAVORITE = 'ADD_FAVORITE',
  ADD_RESERVATION = 'ADD_RESERVATION',
  ADD_USER = 'ADD_USER',
  ADVANCE_RESERVATION_STATUS = 'ADVANCE_RESERVATION_STATUS',
  CANCEL_RESERVATION = 'CANCEL_RESERVATION',
  CANCEL_TOOL_ORDER = 'CANCEL_TOOL_ORDER',
  COMPLETE_RESERVATION = 'COMPLETE_RESERVATION',
  COMPLETE_RETURN = 'COMPLETE_RETURN',
  CREATE_PROJECT_CONFIG = 'CREATE_PROJECT_CONFIG',
  CREATE_ROLE = 'CREATE_ROLE',
  CREATE_TOOL_TRANSFER = 'CREATE_TOOL_TRANSFER',
  DELETE_TOOL_ORDER = 'DELETE_TOOL_ORDER',
  DISPATCH_MODULE = 'DISPATCH_MODULE',
  EDIT_PROJECT_CONFIG = 'EDIT_PROJECT_CONFIG',
  EDIT_RESERVATIONS = 'EDIT_RESERVATIONS',
  EDIT_ROLE = 'EDIT_ROLE',
  EDIT_TOOL_INVENTORY = 'EDIT_TOOL_INVENTORY',
  EDIT_TOOL_ROOM = 'EDIT_TOOL_ROOM',
  EDIT_USER = 'EDIT_USER',
  EXECUTE_IMPORT = 'EXECUTE_IMPORT',
  EXECUTE_RETURN = 'EXECUTE_RETURN',
  FAVORITES_MODULE = 'FAVORITES_MODULE',
  INVENTORY_MODULE = 'INVENTORY_MODULE',
  MAP_MODULE = 'MAP_MODULE',
  PICK_INVENTORY = 'PICK_INVENTORY',
  REMOVE_FAVORITE = 'REMOVE_FAVORITE',
  RESERVATION_DASHBOARD = 'RESERVATION_DASHBOARD',
  RESERVATION_MODULE = 'RESERVATION_MODULE',
  RETURN_MODULE = 'RETURN_MODULE',
  SELECT_TOOL_ROOM = 'SELECT_TOOL_ROOM',
  TOOL_TRANSFER_MODULE = 'TOOL_TRANSFER_MODULE',
  UPDATE_TOOL_TRANSFER = 'UPDATE_TOOL_TRANSFER',
  VIEW_RESERVATIONS = 'VIEW_RESERVATIONS',
  VIEW_USER_ADMIN = 'VIEW_USER_ADMIN'
}

export type BulkMergeResult = {
  __typename?: 'BulkMergeResult';
  insertCount?: Maybe<Scalars['Int']>;
  updateCount?: Maybe<Scalars['Int']>;
};

export type BulkUpdateToolInventoryInput = {
  items: Array<InputMaybe<UpdateToolInventoryInput>>;
};

export type BulkUpdateToolInventoryResult = {
  __typename?: 'BulkUpdateToolInventoryResult';
  error?: Maybe<UpdateToolInventoryError>;
  toolInventoryItems?: Maybe<Array<ToolInventory>>;
};

export enum CancelToolOrderError {
  COMPLETED_ORDER_CAN_NOT_BE_CANCELLED = 'COMPLETED_ORDER_CAN_NOT_BE_CANCELLED',
  INVALID_TOOL_ORDER_ID = 'INVALID_TOOL_ORDER_ID',
  TOOL_ORDER_ALREADY_CANCELLED = 'TOOL_ORDER_ALREADY_CANCELLED',
  TOOL_ORDER_CANCEL_FAILED = 'TOOL_ORDER_CANCEL_FAILED'
}

export type CancelToolOrderInput = {
  cancelOutofStockOrders: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type CancelToolOrderResult = {
  __typename?: 'CancelToolOrderResult';
  errors?: Maybe<Array<Maybe<CancelToolOrderError>>>;
  id?: Maybe<Scalars['ID']>;
};

export type CreateAdhocOrderInput = {
  /** inventory Items */
  inventoryItems: Array<CreateAdhocOrderInventory>;
  /** Order placed for */
  orderPlacedFor: Scalars['String'];
  /** Recipient ID */
  recipientId: Scalars['String'];
  /** toolroom id */
  toolRoomId: Scalars['ID'];
};

export type CreateAdhocOrderInventory = {
  dispatchQuantity: Scalars['Int'];
  toolInventoryId: Scalars['ID'];
};

export type CreateAdhocToolOrderInventoryInput = {
  /** Dispatched quantity */
  dispatchQuantity: Scalars['Int'];
  /** Tool Catalog Id */
  toolCatalogId: Scalars['ID'];
  /** Tool inventory id */
  toolInventoryId: Scalars['ID'];
};

export enum CreateCrewError {
  FAILED_TO_INSERT_CREW = 'FAILED_TO_INSERT_CREW'
}

export type CreateCrewInput = {
  /** Crew number */
  crewNumber: Scalars['String'];
  /** Foreman id */
  foremanId?: InputMaybe<Scalars['ID']>;
  /** General foreman id */
  generalForemanId?: InputMaybe<Scalars['ID']>;
  /** Project id */
  projectId: Scalars['ID'];
  /** Superintendent id */
  superintendentId?: InputMaybe<Scalars['ID']>;
};

export type CreateCrewResult = {
  __typename?: 'CreateCrewResult';
  crew?: Maybe<Crew>;
  error?: Maybe<CreateCrewError>;
};

export enum CreateEmployeePhotosError {
  FAILED_TO_INSERT_EMPLOYEE_PHOTOS = 'FAILED_TO_INSERT_EMPLOYEE_PHOTOS'
}

export type CreateEmployeePhotosInput = {
  /** Id */
  id: Scalars['ID'];
  /** Thumbnail */
  thumbnail: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CreateEmployeePhotosResult = {
  __typename?: 'CreateEmployeePhotosResult';
  employeePhotos?: Maybe<EmployeePhotos>;
  error?: Maybe<CreateEmployeePhotosError>;
};

export type CreateInboundControlsInput = {
  /** Created by */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Created date */
  createdDate?: InputMaybe<Scalars['Datetime']>;
  /** End date */
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Error details */
  errorDetails?: InputMaybe<Scalars['String']>;
  /** Error summray */
  errorSummary?: InputMaybe<Scalars['String']>;
  /** Import summray */
  importSummary?: InputMaybe<Scalars['JSON']>;
  /** Interface id */
  interfaceId: Scalars['ID'];
  /** Project id */
  projectId?: InputMaybe<Scalars['ID']>;
  /** Start date */
  startDate: Scalars['Datetime'];
  /** Status */
  status: Scalars['String'];
  /** UpdatedBy */
  updatedBy?: InputMaybe<Scalars['String']>;
  /** Updated date */
  updatedDate?: InputMaybe<Scalars['Datetime']>;
};

export enum CreateInboundInterfaceError {
  FAILED_TO_INSERT_INBOUND_INTERFACE = 'FAILED_TO_INSERT_INBOUND_INTERFACE'
}

export type CreateInboundInterfaceInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name: Scalars['String'];
  /** Process id */
  processId: Scalars['ID'];
  /** Sort order */
  sortOrder: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CreateInboundInterfaceResult = {
  __typename?: 'CreateInboundInterfaceResult';
  error?: Maybe<CreateInboundInterfaceError>;
  inboundInterface?: Maybe<InboundInterface>;
};

export enum CreateInboundProcessError {
  FAILED_TO_INSERT_INBOUND_PROCESS = 'FAILED_TO_INSERT_INBOUND_PROCESS'
}

export type CreateInboundProcessInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** Name */
  name: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CreateInboundProcessResult = {
  __typename?: 'CreateInboundProcessResult';
  error?: Maybe<CreateInboundProcessError>;
  inboundProcess?: Maybe<InboundProcess>;
};

export enum CreateInboundQueueError {
  FAILED_TO_INSERT_INBOUND_QUEUE = 'FAILED_TO_INSERT_INBOUND_QUEUE'
}

export type CreateInboundQueueInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Parameters */
  parameters: Scalars['String'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Status */
  status: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CreateInboundQueueResult = {
  __typename?: 'CreateInboundQueueResult';
  error?: Maybe<CreateInboundQueueError>;
  inboundQueue?: Maybe<InboundQueue>;
};

export enum CreateOutboundInterfaceError {
  FAILED_TO_INSERT_OUTBOUND_INTERFACE = 'FAILED_TO_INSERT_OUTBOUND_INTERFACE'
}

export type CreateOutboundInterfaceInput = {
  /** CreatedBy */
  createdBy: Scalars['String'];
  /** Created Date */
  createdDate: Scalars['Datetime'];
  /** Error type */
  errorType?: InputMaybe<OutboundErrorType>;
  /** Message */
  message: Scalars['String'];
  /** Next schedule date */
  nextScheduleDate?: InputMaybe<Scalars['Datetime']>;
  /** Outbound action */
  outboundAction: OutboundAction;
  /** Project ID */
  projectId: Scalars['ID'];
  /** referenceId */
  referenceId?: InputMaybe<Scalars['String']>;
  /** Response */
  response?: InputMaybe<Scalars['String']>;
  /** Status */
  status: OutboundStatus;
  /** Updated By */
  updatedBy: Scalars['String'];
  /** Updated Date */
  updatedDate: Scalars['Datetime'];
};

export type CreateOutboundInterfaceResult = {
  __typename?: 'CreateOutboundInterfaceResult';
  error?: Maybe<CreateOutboundInterfaceError>;
  outboundInterface?: Maybe<OutboundInterface>;
};

export enum CreateOutboundRetryError {
  FAILED_TO_INSERT_OUTBOUND_RETRY = 'FAILED_TO_INSERT_OUTBOUND_RETRY'
}

export type CreateOutboundRetryInput = {
  /** Action type */
  actionType: OutboundRetryActionType;
  /** Error type */
  errorType?: InputMaybe<OutboundErrorType>;
  /** Next schedule date */
  nextScheduleDate: Scalars['Datetime'];
  /** Outbound interface id */
  outboundInterfaceId: Scalars['ID'];
  /** Response */
  response?: InputMaybe<Scalars['String']>;
  /** Retry count */
  retryCount: Scalars['Int'];
  /** Status */
  status: OutboundStatus;
};

export type CreateOutboundRetryResult = {
  __typename?: 'CreateOutboundRetryResult';
  error?: Maybe<CreateOutboundRetryError>;
  outboundRetry?: Maybe<OutboundRetry>;
};

export enum CreatePermissionError {
  FAILED_TO_INSERT_PERMISSION = 'FAILED_TO_INSERT_PERMISSION'
}

export type CreatePermissionInput = {
  /** Description */
  description: Scalars['String'];
  /** Name */
  name: Scalars['String'];
};

export type CreatePermissionResult = {
  __typename?: 'CreatePermissionResult';
  error?: Maybe<CreatePermissionError>;
  permission?: Maybe<Permission>;
};

export enum CreateProjectConfigurationError {
  FAILED_TO_INSERT_PROJECT_CONFIGURATION = 'FAILED_TO_INSERT_PROJECT_CONFIGURATION'
}

export type CreateProjectConfigurationInput = {
  /** Configuration name */
  configurationName: Scalars['String'];
  /** Configuration value - TODO: introduce graphql scalar type JSON for this property */
  configurationValue: Scalars['JSON'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CreateProjectConfigurationResult = {
  __typename?: 'CreateProjectConfigurationResult';
  error?: Maybe<CreateProjectConfigurationError>;
  projectConfiguration?: Maybe<ProjectConfiguration>;
};

export enum CreateProjectToolCatalogError {
  FAILED_TO_INSERT_PROJECT_TOOL_CATALOG = 'FAILED_TO_INSERT_PROJECT_TOOL_CATALOG'
}

export type CreateProjectToolCatalogInput = {
  /** Is Locked */
  isLocked?: InputMaybe<Scalars['Boolean']>;
  /** Limit Count */
  limitCount?: InputMaybe<Scalars['Int']>;
  /** Project id */
  projectId?: InputMaybe<Scalars['ID']>;
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
};

export type CreateProjectToolCatalogResult = {
  __typename?: 'CreateProjectToolCatalogResult';
  error?: Maybe<CreateProjectToolCatalogError>;
  projectToolCatalog?: Maybe<ProjectToolCatalog>;
};

export enum CreateRoleError {
  FAILED_TO_INSERT_ROLE = 'FAILED_TO_INSERT_ROLE'
}

export type CreateRoleInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description: Scalars['String'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export enum CreateRolePermissionScopeError {
  FAILED_TO_INSERT_ROLE_PERMISSION_SCOPE = 'FAILED_TO_INSERT_ROLE_PERMISSION_SCOPE'
}

export type CreateRolePermissionScopeInput = {
  /** Permission id */
  permissionId: Scalars['ID'];
  /** Role id */
  roleId: Scalars['ID'];
  /** Scope id */
  scopeId: Scalars['Int'];
};

export type CreateRolePermissionScopeResult = {
  __typename?: 'CreateRolePermissionScopeResult';
  error?: Maybe<CreateRolePermissionScopeError>;
  rolePermissionScope?: Maybe<RolePermissionScope>;
};

export type CreateRoleResult = {
  __typename?: 'CreateRoleResult';
  error?: Maybe<CreateRoleError>;
  role?: Maybe<Role>;
};

export enum CreateScopeError {
  FAILED_TO_INSERT_SCOPE = 'FAILED_TO_INSERT_SCOPE'
}

export type CreateScopeInput = {
  /** Id */
  id: Scalars['Int'];
  /** Name */
  name: Scalars['String'];
};

export type CreateScopeResult = {
  __typename?: 'CreateScopeResult';
  error?: Maybe<CreateScopeError>;
  scope?: Maybe<Scope>;
};

export enum CreateToolCatalogError {
  FAILED_TO_INSERT_TOOL_CATALOG = 'FAILED_TO_INSERT_TOOL_CATALOG'
}

export enum CreateToolCatalogImageError {
  FAILED_TO_INSERT_TOOL_CATALOG_IMAGE = 'FAILED_TO_INSERT_TOOL_CATALOG_IMAGE'
}

export type CreateToolCatalogImageInput = {
  /** Id */
  id: Scalars['ID'];
  /** Thumbnail */
  thumbnail: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CreateToolCatalogImageResult = {
  __typename?: 'CreateToolCatalogImageResult';
  error?: Maybe<CreateToolCatalogImageError>;
  toolCatalogImage?: Maybe<ToolCatalogImage>;
};

export type CreateToolCatalogInput = {
  /** Bscn part number */
  bscnPartNumber: Scalars['String'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Inventory Type */
  inventoryType?: InputMaybe<Scalars['String']>;
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** ToolHound Tool Catalog Id */
  thToolCatalogId?: InputMaybe<Scalars['String']>;
  /** Tool category id */
  toolCategoryId: Scalars['ID'];
  /** Uom */
  uomId?: InputMaybe<Scalars['Int']>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CreateToolCatalogResult = {
  __typename?: 'CreateToolCatalogResult';
  error?: Maybe<CreateToolCatalogError>;
  toolCatalog?: Maybe<ToolCatalog>;
};

export enum CreateToolCategoryError {
  FAILED_TO_INSERT_TOOL_CATEGORY = 'FAILED_TO_INSERT_TOOL_CATEGORY'
}

export type CreateToolCategoryInput = {
  /** Created By */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name: Scalars['String'];
  /** Tool hound id */
  toolHoundId: Scalars['String'];
  /** Tool type id */
  toolTypeId: Scalars['ID'];
};

export type CreateToolCategoryResult = {
  __typename?: 'CreateToolCategoryResult';
  error?: Maybe<CreateToolCategoryError>;
  toolCategory?: Maybe<ToolCategory>;
};

export enum CreateToolCheckInError {
  CHECKIN_BY_NOT_MATCHED_BUT_ITEM_BELONGS_TO_CURRENT_TOOL_ROOM = 'CHECKIN_BY_NOT_MATCHED_BUT_ITEM_BELONGS_TO_CURRENT_TOOL_ROOM',
  FAILED_TO_INSERT_TOOL_CHECK_IN = 'FAILED_TO_INSERT_TOOL_CHECK_IN',
  INVALID_BUN_OR_LOB_ID = 'INVALID_BUN_OR_LOB_ID',
  ITEM_NOT_FOUND = 'ITEM_NOT_FOUND',
  RECIPIENT_WITH_TOOL_HOUND_ID_REQUIRED = 'RECIPIENT_WITH_TOOL_HOUND_ID_REQUIRED',
  REPAIR_TOOL_ROOM_NOT_CONFIGURED = 'REPAIR_TOOL_ROOM_NOT_CONFIGURED',
  TOOL_ROOM_NOT_EXIST_IN_THE_CURRENT_PROJECT = 'TOOL_ROOM_NOT_EXIST_IN_THE_CURRENT_PROJECT',
  TOOL_ROOM_NOT_FOUND = 'TOOL_ROOM_NOT_FOUND'
}

export type CreateToolCheckInInput = {
  /** Check in number */
  checkInNumber: Scalars['String'];
  /** Parent Checkin Id */
  parentCheckInId?: InputMaybe<Scalars['ID']>;
  /** recipient id */
  recipientId: Scalars['String'];
  /** Th transaction id */
  thTransactionId?: InputMaybe<Scalars['String']>;
  /** Tool room id */
  toolRoomId: Scalars['ID'];
};

export enum CreateToolCheckInItemsError {
  FAILED_TO_INSERT_TOOL_CHECK_IN_ITEMS = 'FAILED_TO_INSERT_TOOL_CHECK_IN_ITEMS'
}

export type CreateToolCheckInItemsInput = {
  /** Check in quantity */
  quantity: Scalars['Int'];
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** Tool checkin id */
  toolCheckInId: Scalars['ID'];
  /** Tool inventory id */
  toolInventoryId?: InputMaybe<Scalars['ID']>;
};

export type CreateToolCheckInItemsResult = {
  __typename?: 'CreateToolCheckInItemsResult';
  error?: Maybe<CreateToolCheckInItemsError>;
  toolCheckInItems?: Maybe<ToolCheckInItems>;
};

export type CreateToolCheckInResult = {
  __typename?: 'CreateToolCheckInResult';
  error?: Maybe<CreateToolCheckInError>;
  toolCheckIn?: Maybe<ToolCheckIn>;
};

export enum CreateToolCheckInWarning {
  ALREADY_CHECKED_IN = 'ALREADY_CHECKED_IN',
  CHECKIN_BY_NOT_MATCHED_BUT_ITEM_BELONGS_TO_CURRENT_TOOL_ROOM = 'CHECKIN_BY_NOT_MATCHED_BUT_ITEM_BELONGS_TO_CURRENT_TOOL_ROOM',
  CHECK_IN_BY_USER_IS_DIFFERENT = 'CHECK_IN_BY_USER_IS_DIFFERENT',
  ITEM_BELONG_TO_DIFFERENT_TOOL_ROOM = 'ITEM_BELONG_TO_DIFFERENT_TOOL_ROOM',
  ITEM_NOT_EXIST_IN_CHECKIN = 'ITEM_NOT_EXIST_IN_CHECKIN',
  ITEM_NOT_FOUND = 'ITEM_NOT_FOUND',
  OLD_RECORD_NOT_EXIST = 'OLD_RECORD_NOT_EXIST'
}

export enum CreateToolInventoryError {
  FAILED_TO_INSERT_TOOL_INVENTORY = 'FAILED_TO_INSERT_TOOL_INVENTORY'
}

export type CreateToolInventoryInput = {
  /** Bar code */
  barCode?: InputMaybe<Scalars['String']>;
  /** Bar code id */
  barCodeId?: InputMaybe<Scalars['String']>;
  /** Count Required */
  countRequired: Scalars['Boolean'];
  /** Deleted date */
  deletedDate?: InputMaybe<Scalars['Datetime']>;
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** In transit count */
  inTransitCount?: InputMaybe<Scalars['Int']>;
  /** Is Locked */
  isLocked: Scalars['Boolean'];
  /** Is Serialized */
  isSerialized: Scalars['Boolean'];
  /** Issued count */
  issuedCount?: InputMaybe<Scalars['Int']>;
  /** Limit Count */
  limitCount?: InputMaybe<Scalars['Int']>;
  /** On hand count */
  onHandCount?: InputMaybe<Scalars['Int']>;
  /** On order count */
  onOrderCount?: InputMaybe<Scalars['Int']>;
  /** Status code */
  statusCode?: InputMaybe<Scalars['Int']>;
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** Tool room id */
  toolRoomId: Scalars['ID'];
  /** Total count */
  totalCount?: InputMaybe<Scalars['Int']>;
  /** Vendor */
  vendor?: InputMaybe<Scalars['String']>;
};

export enum CreateToolInventoryPhysicalCountError {
  FAILED_TO_INSERT_TOOL_INVENTORY_PHYSICAL_COUNT = 'FAILED_TO_INSERT_TOOL_INVENTORY_PHYSICAL_COUNT'
}

export type CreateToolInventoryPhysicalCountInput = {
  /** Adjusted count */
  adjustedCount: Scalars['Int'];
  /** Last status by */
  lastStatusBy?: InputMaybe<Scalars['String']>;
  /** Last status date */
  lastStatusDate?: InputMaybe<Scalars['Datetime']>;
  /** Original count */
  originalCount: Scalars['Int'];
  /** Physical count */
  physicalCount: Scalars['Int'];
  /** Status */
  status?: InputMaybe<Scalars['String']>;
  /** Tool inventory id */
  toolInventoryId: Scalars['ID'];
  /** Tool room id */
  toolRoomId: Scalars['ID'];
  /** Total count */
  totalCount: Scalars['Int'];
};

export type CreateToolInventoryPhysicalCountResult = {
  __typename?: 'CreateToolInventoryPhysicalCountResult';
  error?: Maybe<CreateToolInventoryPhysicalCountError>;
  toolInventoryPhysicalCount?: Maybe<ToolInventoryPhysicalCount>;
};

export type CreateToolInventoryResult = {
  __typename?: 'CreateToolInventoryResult';
  error?: Maybe<CreateToolInventoryError>;
  toolInventory?: Maybe<ToolInventory>;
};

export enum CreateToolInventoryStatusError {
  FAILED_TO_INSERT_TOOL_INVENTORY_STATUS = 'FAILED_TO_INSERT_TOOL_INVENTORY_STATUS'
}

export type CreateToolInventoryStatusInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['Int'];
  /** Updated by */
  updatedBy: Scalars['String'];
};

export type CreateToolInventoryStatusResult = {
  __typename?: 'CreateToolInventoryStatusResult';
  error?: Maybe<CreateToolInventoryStatusError>;
  toolInventoryStatus?: Maybe<ToolInventoryStatus>;
};

export enum CreateToolOrderCatalogError {
  FAILED_TO_INSERT_TOOL_ORDER_CATALOG = 'FAILED_TO_INSERT_TOOL_ORDER_CATALOG'
}

export type CreateToolOrderCatalogInput = {
  /** Dispatcher comments */
  dispatcherComments?: InputMaybe<Scalars['String']>;
  /** Dispatcher comments by */
  dispatcherCommentsBy?: InputMaybe<Scalars['String']>;
  /** Non Catalog Description */
  nonCatalogDescription?: InputMaybe<Scalars['String']>;
  /** Non Catalog Reference Url */
  nonCatalogReferenceUrl?: InputMaybe<Scalars['String']>;
  /** Non Catalog Similar To Id */
  nonCatalogSimilarToId?: InputMaybe<Scalars['String']>;
  /** non Catalog Uom Id */
  nonCatalogUomId?: InputMaybe<Scalars['Int']>;
  /** Quantity */
  quantity: Scalars['Int'];
  /** Requester comments */
  requesterComments?: InputMaybe<Scalars['String']>;
  /** Requester comments by */
  requesterCommentsBy?: InputMaybe<Scalars['String']>;
  /** Tool catalog id */
  toolCatalogId?: InputMaybe<Scalars['ID']>;
};

export type CreateToolOrderCatalogResult = {
  __typename?: 'CreateToolOrderCatalogResult';
  error?: Maybe<CreateToolOrderCatalogError>;
  toolOrderCatalog?: Maybe<ToolOrderCatalog>;
};

export enum CreateToolOrderError {
  CATALOG_QUANTITY_CAN_NOT_BE_ZERO = 'CATALOG_QUANTITY_CAN_NOT_BE_ZERO',
  DRAFT_ALREADY_EXIST = 'DRAFT_ALREADY_EXIST',
  FAILED_TO_INSERT_TOOL_ORDER = 'FAILED_TO_INSERT_TOOL_ORDER',
  FAILED_TO_UPDATE_TOOL_ORDER = 'FAILED_TO_UPDATE_TOOL_ORDER',
  INVALID_REQUIRED_START_DATE = 'INVALID_REQUIRED_START_DATE',
  INVALID_TOOL_ROOM_ID = 'INVALID_TOOL_ROOM_ID',
  ORDER_DATE_REQUIRED_AFTER_DRAFT = 'ORDER_DATE_REQUIRED_AFTER_DRAFT',
  ORDER_LIMIT_EXEEDS = 'ORDER_LIMIT_EXEEDS',
  ORDER_NO_ALREADY_EXIST = 'ORDER_NO_ALREADY_EXIST',
  REQUESTER_DOESNT_HAVE_TOOL_HOUND_ID = 'REQUESTER_DOESNT_HAVE_TOOL_HOUND_ID'
}

export enum CreateToolOrderHistoryError {
  FAILED_TO_INSERT_TOOL_ORDER_HISTORY = 'FAILED_TO_INSERT_TOOL_ORDER_HISTORY'
}

export type CreateToolOrderHistoryInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Status */
  status: Scalars['String'];
  /** Tool order id */
  toolOrderId: Scalars['ID'];
};

export type CreateToolOrderHistoryResult = {
  __typename?: 'CreateToolOrderHistoryResult';
  error?: Maybe<CreateToolOrderHistoryError>;
  toolOrderHistory?: Maybe<ToolOrderHistory>;
};

export type CreateToolOrderInput = {
  /** Checked out by */
  checkedOutBy?: InputMaybe<Scalars['String']>;
  /** Checked out date */
  checkedOutDate?: InputMaybe<Scalars['Datetime']>;
  /** Dispatched by */
  dispatchedBy?: InputMaybe<Scalars['String']>;
  /** Order date */
  orderDate?: InputMaybe<Scalars['Datetime']>;
  /** Order placed for */
  orderPlacedFor: Scalars['String'];
  /** Parent tool order id */
  parentToolOrderId?: InputMaybe<Scalars['String']>;
  /** Prepped by */
  preppedBy?: InputMaybe<Scalars['String']>;
  /** Prepped date */
  preppedDate?: InputMaybe<Scalars['String']>;
  /** Project Id */
  projectId?: InputMaybe<Scalars['String']>;
  /** Recipient Id */
  recipientId: Scalars['String'];
  /** Required start date */
  requiredStartDate: Scalars['Datetime'];
  /** Status id */
  status: ToolOrderStatus;
  /** Tool Catalog references for creating the order */
  toolOrderCatalog: Array<CreateToolOrderCatalogInput>;
  /** toolOrder */
  toolOrderInventory?: InputMaybe<Array<InputMaybe<CreateAdhocToolOrderInventoryInput>>>;
  /** Tool room id */
  toolRoomId: Scalars['ID'];
};

export enum CreateToolOrderInventoryError {
  FAILED_TO_INSERT_TOOL_ORDER_INVENTORY = 'FAILED_TO_INSERT_TOOL_ORDER_INVENTORY'
}

export type CreateToolOrderInventoryInput = {
  /** Dispatched quantity */
  dispatchQuantity: Scalars['Int'];
  /** Dispatcher comments */
  dispatcherComments?: InputMaybe<Scalars['String']>;
  /** Dispatcher comments by */
  dispatcherCommentsBy?: InputMaybe<Scalars['String']>;
  /** Tool inventory status */
  status: ToolOrderInventoryStatus;
  /** Tool inventory id */
  toolInventoryId?: InputMaybe<Scalars['ID']>;
  /** Tool order catalog id */
  toolOrderCatalogId: Scalars['ID'];
};

export type CreateToolOrderInventoryResult = {
  __typename?: 'CreateToolOrderInventoryResult';
  error?: Maybe<CreateToolOrderInventoryError>;
  toolOrderInventory?: Maybe<ToolOrderInventory>;
};

export type CreateToolOrderResult = {
  __typename?: 'CreateToolOrderResult';
  error?: Maybe<CreateToolOrderError>;
  toolOrder?: Maybe<ToolOrder>;
};

export enum CreateToolRoomError {
  FAILED_TO_INSERT_TOOL_ROOM = 'FAILED_TO_INSERT_TOOL_ROOM'
}

export type CreateToolRoomInput = {
  /** Bar code id of Tool Room */
  barCode: Scalars['String'];
  /** Created By */
  createdBy: Scalars['String'];
  /** Description that states details about the Tool Room */
  description: Scalars['String'];
  /** Is this tool room active? */
  isActive: Scalars['Boolean'];
  /** Latitude */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude */
  longitude?: InputMaybe<Scalars['Float']>;
  /** Name of the Tool Room, usually to uniquely identify it on project */
  name: Scalars['String'];
  /** Project Id */
  projectId: Scalars['ID'];
  /** Tool hound location id of Tool Room */
  thLocationId: Scalars['String'];
};

export enum CreateToolTransferError {
  FAILED_TO_INSERT_TOOL_TRANSFER = 'FAILED_TO_INSERT_TOOL_TRANSFER',
  INVALID_DESTINATION_TOOL_ROOM = 'INVALID_DESTINATION_TOOL_ROOM',
  INVALID_REQUESTED_ITEMS = 'INVALID_REQUESTED_ITEMS',
  INVALID_SOURCE_TOOL_ROOM = 'INVALID_SOURCE_TOOL_ROOM',
  ON_HAND_COUNT_NOT_AVAILABLE = 'ON_HAND_COUNT_NOT_AVAILABLE'
}

export enum CreateToolTransferHistoryError {
  FAILED_TO_INSERT_TOOL_TRANSFER_HISTORY = 'FAILED_TO_INSERT_TOOL_TRANSFER_HISTORY'
}

export type CreateToolTransferHistoryInput = {
  /** Status */
  status: Scalars['String'];
  /** Tool transfer id */
  toolTransferId: Scalars['ID'];
  /** Tool transfer stats */
  toolTransferStats: Scalars['String'];
};

export type CreateToolTransferHistoryResult = {
  __typename?: 'CreateToolTransferHistoryResult';
  error?: Maybe<CreateToolTransferHistoryError>;
  toolTransferHistory?: Maybe<ToolTransferHistory>;
};

export type CreateToolTransferInput = {
  /** Comment */
  comment?: InputMaybe<Scalars['String']>;
  /** Destination tool room id */
  destinationToolRoomId: Scalars['ID'];
  /** Requested Items */
  requestedItems: Array<CreateToolTransferItemInput>;
  /** Source tool room id */
  sourceToolRoomId: Scalars['ID'];
};

export enum CreateToolTransferItemError {
  FAILED_TO_INSERT_TOOL_TRANSFER_ITEM = 'FAILED_TO_INSERT_TOOL_TRANSFER_ITEM'
}

export type CreateToolTransferItemInput = {
  /** Requested quantity */
  requestedQuantity: Scalars['Int'];
  /** Tool inventory id */
  toolInventoryId: Scalars['ID'];
};

export type CreateToolTransferItemResult = {
  __typename?: 'CreateToolTransferItemResult';
  error?: Maybe<CreateToolTransferItemError>;
  toolTransferItem?: Maybe<ToolTransferItem>;
};

export type CreateToolTransferResult = {
  __typename?: 'CreateToolTransferResult';
  error?: Maybe<CreateToolTransferError>;
  toolTransfer?: Maybe<ToolTransfer>;
};

export enum CreateToolTypeError {
  FAILED_TO_INSERT_TOOL_TYPE = 'FAILED_TO_INSERT_TOOL_TYPE'
}

export type CreateToolTypeInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Name */
  name: Scalars['String'];
  /** Tool hound id */
  toolHoundId: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CreateToolTypeResult = {
  __typename?: 'CreateToolTypeResult';
  error?: Maybe<CreateToolTypeError>;
  toolType?: Maybe<ToolType>;
};

export enum CreateToolUserFavoriteError {
  CATALOG_IS_ALREADY_EXIST_IN_FAVORITE = 'CATALOG_IS_ALREADY_EXIST_IN_FAVORITE',
  FAILED_TO_INSERT_TOOL_USER_FAVORITE = 'FAILED_TO_INSERT_TOOL_USER_FAVORITE',
  INVALID_CATALOG_ITEM = 'INVALID_CATALOG_ITEM'
}

export type CreateToolUserFavoriteInput = {
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** User id */
  userId: Scalars['ID'];
};

export type CreateToolUserFavoriteResult = {
  __typename?: 'CreateToolUserFavoriteResult';
  error?: Maybe<CreateToolUserFavoriteError>;
  toolUserFavorite?: Maybe<ToolUserFavorite>;
};

export enum CreateUomError {
  FAILED_TO_INSERT_UOM = 'FAILED_TO_INSERT_UOM',
  UOM_ID_ALREADY_EXIST = 'UOM_ID_ALREADY_EXIST'
}

export type CreateUomInput = {
  /** Abbreviation */
  abbreviation: Scalars['String'];
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['Int'];
};

export type CreateUomResult = {
  __typename?: 'CreateUomResult';
  error?: Maybe<CreateUomError>;
  uom?: Maybe<Uom>;
};

export type CreateUserAccountInput = {
  /** Login name */
  bun: Scalars['String'];
  /** Exempted from import */
  exemptedFromImport?: InputMaybe<Scalars['Boolean']>;
  /** User active status */
  isActive: Scalars['Boolean'];
  /** lobEmployeeId */
  lobEmployeeId: Scalars['String'];
  /** First name of the User */
  nameFirst: Scalars['String'];
  /** Last name of the User */
  nameLast: Scalars['String'];
  /** Middle name of the User */
  nameMiddle?: InputMaybe<Scalars['String']>;
  /** Persona */
  persona: Scalars['String'];
  /** Role Ids */
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Supervisor Id */
  supervisorId?: InputMaybe<Scalars['String']>;
  /** Tool Room Ids */
  toolRoomIds?: InputMaybe<Array<Scalars['ID']>>;
  /** UPN */
  upn: Scalars['String'];
};

export type CreateUserAccountResult = {
  __typename?: 'CreateUserAccountResult';
  /** Error */
  error?: Maybe<CreateUserError>;
  /** User reated during the mutation */
  userAccount?: Maybe<User>;
};

export enum CreateUserError {
  DUPLICATE = 'DUPLICATE',
  INVALID_PROJECT_ERROR = 'INVALID_PROJECT_ERROR',
  NO_CORRESPONDING_TH6_ROLE = 'NO_CORRESPONDING_TH6_ROLE',
  SEARCH_USER_API_FAIL = 'SEARCH_USER_API_FAIL'
}

export type CreateUserInput = {
  /** Login name */
  bun: Scalars['String'];
  /** User email */
  email?: InputMaybe<Scalars['String']>;
  /** First name of the User */
  firstName: Scalars['String'];
  /** User active status */
  isActive: Scalars['Boolean'];
  /** Last name of the User */
  lastName: Scalars['String'];
  /** lobEmployeeId */
  lobEmployeeId: Scalars['String'];
  /** Middle name of the User */
  middleName?: InputMaybe<Scalars['String']>;
  /** Persona */
  persona: Scalars['String'];
  /** Role Ids */
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Supervisor Id */
  supervisorId?: InputMaybe<Scalars['String']>;
  /** Tool Room Ids */
  toolRoomIds?: InputMaybe<Array<Scalars['ID']>>;
  /** UPN */
  upn: Scalars['String'];
};

export type CreateUserInputWithProjectIds = {
  /** Login name */
  bun: Scalars['String'];
  /** User email */
  email?: InputMaybe<Scalars['String']>;
  /** Exempted from import */
  exemptedFromImport?: InputMaybe<Scalars['Boolean']>;
  /** First name of the User */
  firstName: Scalars['String'];
  /** User active status */
  isActive: Scalars['Boolean'];
  /** Last name of the User */
  lastName: Scalars['String'];
  /** lobEmployeeId */
  lobEmployeeId: Scalars['String'];
  /** Middle name of the User */
  middleName?: InputMaybe<Scalars['String']>;
  /** Persona */
  persona: Scalars['String'];
  /** List of project Ids to be associated with the user being created */
  projectIds: Array<Scalars['ID']>;
  /** Role Ids */
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Supervisor Id */
  supervisorId?: InputMaybe<Scalars['String']>;
  /** Tool Room Ids */
  toolRoomIds?: InputMaybe<Array<Scalars['ID']>>;
  /** UPN */
  upn: Scalars['String'];
};

export enum CreateUserProjectError {
  FAILED_TO_INSERT_USER_PROJECT = 'FAILED_TO_INSERT_USER_PROJECT'
}

export type CreateUserProjectInput = {
  /** Badge barcode id */
  badgeBarcodeId?: InputMaybe<Scalars['String']>;
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Crew number */
  crewNumber?: InputMaybe<Scalars['String']>;
  /** Email */
  email?: InputMaybe<Scalars['String']>;
  /** First name */
  firstName: Scalars['String'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Last name */
  lastName: Scalars['String'];
  /** Lob employee id */
  lobEmployeeId: Scalars['String'];
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']>;
  /** Persona */
  persona?: InputMaybe<Scalars['String']>;
  /** Project id */
  projectId: Scalars['ID'];
  /** Supervisor id */
  supervisorId?: InputMaybe<Scalars['String']>;
  /** Tool hound user id */
  thUserId?: InputMaybe<Scalars['String']>;
  /** Tool hound user login */
  thUserLogin?: InputMaybe<Scalars['String']>;
  /** Tool hound id */
  toolHoundId?: InputMaybe<Scalars['String']>;
  /** Updated date */
  updatedDate: Scalars['Datetime'];
  /** User id */
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateUserProjectResult = {
  __typename?: 'CreateUserProjectResult';
  error?: Maybe<CreateUserProjectError>;
  userProject?: Maybe<UserProject>;
};

export type CreateUserResult = {
  __typename?: 'CreateUserResult';
  /** Error */
  error?: Maybe<CreateUserError>;
  /** User reated during the mutation */
  userAccount?: Maybe<User>;
};

export enum CreateUserRoleError {
  FAILED_TO_INSERT_USER_ROLE = 'FAILED_TO_INSERT_USER_ROLE'
}

export type CreateUserRoleInput = {
  /** Project id */
  projectId: Scalars['ID'];
  /** Role id */
  roleId: Scalars['ID'];
  /** User id */
  userId: Scalars['ID'];
};

export type CreateUserRoleResult = {
  __typename?: 'CreateUserRoleResult';
  error?: Maybe<CreateUserRoleError>;
  userRole?: Maybe<UserRole>;
};

export enum CreateUserToolRoomError {
  FAILED_TO_INSERT_USER_TOOL_ROOM = 'FAILED_TO_INSERT_USER_TOOL_ROOM'
}

export type CreateUserToolRoomInput = {
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Tool room id */
  toolRoomId: Scalars['ID'];
  /** User id */
  userId: Scalars['ID'];
};

export type CreateUserToolRoomResult = {
  __typename?: 'CreateUserToolRoomResult';
  error?: Maybe<CreateUserToolRoomError>;
  userToolRoom?: Maybe<UserToolRoom>;
};

export type Crew = {
  __typename?: 'Crew';
  /** Crew count */
  crewCount?: Maybe<Scalars['Int']>;
  /** Crew number */
  crewNumber: Scalars['String'];
  /** Foreman id */
  foremanId?: Maybe<Scalars['ID']>;
  /** General foreman id */
  generalForemanId?: Maybe<Scalars['ID']>;
  /** Id */
  id: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Superintendent id */
  superintendentId?: Maybe<Scalars['ID']>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type CursorPaginationInput = {
  /** Cursor to fetch next rows: we are passing id in cursor */
  cursor?: InputMaybe<Scalars['String']>;
  /** Number of rows to be fetched */
  pageSize?: InputMaybe<Scalars['Int']>;
};

export enum DaysOfWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export enum DeleteCrewError {
  CREW_DELETE_FAILED = 'CREW_DELETE_FAILED',
  INVALID_CREW_ID = 'INVALID_CREW_ID'
}

export type DeleteCrewInput = {
  id: Scalars['ID'];
};

export type DeleteCrewResult = {
  __typename?: 'DeleteCrewResult';
  errors?: Maybe<Array<Maybe<DeleteCrewError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteEmployeePhotosError {
  EMPLOYEE_PHOTOS_DELETE_FAILED = 'EMPLOYEE_PHOTOS_DELETE_FAILED',
  INVALID_EMPLOYEE_PHOTOS_ID = 'INVALID_EMPLOYEE_PHOTOS_ID'
}

export type DeleteEmployeePhotosInput = {
  id: Scalars['ID'];
};

export type DeleteEmployeePhotosResult = {
  __typename?: 'DeleteEmployeePhotosResult';
  errors?: Maybe<Array<Maybe<DeleteEmployeePhotosError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteOutboundInterfaceError {
  INVALID_OUTBOUND_INTERFACE_ID = 'INVALID_OUTBOUND_INTERFACE_ID',
  OUTBOUND_INTERFACE_DELETE_FAILED = 'OUTBOUND_INTERFACE_DELETE_FAILED'
}

export type DeleteOutboundInterfaceInput = {
  id: Scalars['ID'];
};

export type DeleteOutboundInterfaceResult = {
  __typename?: 'DeleteOutboundInterfaceResult';
  errors?: Maybe<Array<Maybe<DeleteOutboundInterfaceError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteOutboundRetryError {
  INVALID_OUTBOUND_RETRY_ID = 'INVALID_OUTBOUND_RETRY_ID',
  OUTBOUND_RETRY_DELETE_FAILED = 'OUTBOUND_RETRY_DELETE_FAILED'
}

export type DeleteOutboundRetryInput = {
  id: Scalars['ID'];
};

export type DeleteOutboundRetryResult = {
  __typename?: 'DeleteOutboundRetryResult';
  errors?: Maybe<Array<Maybe<DeleteOutboundRetryError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeletePermissionError {
  INVALID_PERMISSION_ID = 'INVALID_PERMISSION_ID',
  PERMISSION_DELETE_FAILED = 'PERMISSION_DELETE_FAILED'
}

export type DeletePermissionInput = {
  id: Scalars['ID'];
};

export type DeletePermissionResult = {
  __typename?: 'DeletePermissionResult';
  errors?: Maybe<Array<Maybe<DeletePermissionError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteProjectConfigurationError {
  INVALID_PROJECT_CONFIGURATION_ID = 'INVALID_PROJECT_CONFIGURATION_ID',
  PROJECT_CONFIGURATION_DELETE_FAILED = 'PROJECT_CONFIGURATION_DELETE_FAILED'
}

export type DeleteProjectConfigurationInput = {
  id: Scalars['ID'];
};

export type DeleteProjectConfigurationResult = {
  __typename?: 'DeleteProjectConfigurationResult';
  errors?: Maybe<Array<Maybe<DeleteProjectConfigurationError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteProjectToolCatalogError {
  INVALID_PROJECT_TOOL_CATALOG_ID = 'INVALID_PROJECT_TOOL_CATALOG_ID',
  PROJECT_TOOL_CATALOG_DELETE_FAILED = 'PROJECT_TOOL_CATALOG_DELETE_FAILED'
}

export type DeleteProjectToolCatalogInput = {
  id: Scalars['ID'];
};

export type DeleteProjectToolCatalogResult = {
  __typename?: 'DeleteProjectToolCatalogResult';
  errors?: Maybe<Array<Maybe<DeleteProjectToolCatalogError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteRoleError {
  INVALID_ROLE_ID = 'INVALID_ROLE_ID',
  ROLE_DELETE_FAILED = 'ROLE_DELETE_FAILED'
}

export type DeleteRoleInput = {
  id: Scalars['ID'];
};

export enum DeleteRolePermissionScopeError {
  INVALID_ROLE_PERMISSION_SCOPE_ID = 'INVALID_ROLE_PERMISSION_SCOPE_ID',
  ROLE_PERMISSION_SCOPE_ADD_DELETE_FAILED = 'ROLE_PERMISSION_SCOPE_ADD_DELETE_FAILED',
  ROLE_PERMISSION_SCOPE_DELETE_FAILED = 'ROLE_PERMISSION_SCOPE_DELETE_FAILED',
  ROLE_PERMISSION_SCOPE_INVALID_INPUT = 'ROLE_PERMISSION_SCOPE_INVALID_INPUT'
}

export type DeleteRolePermissionScopeInput = {
  id: Scalars['ID'];
};

export type DeleteRolePermissionScopeResult = {
  __typename?: 'DeleteRolePermissionScopeResult';
  error?: Maybe<DeleteRolePermissionScopeError>;
  id?: Maybe<Scalars['ID']>;
};

export type DeleteRoleResult = {
  __typename?: 'DeleteRoleResult';
  errors?: Maybe<Array<Maybe<DeleteRoleError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteScopeError {
  INVALID_SCOPE_ID = 'INVALID_SCOPE_ID',
  SCOPE_DELETE_FAILED = 'SCOPE_DELETE_FAILED'
}

export type DeleteScopeInput = {
  id: Scalars['Int'];
};

export type DeleteScopeResult = {
  __typename?: 'DeleteScopeResult';
  errors?: Maybe<Array<Maybe<DeleteScopeError>>>;
  id?: Maybe<Scalars['Int']>;
};

export enum DeleteToolCatalogImageError {
  INVALID_TOOL_CATALOG_IMAGE_ID = 'INVALID_TOOL_CATALOG_IMAGE_ID',
  TOOL_CATALOG_IMAGE_DELETE_FAILED = 'TOOL_CATALOG_IMAGE_DELETE_FAILED'
}

export type DeleteToolCatalogImageInput = {
  id: Scalars['ID'];
};

export type DeleteToolCatalogImageResult = {
  __typename?: 'DeleteToolCatalogImageResult';
  errors?: Maybe<Array<Maybe<DeleteToolCatalogImageError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteToolCheckInError {
  INVALID_TOOL_CHECK_IN_ID = 'INVALID_TOOL_CHECK_IN_ID',
  TOOL_CHECK_IN_DELETE_FAILED = 'TOOL_CHECK_IN_DELETE_FAILED'
}

export type DeleteToolCheckInInput = {
  id: Scalars['ID'];
};

export enum DeleteToolCheckInItemsError {
  INVALID_TOOL_CHECK_IN_ITEMS_ID = 'INVALID_TOOL_CHECK_IN_ITEMS_ID',
  TOOL_CHECK_IN_ITEMS_DELETE_FAILED = 'TOOL_CHECK_IN_ITEMS_DELETE_FAILED'
}

export type DeleteToolCheckInItemsInput = {
  id: Scalars['ID'];
};

export type DeleteToolCheckInItemsResult = {
  __typename?: 'DeleteToolCheckInItemsResult';
  errors?: Maybe<Array<Maybe<DeleteToolCheckInItemsError>>>;
  id?: Maybe<Scalars['ID']>;
};

export type DeleteToolCheckInResult = {
  __typename?: 'DeleteToolCheckInResult';
  errors?: Maybe<Array<Maybe<DeleteToolCheckInError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteToolInventoryError {
  INVALID_TOOL_INVENTORY_ID = 'INVALID_TOOL_INVENTORY_ID',
  TOOL_INVENTORY_DELETE_FAILED = 'TOOL_INVENTORY_DELETE_FAILED'
}

export type DeleteToolInventoryInput = {
  id: Scalars['ID'];
};

export enum DeleteToolInventoryPhysicalCountError {
  INVALID_TOOL_INVENTORY_PHYSICAL_COUNT_ID = 'INVALID_TOOL_INVENTORY_PHYSICAL_COUNT_ID',
  TOOL_INVENTORY_PHYSICAL_COUNT_DELETE_FAILED = 'TOOL_INVENTORY_PHYSICAL_COUNT_DELETE_FAILED'
}

export type DeleteToolInventoryPhysicalCountInput = {
  id: Scalars['ID'];
};

export type DeleteToolInventoryPhysicalCountResult = {
  __typename?: 'DeleteToolInventoryPhysicalCountResult';
  errors?: Maybe<Array<Maybe<DeleteToolInventoryPhysicalCountError>>>;
  id?: Maybe<Scalars['ID']>;
};

export type DeleteToolInventoryResult = {
  __typename?: 'DeleteToolInventoryResult';
  errors?: Maybe<Array<Maybe<DeleteToolInventoryError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteToolInventoryStatusError {
  INVALID_TOOL_INVENTORY_STATUS_ID = 'INVALID_TOOL_INVENTORY_STATUS_ID',
  TOOL_INVENTORY_STATUS_DELETE_FAILED = 'TOOL_INVENTORY_STATUS_DELETE_FAILED'
}

export type DeleteToolInventoryStatusInput = {
  id: Scalars['Int'];
};

export type DeleteToolInventoryStatusResult = {
  __typename?: 'DeleteToolInventoryStatusResult';
  errors?: Maybe<Array<Maybe<DeleteToolInventoryStatusError>>>;
  id?: Maybe<Scalars['Int']>;
};

export enum DeleteToolOrderCatalogError {
  INVALID_TOOL_ORDER_CATALOG_ID = 'INVALID_TOOL_ORDER_CATALOG_ID',
  TOOL_ORDER_CATALOG_DELETE_FAILED = 'TOOL_ORDER_CATALOG_DELETE_FAILED'
}

export type DeleteToolOrderCatalogInput = {
  id?: InputMaybe<Scalars['ID']>;
  toolOrderId?: InputMaybe<Scalars['ID']>;
};

export type DeleteToolOrderCatalogResult = {
  __typename?: 'DeleteToolOrderCatalogResult';
  errors?: Maybe<Array<Maybe<DeleteToolOrderCatalogError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteToolOrderError {
  INVALID_TOOL_ORDER_ID = 'INVALID_TOOL_ORDER_ID',
  ONLY_DRAFT_AND_PLACED_ORDER_CAN_BE_DELETED = 'ONLY_DRAFT_AND_PLACED_ORDER_CAN_BE_DELETED',
  TOOL_ORDER_CATALOG_NOT_FOUND = 'TOOL_ORDER_CATALOG_NOT_FOUND',
  TOOL_ORDER_DELETE_FAILED = 'TOOL_ORDER_DELETE_FAILED'
}

export enum DeleteToolOrderHistoryError {
  INVALID_TOOL_ORDER_HISTORY_ID = 'INVALID_TOOL_ORDER_HISTORY_ID',
  TOOL_ORDER_HISTORY_DELETE_FAILED = 'TOOL_ORDER_HISTORY_DELETE_FAILED'
}

export type DeleteToolOrderHistoryInput = {
  id?: InputMaybe<Scalars['ID']>;
  toolOrderId?: InputMaybe<Scalars['ID']>;
};

export type DeleteToolOrderHistoryResult = {
  __typename?: 'DeleteToolOrderHistoryResult';
  errors?: Maybe<Array<Maybe<DeleteToolOrderHistoryError>>>;
  id?: Maybe<Scalars['ID']>;
};

export type DeleteToolOrderInput = {
  id: Scalars['ID'];
};

export enum DeleteToolOrderInventoryError {
  INVALID_TOOL_ORDER_INVENTORY_ID = 'INVALID_TOOL_ORDER_INVENTORY_ID',
  TOOL_ORDER_INVENTORY_DELETE_FAILED = 'TOOL_ORDER_INVENTORY_DELETE_FAILED'
}

export type DeleteToolOrderInventoryInput = {
  id: Scalars['ID'];
};

export type DeleteToolOrderInventoryResult = {
  __typename?: 'DeleteToolOrderInventoryResult';
  errors?: Maybe<Array<Maybe<DeleteToolOrderInventoryError>>>;
  id?: Maybe<Scalars['ID']>;
  toolOrder: ToolOrder;
};

export type DeleteToolOrderResult = {
  __typename?: 'DeleteToolOrderResult';
  errors?: Maybe<Array<Maybe<DeleteToolOrderError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteToolTransferError {
  INVALID_TOOL_TRANSFER_ID = 'INVALID_TOOL_TRANSFER_ID',
  TOOL_TRANSFER_DELETE_FAILED = 'TOOL_TRANSFER_DELETE_FAILED'
}

export type DeleteToolTransferInput = {
  id: Scalars['ID'];
};

export enum DeleteToolTransferItemError {
  INVALID_TOOL_TRANSFER_ITEM_ID = 'INVALID_TOOL_TRANSFER_ITEM_ID',
  TOOL_TRANSFER_ITEM_DELETE_FAILED = 'TOOL_TRANSFER_ITEM_DELETE_FAILED'
}

export type DeleteToolTransferItemInput = {
  id: Scalars['ID'];
};

export type DeleteToolTransferItemResult = {
  __typename?: 'DeleteToolTransferItemResult';
  errors?: Maybe<Array<Maybe<DeleteToolTransferItemError>>>;
  id?: Maybe<Scalars['ID']>;
};

export type DeleteToolTransferResult = {
  __typename?: 'DeleteToolTransferResult';
  errors?: Maybe<Array<Maybe<DeleteToolTransferError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteToolUserFavoriteError {
  TOOL_FAVORITE_NOT_FOUND = 'TOOL_FAVORITE_NOT_FOUND',
  TOOL_USER_FAVORITE_DELETE_FAILED = 'TOOL_USER_FAVORITE_DELETE_FAILED'
}

export type DeleteToolUserFavoriteResult = {
  __typename?: 'DeleteToolUserFavoriteResult';
  errors?: Maybe<Array<Maybe<DeleteToolUserFavoriteError>>>;
  id?: Maybe<Scalars['ID']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  toolCatalogId?: Maybe<Scalars['String']>;
};

export enum DeleteUomError {
  INVALID_UOM_ID = 'INVALID_UOM_ID',
  UOM_DELETE_FAILED = 'UOM_DELETE_FAILED'
}

export type DeleteUomInput = {
  id: Scalars['Int'];
};

export type DeleteUomResult = {
  __typename?: 'DeleteUomResult';
  errors?: Maybe<Array<Maybe<DeleteUomError>>>;
  id?: Maybe<Scalars['Int']>;
};

export enum DeleteUserProjectError {
  INVALID_USER_PROJECT_ID = 'INVALID_USER_PROJECT_ID',
  USER_PROJECT_DELETE_FAILED = 'USER_PROJECT_DELETE_FAILED'
}

export type DeleteUserProjectInput = {
  id: Scalars['ID'];
};

export type DeleteUserProjectResult = {
  __typename?: 'DeleteUserProjectResult';
  errors?: Maybe<Array<Maybe<DeleteUserProjectError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteUserRoleError {
  INVALID_USER_ROLE_ID = 'INVALID_USER_ROLE_ID',
  USER_ROLE_DELETE_FAILED = 'USER_ROLE_DELETE_FAILED'
}

export type DeleteUserRoleInput = {
  id: Scalars['ID'];
};

export type DeleteUserRoleResult = {
  __typename?: 'DeleteUserRoleResult';
  errors?: Maybe<Array<Maybe<DeleteUserRoleError>>>;
  id?: Maybe<Scalars['ID']>;
};

export enum DeleteUserToolRoomError {
  INVALID_USER_TOOL_ROOM_ID = 'INVALID_USER_TOOL_ROOM_ID',
  USER_TOOL_ROOM_DELETE_FAILED = 'USER_TOOL_ROOM_DELETE_FAILED'
}

export type DeleteUserToolRoomInput = {
  id: Scalars['ID'];
};

export type DeleteUserToolRoomResult = {
  __typename?: 'DeleteUserToolRoomResult';
  errors?: Maybe<Array<Maybe<DeleteUserToolRoomError>>>;
  id?: Maybe<Scalars['ID']>;
};

export type DispatchNotFulfilledInventoryInput = {
  toolCatalogId: Scalars['ID'];
  toolOrderCatalogId: Scalars['ID'];
};

export type DispatchToolOrderInput = {
  /** Not Fulfilled Items */
  notFulfilledItems: Array<DispatchNotFulfilledInventoryInput>;
  /** Tool Order Id */
  toolOrderId: Scalars['String'];
};

export enum DispatchToolOrderStatusError {
  ALREADY_PREPARED = 'ALREADY_PREPARED',
  FAILED_TO_DISPATCH_ORDER = 'FAILED_TO_DISPATCH_ORDER',
  ON_HAND_COUNT_NOT_AVAILABLE = 'ON_HAND_COUNT_NOT_AVAILABLE',
  PICKED_QUANTITY_IS_GREATER = 'PICKED_QUANTITY_IS_GREATER',
  RECIPIENT_DOESNT_HAVE_TOOL_HOUND_ID = 'RECIPIENT_DOESNT_HAVE_TOOL_HOUND_ID',
  TOOL_ORDER_CATALOG_DATA_NOT_FOUND = 'TOOL_ORDER_CATALOG_DATA_NOT_FOUND',
  TOOL_ORDER_NOT_FOUND = 'TOOL_ORDER_NOT_FOUND',
  USER_DOESNT_HAVE_OUTBOUND_USER_ID = 'USER_DOESNT_HAVE_OUTBOUND_USER_ID'
}

export type DispatchToolOrderStatusResult = {
  __typename?: 'DispatchToolOrderStatusResult';
  error?: Maybe<DispatchToolOrderStatusError>;
  toolOrder?: Maybe<ToolOrder>;
};

export type EmployeeImageInput = {
  id: Scalars['ID'];
};

export type EmployeePhotos = {
  __typename?: 'EmployeePhotos';
  /** Id */
  id: Scalars['ID'];
  /** Thumbnail */
  thumbnail: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

/** List of potential exceptions the server can return */
export enum ExceptionCode {
  /** The user does not have the required permission for this action */
  MISSING_REQUIRED_PERMISSION = 'MISSING_REQUIRED_PERMISSION',
  /** Generic error code */
  SYSTEM_ERROR = 'SYSTEM_ERROR'
}

export type FilterConditionInput = {
  /** Name of the field for which the filter needs to be applied to */
  field: Scalars['String'];
  /** Filter operator */
  operator: OperatorType;
  /** Value to be used in the condition */
  value?: InputMaybe<Scalars['String']>;
  /** List of values to be used - for IN Operator */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FilterInput = {
  /** List of and conditions */
  and?: InputMaybe<Array<FilterConditionInput>>;
  /** List of or conditions */
  or?: InputMaybe<Array<FilterConditionInput>>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type GeoLocationInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type GroupedToolInventory = {
  __typename?: 'GroupedToolInventory';
  /** Bar code id */
  barCodeId: Scalars['String'];
  /** Created by */
  createdBy?: Maybe<Scalars['String']>;
  /** User object for createdBy prop */
  createdByUser?: Maybe<User>;
  /** Created date */
  createdDate?: Maybe<Scalars['Datetime']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** Is Locked */
  isLocked?: Maybe<Scalars['Boolean']>;
  /** Is the tool a serialized tool i.e. reusable tool. For eg. A drill */
  isSerialized: Scalars['Boolean'];
  /** Limit Count */
  limitCount?: Maybe<Scalars['Int']>;
  /** On hand count */
  onHandCount?: Maybe<Scalars['Int']>;
  /** Tool catalog */
  toolCatalog?: Maybe<ToolCatalog>;
  /** Tool Catalog ID */
  toolCatalogId: Scalars['ID'];
  /** Tool room */
  toolRoom?: Maybe<ToolRoom>;
  /** Total count */
  totalCount?: Maybe<Scalars['Int']>;
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']>;
  /** User object for createdBy prop */
  updatedByUser?: Maybe<User>;
  /** Updated date */
  updatedDate?: Maybe<Scalars['Datetime']>;
};

export type ImportCatalogStatus = {
  __typename?: 'ImportCatalogStatus';
  /** Description of the import process */
  description: Scalars['String'];
  /** Unique Identifier of the import record */
  id: Scalars['ID'];
  /** How many items errored */
  itemsErrored: Scalars['Int'];
  /** How many items have been successfully imported */
  itemsImported: Scalars['Int'];
  /** how many items have received */
  itemsReceived: Scalars['Int'];
  /** Status of the import */
  status: ImportStatus;
  /** Process last updated by (BUN) */
  updatedBy: Scalars['String'];
  /** Last Updated status */
  updatedDate: Scalars['Datetime'];
};

export enum ImportError {
  CONNECTION_TO_SOURCE_FAILED = 'CONNECTION_TO_SOURCE_FAILED',
  ERROR_UPDATING_DESTINATION_DATA = 'ERROR_UPDATING_DESTINATION_DATA',
  INVALID_IMPORT_INPUT = 'INVALID_IMPORT_INPUT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export type ImportInput = {
  /** Project Tool Catalog CSV File */
  ProjectToolCatalogCsvInput?: InputMaybe<Scalars['JSON']>;
  /** Custom Date for sync */
  customDate?: InputMaybe<Scalars['Datetime']>;
  /** Indicates full or partial import */
  importType: ImportType;
  /** Name of the actual entity to be imported */
  interfaceName: InterfaceName;
  /** Indicates the interface where the data needs to be imported from */
  interfaceType: InterfaceType;
  /** ToolRoom Id of the project */
  toolRoomId?: InputMaybe<Scalars['ID']>;
};

export type ImportResult = {
  __typename?: 'ImportResult';
  /** Value indicating an error occurred during import */
  error?: Maybe<ImportError>;
  /** error Details */
  errorDetails?: Maybe<Scalars['String']>;
  /** inbound controls */
  inboundControls?: Maybe<Array<InboundControls>>;
  /** Boolean value to indicate if the import is success or failure */
  isSuccess: Scalars['Boolean'];
};

export enum ImportStatus {
  COMPLETED = 'COMPLETED',
  ERRORED_AND_TERMINATED = 'ERRORED_AND_TERMINATED',
  ERRORED_WITH_SOME_RESULTS = 'ERRORED_WITH_SOME_RESULTS',
  IN_PROCESS = 'IN_PROCESS',
  SCHEDULED = 'SCHEDULED'
}

export enum ImportType {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL'
}

export type InboundControlUpdatedSubscriptionPayload = {
  __typename?: 'InboundControlUpdatedSubscriptionPayload';
  /** End date */
  endDate: Scalars['Datetime'];
  /** Error details */
  errorDetails?: Maybe<Scalars['String']>;
  /** Error summray */
  errorSummary?: Maybe<Scalars['String']>;
  /** Import summray */
  importSummary?: Maybe<Scalars['JSON']>;
  /** Interface id */
  interfaceId: Scalars['ID'];
  /** Start date */
  startDate: Scalars['Datetime'];
  /** Status */
  status: Scalars['String'];
};

export type InboundControls = {
  __typename?: 'InboundControls';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** End date */
  endDate?: Maybe<Scalars['Datetime']>;
  /** Error details */
  errorDetails?: Maybe<Scalars['String']>;
  /** Error summray */
  errorSummary?: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** Import summray */
  importSummary?: Maybe<Scalars['JSON']>;
  /** Interface id */
  interfaceId: Scalars['ID'];
  /** Project id */
  projectId?: Maybe<Scalars['ID']>;
  /** Start date */
  startDate: Scalars['Datetime'];
  /** Status */
  status: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export enum InboundControlsError {
  FAILED_TO_INSERT_INBOUND_CONTROLS = 'FAILED_TO_INSERT_INBOUND_CONTROLS',
  FAILED_TO_UPDATE_INBOUND_CONTROLS = 'FAILED_TO_UPDATE_INBOUND_CONTROLS',
  INVALID_INTERFACE_CONTROLS = 'INVALID_INTERFACE_CONTROLS'
}

export type InboundControlsResult = {
  __typename?: 'InboundControlsResult';
  error?: Maybe<InboundControlsError>;
  inboundControlsId?: Maybe<Scalars['String']>;
};

export type InboundInterface = {
  __typename?: 'InboundInterface';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name: Scalars['String'];
  /** Process id */
  processId: Scalars['ID'];
  /** Sort order */
  sortOrder: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type InboundProcess = {
  __typename?: 'InboundProcess';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** Name */
  name: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type InboundQueue = {
  __typename?: 'InboundQueue';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Parameters */
  parameters: Scalars['String'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Status */
  status: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export enum InterfaceControlStatus {
  ERRORED = 'ERRORED',
  INITIATED = 'INITIATED',
  IN_PROCESS = 'IN_PROCESS',
  SUCCESS = 'SUCCESS'
}

export enum InterfaceName {
  ALL = 'ALL',
  CREWS = 'CREWS',
  EMPLOYEE_PHOTOS = 'EMPLOYEE_PHOTOS',
  ETRACK_USERS = 'ETRACK_USERS',
  FILE = 'FILE',
  PROJECT_TOOL_CATALOG = 'PROJECT_TOOL_CATALOG',
  TOOL_CATALOG = 'TOOL_CATALOG',
  TOOL_CATALOG_IMAGE = 'TOOL_CATALOG_IMAGE',
  TOOL_CATEGORY = 'TOOL_CATEGORY',
  TOOL_INVENTORY = 'TOOL_INVENTORY',
  TOOL_INVENTORY_STATUS = 'TOOL_INVENTORY_STATUS',
  TOOL_ROOM = 'TOOL_ROOM',
  UOM = 'UOM',
  USERS = 'USERS',
  USER_PROJECT_TOOLHOUND_ID = 'USER_PROJECT_TOOLHOUND_ID'
}

export enum InterfaceType {
  ALL = 'ALL',
  ETRACK = 'ETRACK',
  FILE_IMPORT = 'FILE_IMPORT',
  TOOLHOUND = 'TOOLHOUND'
}

export enum InventoryStatus {
  GOOD = 'GOOD',
  REPAIR = 'REPAIR',
  WRITEOFF = 'WRITEOFF'
}

/** InventoryType field that represents fields from the ToolCatalog.inventoryType prop */
export enum InventoryType {
  Bulk = 'Bulk',
  Consumable = 'Consumable',
  Equipment = 'Equipment',
  Individual = 'Individual'
}

export enum MergeBulkToolCategoryStatsImportError {
  FAILED_TO_UPDATE_TOOL_CATEGORY_STATS = 'FAILED_TO_UPDATE_TOOL_CATEGORY_STATS'
}

export type MergeBulkToolCategoryStatsImportResponse = {
  __typename?: 'MergeBulkToolCategoryStatsImportResponse';
  error?: Maybe<MergeBulkToolCategoryStatsImportError>;
  result?: Maybe<MergeBulkToolCategoryStatsImportResult>;
};

export type MergeBulkToolCategoryStatsImportResult = {
  __typename?: 'MergeBulkToolCategoryStatsImportResult';
  /** Number of delete count */
  deleteCount?: Maybe<Scalars['Int']>;
  /** Number of insert count */
  insertCount?: Maybe<Scalars['Int']>;
  /** Number of update count */
  updateCount?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Mutation to update a role permission scope */
  addDeleteRolePermissionScope: AddDeleteRolePermissionScopeResult;
  /** Mutation to advance tool order the the right in the tool orrder workflow by changing its status */
  advanceToolOrderStatus: AdvanceToolOrderStatusResult;
  /** Mutation to update a tool inventory */
  bulkUpdateToolInventory: BulkUpdateToolInventoryResult;
  /** Muation Cancel Tool Order */
  cancelToolOrder: CancelToolOrderResult;
  /** Clears all the entries in redis cache. DO NOT USE THIS UNLESS REQUIRED FOR DEBUGGING. TO BE PHASED OUT ONCE THE ENVIRONMENTS ARE STABLE */
  clearAll: Scalars['Boolean'];
  /** Create Adhoc Tool Order */
  createAdhocToolOrder: AdhocOrderResult;
  /** Mutation to create a crew */
  createCrew: CreateCrewResult;
  /** Mutation to create a inbound controls */
  createInboundControls: InboundControlsResult;
  /** Mutation to create a inbound interface */
  createInboundInterface: CreateInboundInterfaceResult;
  /** Mutation to create a inbound process */
  createInboundProcess: CreateInboundProcessResult;
  /** Mutation to create a inbound queue */
  createInboundQueue: CreateInboundQueueResult;
  /** Mutation to create a outbound interface */
  createOutboundInterface: CreateOutboundInterfaceResult;
  /** Mutation to create a outbound retry */
  createOutboundRetry: CreateOutboundRetryResult;
  /** Mutation to create a permission */
  createPermission: CreatePermissionResult;
  /** Mutation to create a project configuration */
  createProjectConfiguration: CreateProjectConfigurationResult;
  /** Mutation to create a project tool catalog */
  createProjectToolCatalog: CreateProjectToolCatalogResult;
  /** Mutation to create a role */
  createRole: CreateRoleResult;
  /** Mutation to create a role permission scope */
  createRolePermissionScope: CreateRolePermissionScopeResult;
  /** Mutation to create a scope */
  createScope: CreateScopeResult;
  /** Mutation to create a tool catalog */
  createToolCatalog: CreateToolCatalogResult;
  /** Mutation to create a tool category */
  createToolCategory: CreateToolCategoryResult;
  /** Mutation to create a tool check in */
  createToolCheckIn: CreateToolCheckInResult;
  /** Mutation to create a tool check in items */
  createToolCheckInItems: CreateToolCheckInItemsResult;
  /** Mutation to create a tool inventory */
  createToolInventory: CreateToolInventoryResult;
  /** Mutation to create a tool inventory physical count */
  createToolInventoryPhysicalCount: CreateToolInventoryPhysicalCountResult;
  /** Mutation to create a tool order */
  createToolOrder: CreateToolOrderResult;
  /** Mutation to create a tool order catalog */
  createToolOrderCatalog: CreateToolOrderCatalogResult;
  /** Mutation to create a tool order inventory */
  createToolOrderInventory: CreateToolOrderInventoryResult;
  /** Mutation to create a tool transfer */
  createToolTransfer: CreateToolTransferResult;
  /** Mutation to create a tool transfer history */
  createToolTransferHistory: CreateToolTransferHistoryResult;
  /** Mutation to create a tool transfer item */
  createToolTransferItem: CreateToolTransferItemResult;
  /** Mutation to create a tool type */
  createToolType: CreateToolTypeResult;
  /** Mutation to create a tool user favorite */
  createToolUserFavorite: CreateToolUserFavoriteResult;
  /** Mutation to create a uom */
  createUom: CreateUomResult;
  /** Create user */
  createUserAccount?: Maybe<CreateUserAccountResult>;
  /** Mutation to create a user project */
  createUserProject: CreateUserProjectResult;
  /** Mutation to create a user role */
  createUserRole: CreateUserRoleResult;
  /** Mutation to create a user tool room */
  createUserToolRoom: CreateUserToolRoomResult;
  /** Mutation to delete a crew */
  deleteCrew: DeleteCrewResult;
  /** Mutation to delete a outbound interface */
  deleteOutboundInterface: DeleteOutboundInterfaceResult;
  /** Mutation to delete a outbound retry */
  deleteOutboundRetry: DeleteOutboundRetryResult;
  /** Mutation to delete a permission */
  deletePermission: DeletePermissionResult;
  /** Mutation to delete a project configuration */
  deleteProjectConfiguration: DeleteProjectConfigurationResult;
  /** Mutation to delete a project tool catalog */
  deleteProjectToolCatalog: DeleteProjectToolCatalogResult;
  /** Mutation to delete a role */
  deleteRole: DeleteRoleResult;
  /** Mutation to delete a role permission scope */
  deleteRolePermissionScope: DeleteRolePermissionScopeResult;
  /** Mutation to delete a scope */
  deleteScope: DeleteScopeResult;
  /** Mutation to delete a tool check in */
  deleteToolCheckIn: DeleteToolCheckInResult;
  /** Mutation to delete a tool check in items */
  deleteToolCheckInItems: DeleteToolCheckInItemsResult;
  /** Mutation to delete a tool inventory */
  deleteToolInventory: DeleteToolInventoryResult;
  /** Mutation to delete a tool inventory physical count */
  deleteToolInventoryPhysicalCount: DeleteToolInventoryPhysicalCountResult;
  /** Mutation to delete a tool order */
  deleteToolOrder: DeleteToolOrderResult;
  /** Mutation to delete a tool order catalog */
  deleteToolOrderCatalog: DeleteToolOrderCatalogResult;
  /** Mutation to delete a tool order inventory */
  deleteToolOrderInventory: DeleteToolOrderInventoryResult;
  /** Mutation to delete a tool transfer */
  deleteToolTransfer: DeleteToolTransferResult;
  /** Mutation to delete a tool transfer item */
  deleteToolTransferItem: DeleteToolTransferItemResult;
  /** Mutation to delete a tool user favorite */
  deleteToolUserFavorite: DeleteToolUserFavoriteResult;
  /** Mutation to delete a tool user favorite by catalogId  */
  deleteToolUserFavoriteByToolCatalogId: DeleteToolUserFavoriteResult;
  /** Mutation to delete a uom */
  deleteUom: DeleteUomResult;
  /** Mutation to delete a user project */
  deleteUserProject: DeleteUserProjectResult;
  /** Mutation to delete a user role */
  deleteUserRole: DeleteUserRoleResult;
  /** Mutation to delete a user tool room */
  deleteUserToolRoom: DeleteUserToolRoomResult;
  /** Mutation for Dispatch Tool Order */
  dispatchToolOrder: DispatchToolOrderStatusResult;
  /** Start the import process */
  import: ImportResult;
  importCatalog: ImportCatalogStatus;
  /** Mutation to import tool category stats */
  mergeBulkToolCategoryStatsImport: MergeBulkToolCategoryStatsImportResponse;
  /** Mutation to pick items */
  pickInventory: PickToolOrderInventoryResult;
  /** Mutation to retry failed outbound interface */
  retryOutboundInterface: UpdateOutboundInterfaceResult;
  /** Mutation to both save and delete favorites */
  saveToolUserFavorites: SaveToolUserFavoriteResult;
  /** Mutation to toggle countRequired */
  toggleCountRequired: ToggleCountRequiredResult;
  /** Tool Check in Mutation  */
  toolCheckIn: ToolCheckInResult;
  /** Mutation to update a crew */
  updateCrew: UpdateCrewResult;
  /** Mutation to update a inbound controls */
  updateInboundControls: InboundControlsResult;
  /** Mutation to update a outbound interface */
  updateOutboundInterface: UpdateOutboundInterfaceResult;
  /** Mutation to update a outbound retry */
  updateOutboundRetry: UpdateOutboundRetryResult;
  /** Mutation to update a permission */
  updatePermission: UpdatePermissionResult;
  /** Mutation to update a project configuration */
  updateProjectConfiguration: UpdateProjectConfigurationResult;
  /** Mutation to update a project tool catalog */
  updateProjectToolCatalog: UpdateProjectToolCatalogResult;
  /** Mutation to update a role */
  updateRole: UpdateRoleResult;
  /** Mutation to update a role permission scope */
  updateRolePermissionScope: UpdateRolePermissionScopeResult;
  /** Mutation to update a scope */
  updateScope: UpdateScopeResult;
  /** Mutation to update a tool check in */
  updateToolCheckIn: UpdateToolCheckInResult;
  /** Mutation to update a tool check in items */
  updateToolCheckInItems: UpdateToolCheckInItemsResult;
  /** Mutation to update a tool inventory */
  updateToolInventory: UpdateToolInventoryResult;
  /** Mutation to update a tool inventory physical count */
  updateToolInventoryPhysicalCount: UpdateToolInventoryPhysicalCountResult;
  /** Update tool order with items to del/ updte / insert in tool order catalog */
  updateToolOrder?: Maybe<UpdateToolOrderResult>;
  /** Mutation to update a tool order catalog */
  updateToolOrderCatalog: UpdateToolOrderCatalogResult;
  /** Mutation to update a tool order inventory */
  updateToolOrderInventory: UpdateToolOrderInventoryResult;
  updateToolRoom?: Maybe<UpdateToolRoomResult>;
  /** Mutation to update a tool transfer */
  updateToolTransfer: UpdateToolTransferResult;
  /** Mutation to update a tool transfer item */
  updateToolTransferItem: UpdateToolTransferItemResult;
  /** Mutation to update a uom */
  updateUom: UpdateUomResult;
  /** Update user */
  updateUserAccount?: Maybe<UpdateUserAccountResult>;
  /** Update default project for a user */
  updateUserDefaultProject: UpdateUserDefaultProjectResult;
  /** Mutation to update a user project */
  updateUserProject: UpdateUserProjectResult;
  /** Mutation to update a user role */
  updateUserRole: UpdateUserRoleResult;
  /** Mutation to update a user tool room */
  updateUserToolRoom: UpdateUserToolRoomResult;
};


export type MutationAddDeleteRolePermissionScopeArgs = {
  addDeleteRolePermissionsInput: AddDeleteRolePermissionsInput;
};


export type MutationAdvanceToolOrderStatusArgs = {
  advanceToolOrderStatusInput: AdvanceToolOrderStatusInput;
};


export type MutationBulkUpdateToolInventoryArgs = {
  input: BulkUpdateToolInventoryInput;
};


export type MutationCancelToolOrderArgs = {
  cancelToolOrderInput: CancelToolOrderInput;
};


export type MutationCreateAdhocToolOrderArgs = {
  createAdhocOrderInput: CreateAdhocOrderInput;
};


export type MutationCreateCrewArgs = {
  createCrewInput: CreateCrewInput;
};


export type MutationCreateInboundControlsArgs = {
  createInboundControlsInput: CreateInboundControlsInput;
};


export type MutationCreateInboundInterfaceArgs = {
  createInboundInterfaceInput: CreateInboundInterfaceInput;
};


export type MutationCreateInboundProcessArgs = {
  createInboundProcessInput: CreateInboundProcessInput;
};


export type MutationCreateInboundQueueArgs = {
  createInboundQueueInput: CreateInboundQueueInput;
};


export type MutationCreateOutboundInterfaceArgs = {
  createOutboundInterfaceInput: CreateOutboundInterfaceInput;
};


export type MutationCreateOutboundRetryArgs = {
  createOutboundRetryInput: CreateOutboundRetryInput;
};


export type MutationCreatePermissionArgs = {
  createPermissionInput: CreatePermissionInput;
};


export type MutationCreateProjectConfigurationArgs = {
  createProjectConfigurationInput: CreateProjectConfigurationInput;
};


export type MutationCreateProjectToolCatalogArgs = {
  createProjectToolCatalogInput: CreateProjectToolCatalogInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateRolePermissionScopeArgs = {
  createRolePermissionScopeInput: CreateRolePermissionScopeInput;
};


export type MutationCreateScopeArgs = {
  createScopeInput: CreateScopeInput;
};


export type MutationCreateToolCatalogArgs = {
  createToolCatalogInput: CreateToolCatalogInput;
};


export type MutationCreateToolCategoryArgs = {
  createToolCategoryInput: CreateToolCategoryInput;
};


export type MutationCreateToolCheckInArgs = {
  createToolCheckInInput: CreateToolCheckInInput;
};


export type MutationCreateToolCheckInItemsArgs = {
  createToolCheckInItemsInput: CreateToolCheckInItemsInput;
};


export type MutationCreateToolInventoryArgs = {
  createToolInventoryInput: CreateToolInventoryInput;
};


export type MutationCreateToolInventoryPhysicalCountArgs = {
  createToolInventoryPhysicalCountInput: CreateToolInventoryPhysicalCountInput;
};


export type MutationCreateToolOrderArgs = {
  createToolOrderInput: CreateToolOrderInput;
};


export type MutationCreateToolOrderCatalogArgs = {
  createToolOrderCatalogInput: CreateToolOrderCatalogInput;
};


export type MutationCreateToolOrderInventoryArgs = {
  createToolOrderInventoryInput: CreateToolOrderInventoryInput;
};


export type MutationCreateToolTransferArgs = {
  createToolTransferInput: CreateToolTransferInput;
};


export type MutationCreateToolTransferHistoryArgs = {
  createToolTransferHistoryInput: CreateToolTransferHistoryInput;
};


export type MutationCreateToolTransferItemArgs = {
  createToolTransferItemInput: CreateToolTransferItemInput;
};


export type MutationCreateToolTypeArgs = {
  createToolTypeInput: CreateToolTypeInput;
};


export type MutationCreateToolUserFavoriteArgs = {
  createToolUserFavoriteInput: CreateToolUserFavoriteInput;
};


export type MutationCreateUomArgs = {
  createUomInput: CreateUomInput;
};


export type MutationCreateUserAccountArgs = {
  createUserAccountInput: CreateUserAccountInput;
};


export type MutationCreateUserProjectArgs = {
  createUserProjectInput: CreateUserProjectInput;
};


export type MutationCreateUserRoleArgs = {
  createUserRoleInput: CreateUserRoleInput;
};


export type MutationCreateUserToolRoomArgs = {
  createUserToolRoomInput: CreateUserToolRoomInput;
};


export type MutationDeleteCrewArgs = {
  deleteCrewInput: DeleteCrewInput;
};


export type MutationDeleteOutboundInterfaceArgs = {
  deleteOutboundInterfaceInput: DeleteOutboundInterfaceInput;
};


export type MutationDeleteOutboundRetryArgs = {
  deleteOutboundRetryInput: DeleteOutboundRetryInput;
};


export type MutationDeletePermissionArgs = {
  deletePermissionInput: DeletePermissionInput;
};


export type MutationDeleteProjectConfigurationArgs = {
  deleteProjectConfigurationInput: DeleteProjectConfigurationInput;
};


export type MutationDeleteProjectToolCatalogArgs = {
  deleteProjectToolCatalogInput: DeleteProjectToolCatalogInput;
};


export type MutationDeleteRoleArgs = {
  deleteRoleInput: DeleteRoleInput;
};


export type MutationDeleteRolePermissionScopeArgs = {
  deleteRolePermissionScopeInput: DeleteRolePermissionScopeInput;
};


export type MutationDeleteScopeArgs = {
  deleteScopeInput: DeleteScopeInput;
};


export type MutationDeleteToolCheckInArgs = {
  deleteToolCheckInInput: DeleteToolCheckInInput;
};


export type MutationDeleteToolCheckInItemsArgs = {
  deleteToolCheckInItemsInput: DeleteToolCheckInItemsInput;
};


export type MutationDeleteToolInventoryArgs = {
  deleteToolInventoryInput: DeleteToolInventoryInput;
};


export type MutationDeleteToolInventoryPhysicalCountArgs = {
  deleteToolInventoryPhysicalCountInput: DeleteToolInventoryPhysicalCountInput;
};


export type MutationDeleteToolOrderArgs = {
  deleteToolOrderInput: DeleteToolOrderInput;
};


export type MutationDeleteToolOrderCatalogArgs = {
  deleteToolOrderCatalogInput: DeleteToolOrderCatalogInput;
};


export type MutationDeleteToolOrderInventoryArgs = {
  deleteToolOrderInventoryInput: DeleteToolOrderInventoryInput;
};


export type MutationDeleteToolTransferArgs = {
  deleteToolTransferInput: DeleteToolTransferInput;
};


export type MutationDeleteToolTransferItemArgs = {
  deleteToolTransferItemInput: DeleteToolTransferItemInput;
};


export type MutationDeleteToolUserFavoriteArgs = {
  toolUserFavoriteId: Scalars['ID'];
};


export type MutationDeleteToolUserFavoriteByToolCatalogIdArgs = {
  toolCatalogId: Scalars['ID'];
};


export type MutationDeleteUomArgs = {
  deleteUomInput: DeleteUomInput;
};


export type MutationDeleteUserProjectArgs = {
  deleteUserProjectInput: DeleteUserProjectInput;
};


export type MutationDeleteUserRoleArgs = {
  deleteUserRoleInput: DeleteUserRoleInput;
};


export type MutationDeleteUserToolRoomArgs = {
  deleteUserToolRoomInput: DeleteUserToolRoomInput;
};


export type MutationDispatchToolOrderArgs = {
  dispatchToolOrderInput: DispatchToolOrderInput;
};


export type MutationImportArgs = {
  importInput: ImportInput;
};


export type MutationPickInventoryArgs = {
  pickToolOrderInventoryInput: PickToolOrderInventoryInput;
};


export type MutationRetryOutboundInterfaceArgs = {
  retryOutboundInterfaceInput: RetryOutboundInterfaceInput;
};


export type MutationSaveToolUserFavoritesArgs = {
  input: SaveToolUserFavoriteInput;
};


export type MutationToggleCountRequiredArgs = {
  toggleCountRequiredInput: ToggleCountRequiredInput;
};


export type MutationToolCheckInArgs = {
  toolCheckInInput: ToolCheckInInput;
};


export type MutationUpdateCrewArgs = {
  updateCrewInput: UpdateCrewInput;
};


export type MutationUpdateInboundControlsArgs = {
  updateInboundControlsInput: UpdateInboundControlsInput;
};


export type MutationUpdateOutboundInterfaceArgs = {
  updateOutboundInterfaceInput: UpdateOutboundInterfaceInput;
};


export type MutationUpdateOutboundRetryArgs = {
  updateOutboundRetryInput: UpdateOutboundRetryInput;
};


export type MutationUpdatePermissionArgs = {
  updatePermissionInput: UpdatePermissionInput;
};


export type MutationUpdateProjectConfigurationArgs = {
  updateProjectConfigurationInput: UpdateProjectConfigurationInput;
};


export type MutationUpdateProjectToolCatalogArgs = {
  updateProjectToolCatalogInput: UpdateProjectToolCatalogInput;
};


export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};


export type MutationUpdateRolePermissionScopeArgs = {
  updateRolePermissionScopeInput: UpdateRolePermissionScopeInput;
};


export type MutationUpdateScopeArgs = {
  updateScopeInput: UpdateScopeInput;
};


export type MutationUpdateToolCheckInArgs = {
  updateToolCheckInInput: UpdateToolCheckInInput;
};


export type MutationUpdateToolCheckInItemsArgs = {
  updateToolCheckInItemsInput: UpdateToolCheckInItemsInput;
};


export type MutationUpdateToolInventoryArgs = {
  updateToolInventoryInput: UpdateToolInventoryInput;
};


export type MutationUpdateToolInventoryPhysicalCountArgs = {
  updateToolInventoryPhysicalCountInput: UpdateToolInventoryPhysicalCountInput;
};


export type MutationUpdateToolOrderArgs = {
  input: UpdateToolOrderInput;
};


export type MutationUpdateToolOrderCatalogArgs = {
  updateToolOrderCatalogInput: UpdateToolOrderCatalogInput;
};


export type MutationUpdateToolOrderInventoryArgs = {
  updateToolOrderInventoryInput: UpdateToolOrderInventoryInput;
};


export type MutationUpdateToolRoomArgs = {
  input: UpdateToolRoomInput;
};


export type MutationUpdateToolTransferArgs = {
  updateToolTransferInput: UpdateToolTransferInput;
};


export type MutationUpdateToolTransferItemArgs = {
  updateToolTransferItemInput: UpdateToolTransferItemInput;
};


export type MutationUpdateUomArgs = {
  updateUomInput: UpdateUomInput;
};


export type MutationUpdateUserAccountArgs = {
  updateUserAccountInput: UpdateUserAccountInput;
};


export type MutationUpdateUserDefaultProjectArgs = {
  updateUserDefaultProjectInput: UpdateUserDefaultProjectInput;
};


export type MutationUpdateUserProjectArgs = {
  updateUserProjectInput: UpdateUserProjectInput;
};


export type MutationUpdateUserRoleArgs = {
  updateUserRoleInput: UpdateUserRoleInput;
};


export type MutationUpdateUserToolRoomArgs = {
  updateUserToolRoomInput: UpdateUserToolRoomInput;
};

export enum OperationType {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  READ = 'READ',
  UPDATE = 'UPDATE'
}

export enum OperatorType {
  /** Equal */
  EQUAL = 'EQUAL',
  /** Greater than */
  GREATER_THAN = 'GREATER_THAN',
  /** Greater than or equal to */
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  /** In condition */
  IN = 'IN',
  /** Less than */
  LESS_THAN = 'LESS_THAN',
  /** Less than or equal to */
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  /** Like condition */
  LIKE = 'LIKE',
  /** Not equal to */
  NOT_EQUAL_TO = 'NOT_EQUAL_TO',
  /** Not In condition */
  NOT_IN = 'NOT_IN',
  /** Not like conditions */
  NOT_LIKE = 'NOT_LIKE'
}

export enum OutboundAction {
  /** Send adjustments like +5 or -2 to TH6 */
  INVENTORY_ADJUSTMENT = 'INVENTORY_ADJUSTMENT',
  /** Update inventory to mark new quantities */
  INVENTORY_UPDATE = 'INVENTORY_UPDATE',
  /** When orders are fulfilled */
  ISSUE = 'ISSUE',
  /** Tool Transfer receiving end */
  RECEIVE = 'RECEIVE',
  /** When items are returned/checked-in */
  RETURN = 'RETURN',
  /** Tool Transfer */
  TRANSFER = 'TRANSFER',
  /** Tool Transfer Receipt */
  TRANSFER_RECEIPT = 'TRANSFER_RECEIPT'
}

export enum OutboundErrorType {
  /** Non transient is like a failure returned by the api which requires manual intervention */
  NONTRANSIENT = 'NONTRANSIENT',
  /** Transient is when u have failures like api down, network not available so we can retry later. */
  TRANSIENT = 'TRANSIENT'
}

export type OutboundInterface = {
  __typename?: 'OutboundInterface';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Error type */
  errorType?: Maybe<OutboundErrorType>;
  /** Id */
  id: Scalars['ID'];
  /** Message */
  message: Scalars['String'];
  /** Next schedule date */
  nextScheduleDate?: Maybe<Scalars['Datetime']>;
  /** Outbound action */
  outboundAction: OutboundAction;
  /** Project id */
  projectId: Scalars['ID'];
  /** referenceId */
  referenceId?: Maybe<Scalars['String']>;
  /** Response */
  response?: Maybe<Scalars['String']>;
  /** Status */
  status: OutboundStatus;
  /** toolCheckIn */
  toolCheckIn?: Maybe<ToolCheckIn>;
  /** toolOrder */
  toolOrder?: Maybe<ToolOrder>;
  /** toolTransfer */
  toolTransfer?: Maybe<ToolTransfer>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type OutboundRetry = {
  __typename?: 'OutboundRetry';
  /** Action type */
  actionType: OutboundRetryActionType;
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Error type */
  errorType?: Maybe<OutboundErrorType>;
  /** Id */
  id: Scalars['ID'];
  /** Next schedule date */
  nextScheduleDate: Scalars['Datetime'];
  /** Outbound interface id */
  outboundInterfaceId: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Response */
  response?: Maybe<Scalars['String']>;
  /** Retry count */
  retryCount: Scalars['Int'];
  /** Status */
  status: OutboundStatus;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export enum OutboundRetryActionType {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL'
}

export enum OutboundStatus {
  /** When an error occurred during an outbound call */
  ERROR = 'ERROR',
  /** When we make an outbound call and are waiting for a response. Not applicable to retries. */
  PUBLISH = 'PUBLISH',
  /** When an outbound succeeds */
  SUCCESS = 'SUCCESS'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  /** limit */
  limit?: Maybe<Scalars['Int']>;
  /** offset */
  offset?: Maybe<Scalars['Int']>;
};

export type PaginationInput = {
  /** Number of rows to be fetched */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of rows to be skipped */
  offset?: InputMaybe<Scalars['Int']>;
};

export type Permission = {
  __typename?: 'Permission';
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
  /** Module */
  module: Scalars['String'];
  /** Name */
  name: Scalars['String'];
};

export type PermissionScope = {
  __typename?: 'PermissionScope';
  /** Role permission scope id */
  id: Scalars['ID'];
  /** Permission object */
  permission?: Maybe<Permission>;
  /** Permission id */
  permissionId: Scalars['ID'];
  /** Scope of the permission */
  scope?: Maybe<Scope>;
  /** Scope ID */
  scopeId: Scalars['Int'];
};

export enum PickToolOrderInventoryError {
  DISPATCH_QUANTITY_GREATER_THAN_ORDER_QUANTITY = 'DISPATCH_QUANTITY_GREATER_THAN_ORDER_QUANTITY',
  DISPATCH_QUANTITY_SHOULD_BE_GREATER_THAN_0 = 'DISPATCH_QUANTITY_SHOULD_BE_GREATER_THAN_0',
  FAILED_TO_INSERT_TOOL_ORDER_INVENTORY = 'FAILED_TO_INSERT_TOOL_ORDER_INVENTORY',
  INVENTORY_ID_REQUIRED = 'INVENTORY_ID_REQUIRED',
  INVENTORY_ID_SHOULD_BE_NULL = 'INVENTORY_ID_SHOULD_BE_NULL',
  SERIALIZED_ITEM_QUANTITY_WILL_NOT_EXCEED_TO_1 = 'SERIALIZED_ITEM_QUANTITY_WILL_NOT_EXCEED_TO_1',
  TOOL_ORDER_NOT_FOUND = 'TOOL_ORDER_NOT_FOUND'
}

export type PickToolOrderInventoryInput = {
  /** Pick Quantity (Dispatch Quantity) */
  dispatchQuantity: Scalars['Int'];
  /** Dispatcher comments */
  dispatcherComments?: InputMaybe<Scalars['String']>;
  /** Dispatcher comments by */
  dispatcherCommentsBy?: InputMaybe<Scalars['String']>;
  /** Tool inventory status */
  status: ToolOrderInventoryStatus;
  /** Tool Catalog Id */
  toolCatalogId?: InputMaybe<Scalars['String']>;
  /** Tool Inventory Id */
  toolInventoryId?: InputMaybe<Scalars['ID']>;
  /** Tool Order Catalog Id */
  toolOrderCatalogId: Scalars['String'];
  /** Tool Order Id */
  toolOrderId: Scalars['String'];
};

export type PickToolOrderInventoryResponse = {
  __typename?: 'PickToolOrderInventoryResponse';
  error?: Maybe<PickToolOrderInventoryError>;
  toolOrderInventoryId?: Maybe<Scalars['String']>;
};

export type PickToolOrderInventoryResult = {
  __typename?: 'PickToolOrderInventoryResult';
  error?: Maybe<PickToolOrderInventoryError>;
  toolOrder: ToolOrder;
  toolOrderCatalog?: Maybe<ToolOrderCatalog>;
  toolOrderInventory?: Maybe<ToolOrderInventory>;
};

export type Project = {
  __typename?: 'Project';
  /** Unique Identifier for the Project */
  id: Scalars['ID'];
  /** Job number */
  jobNumber?: Maybe<Scalars['String']>;
  /** Project Name */
  name?: Maybe<Scalars['String']>;
  /** Sub-job number */
  subJobNumber?: Maybe<Scalars['String']>;
  /** toolhound parent location id */
  thParentLocationId?: Maybe<Scalars['String']>;
};

export type ProjectConfiguration = {
  __typename?: 'ProjectConfiguration';
  /** Configuration name */
  configurationName: Scalars['String'];
  /** Configuration value */
  configurationValue: Scalars['JSON'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ProjectToolCatalog = {
  __typename?: 'ProjectToolCatalog';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Is Locked */
  isLocked?: Maybe<Scalars['Boolean']>;
  /** Limit Count */
  limitCount?: Maybe<Scalars['Int']>;
  /** Project id */
  projectId?: Maybe<Scalars['ID']>;
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ProjectToolCatalogCsvPayload = {
  __typename?: 'ProjectToolCatalogCsvPayload';
  /** Id */
  csvFileId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** Get crew by id */
  crewById?: Maybe<Crew>;
  /** Get crews count. Sort params ignored and can be provided as [] */
  crewCount?: Maybe<Scalars['Int']>;
  /** Employe Image UR */
  employeeImageUrl?: Maybe<Scalars['String']>;
  /** Get employee photoss count. Sort params ignored and can be provided as [] */
  employeePhotosCount?: Maybe<Scalars['Int']>;
  /** count for grouped parent inventories by criteria */
  groupedParentInventoryCount?: Maybe<Scalars['Int']>;
  /** Get inbound controls by id */
  inboundControlsById?: Maybe<InboundControls>;
  /** Get inbound interface by id */
  inboundInterfaceById?: Maybe<InboundInterface>;
  /** Get inbound process by id */
  inboundProcessById?: Maybe<InboundProcess>;
  /** Get inbound queue by id */
  inboundQueueById?: Maybe<InboundQueue>;
  /** The last running Import Catalog process */
  latestCatalogImport?: Maybe<ImportCatalogStatus>;
  /** Get outbound interface by id */
  outboundInterfaceById?: Maybe<OutboundInterface>;
  /** Get outbound interfaces count. Sort params ignored and can be provided as [] */
  outboundInterfaceCount?: Maybe<Scalars['Int']>;
  /** Get outbound retry by id */
  outboundRetryById?: Maybe<OutboundRetry>;
  /** Get outbound retrys count. Sort params ignored and can be provided as [] */
  outboundRetryCount?: Maybe<Scalars['Int']>;
  /** Get permission by id */
  permissionById?: Maybe<Permission>;
  /** Get Project by Id */
  project?: Maybe<Project>;
  /** Get project configuration by id */
  projectConfigurationById?: Maybe<ProjectConfiguration>;
  /** Get project configurations count. Sort params ignored and can be provided as [] */
  projectConfigurationCount?: Maybe<Scalars['Int']>;
  /** Get project tool catalog by id */
  projectToolCatalogById?: Maybe<ProjectToolCatalog>;
  /** Get project tool catalogs count. Sort params ignored and can be provided as [] */
  projectToolCatalogCount?: Maybe<Scalars['Int']>;
  /** Get list of all Projects */
  projects: Array<Maybe<Project>>;
  /** Get role by id */
  roleById?: Maybe<Role>;
  /** Get role permission scope by id */
  rolePermissionScopeById?: Maybe<RolePermissionScope>;
  /** Get scope by id */
  scopeById?: Maybe<Scope>;
  /** Search crews */
  searchCrews?: Maybe<SearchCrewResult>;
  /** Search employee photoss */
  searchEmployeePhotoss?: Maybe<SearchEmployeePhotosResult>;
  /** searchGroupedParentInventories Requires toolRoomId in search input */
  searchGroupedParentInventories?: Maybe<SearchGroupedInventoryResult>;
  /** Search inbound controlss */
  searchInboundControlss?: Maybe<SearchInboundControlsResult>;
  /** Search inbound interfaces */
  searchInboundInterfaces?: Maybe<SearchInboundInterfaceResult>;
  /** Search inbound processs */
  searchInboundProcesss?: Maybe<SearchInboundProcessResult>;
  /** Search inbound queues */
  searchInboundQueues?: Maybe<SearchInboundQueueResult>;
  /** Search outbound interfaces */
  searchOutboundInterfaces?: Maybe<SearchOutboundInterfaceResult>;
  /** Search outbound retrys */
  searchOutboundRetries?: Maybe<SearchOutboundRetryResult>;
  /** Search permissions */
  searchPermissions?: Maybe<SearchPermissionResult>;
  /** Search project configurations */
  searchProjectConfigurations?: Maybe<SearchProjectConfigurationResult>;
  /** Search project tool catalogs */
  searchProjectToolCatalogs?: Maybe<SearchProjectToolCatalogResult>;
  /** Search Projects */
  searchProjects?: Maybe<SearchProjectsResult>;
  /** Search role permission scopes */
  searchRolePermissionScopes?: Maybe<SearchRolePermissionScopeResult>;
  /** Search roles */
  searchRoles?: Maybe<SearchRoleResult>;
  /** Search scopes */
  searchScopes?: Maybe<SearchScopeResult>;
  /** Search tool catalog images */
  searchToolCatalogImages?: Maybe<SearchToolCatalogImageResult>;
  /** Search tool catalogs */
  searchToolCatalogs?: Maybe<SearchToolCatalogResult>;
  /** Search tool categories */
  searchToolCategories?: Maybe<SearchToolCategoryResult>;
  /** Search tool category statss */
  searchToolCategoryStatss?: Maybe<SearchToolCategoryStatsResult>;
  /** Search tool check in itemss */
  searchToolCheckInItemss?: Maybe<SearchToolCheckInItemsResult>;
  /** Search tool check ins */
  searchToolCheckIns?: Maybe<SearchToolCheckInResult>;
  /** Search tool inventorys */
  searchToolInventories?: Maybe<SearchToolInventoryResult>;
  /** Search tool inventory physical counts */
  searchToolInventoryPhysicalCounts?: Maybe<SearchToolInventoryPhysicalCountResult>;
  /** Search tool inventory statuss */
  searchToolInventoryStatuss?: Maybe<SearchToolInventoryStatusResult>;
  /** Search tool order catalogs */
  searchToolOrderCatalogs?: Maybe<SearchToolOrderCatalogResult>;
  /** Search tool order historys */
  searchToolOrderHistorys?: Maybe<SearchToolOrderHistoryResult>;
  /** Search tool order inventorys */
  searchToolOrderInventory?: Maybe<SearchToolOrderInventoryResult>;
  /** Temp query: Search tool order inventory by who it was ordered for */
  searchToolOrderInventoryByOrderedFor?: Maybe<SearchToolOrderInventoryResult>;
  /** Search tool orders */
  searchToolOrders?: Maybe<SearchToolOrderResult>;
  /** Search tool rooms */
  searchToolRooms?: Maybe<SearchToolRoomResult>;
  /** Search tool transfer historys */
  searchToolTransferHistorys?: Maybe<SearchToolTransferHistoryResult>;
  /** Search tool transfer items */
  searchToolTransferItems?: Maybe<SearchToolTransferItemResult>;
  /** Search tool transfers */
  searchToolTransfers?: Maybe<SearchToolTransferResult>;
  /** Search tool types */
  searchToolTypes?: Maybe<SearchToolTypeResult>;
  /** Search tool user favorites */
  searchToolUserFavorites?: Maybe<SearchToolUserFavoriteResult>;
  /** Search uoms */
  searchUoms?: Maybe<SearchUomResult>;
  /** Search user projects */
  searchUserProjects?: Maybe<SearchUserProjectResult>;
  /** Search user roles */
  searchUserRoles?: Maybe<SearchUserRoleResult>;
  /** Search user tool rooms */
  searchUserToolRooms?: Maybe<SearchUserToolRoomResult>;
  /** Search Users */
  searchUsers?: Maybe<SearchUserResult>;
  /** Get tool catalog by id */
  toolCatalogById?: Maybe<ToolCatalog>;
  /** Get tool catalog images count. Sort params ignored and can be provided as [] */
  toolCatalogImageCount?: Maybe<Scalars['Int']>;
  /** Tool Catalog Image URL */
  toolCatalogImageUrl?: Maybe<Scalars['String']>;
  /** tool catalogs count for search input */
  toolCatalogsCountForSearch?: Maybe<Scalars['Int']>;
  /** Search tool categories count for search input */
  toolCategoriesCountForSearch?: Maybe<Scalars['Int']>;
  /** Get tool category by id */
  toolCategoryById?: Maybe<ToolCategory>;
  /** Grouped tool categories by name */
  toolCategoryGroupByName: Array<ToolCategory>;
  /** Get tool category stats by id */
  toolCategoryStatsById?: Maybe<ToolCategoryStats>;
  /** Get tool check in by id */
  toolCheckInById?: Maybe<ToolCheckIn>;
  /** Get tool check ins count. Sort params ignored and can be provided as [] */
  toolCheckInCount?: Maybe<Scalars['Int']>;
  /** Get tool check in items by id */
  toolCheckInItemsById?: Maybe<ToolCheckInItems>;
  /** Get tool check in itemss count. Sort params ignored and can be provided as [] */
  toolCheckInItemsCount?: Maybe<Scalars['Int']>;
  /** Get tool inventory by id */
  toolInventoryById?: Maybe<ToolInventory>;
  /** count for inventories by criteria */
  toolInventoryCountForSearch?: Maybe<Scalars['Int']>;
  /** Get tool inventory physical count by id */
  toolInventoryPhysicalCountById?: Maybe<ToolInventoryPhysicalCount>;
  /** Get tool inventory physical counts count. Sort params ignored and can be provided as [] */
  toolInventoryPhysicalCountCount?: Maybe<Scalars['Int']>;
  /** Inventory Stats */
  toolInventoryStats?: Maybe<ToolInventoryStatsResult>;
  /** Get tool inventory status by id */
  toolInventoryStatusById?: Maybe<ToolInventoryStatus>;
  /** Get tool inventory statuss count. Sort params ignored and can be provided as [] */
  toolInventoryStatusCount?: Maybe<Scalars['Int']>;
  /** Get tool order by id */
  toolOrderById?: Maybe<ToolOrder>;
  /** Get tool order catalog by id */
  toolOrderCatalogById?: Maybe<ToolOrderCatalog>;
  /** A complete list parent and out of stock tool orders for a given tool order id */
  toolOrderFamilyTree?: Maybe<SearchToolOrderResult>;
  /** Get tool order history by id */
  toolOrderHistoryById?: Maybe<ToolOrderHistory>;
  /** Get tool order inventory by id */
  toolOrderInventoryById?: Maybe<ToolOrderInventory>;
  /** tool order stats by user and tool room */
  toolOrderStats?: Maybe<ToolOrderStatsResponse>;
  /** List of tool order statuses */
  toolOrderStatuses: Array<ToolOrderStatusData>;
  /** Tool orders count */
  toolOrdersCountForSearch?: Maybe<Scalars['Int']>;
  /** Get a project by id */
  toolRoom?: Maybe<ToolRoom>;
  /** Get list of all tool rooms */
  toolRooms: Array<ToolRoom>;
  /** Tool rooms count for search input */
  toolRoomsCountForSearch?: Maybe<Scalars['Int']>;
  /** Get tool transfer by id */
  toolTransferById?: Maybe<ToolTransfer>;
  /** Get tool transfers count. Sort params ignored and can be provided as [] */
  toolTransferCount?: Maybe<Scalars['Int']>;
  /** Get tool transfer history by id */
  toolTransferHistoryById?: Maybe<ToolTransferHistory>;
  /** Get tool transfer historys count. Sort params ignored and can be provided as [] */
  toolTransferHistoryCount?: Maybe<Scalars['Int']>;
  /** Get tool transfer item by id */
  toolTransferItemById?: Maybe<ToolTransferItem>;
  /** Get tool transfer items count. Sort params ignored and can be provided as [] */
  toolTransferItemCount?: Maybe<Scalars['Int']>;
  /** Get tool type by id */
  toolTypeById?: Maybe<ToolType>;
  /** Get tool user favorite by id */
  toolUserFavoriteById?: Maybe<ToolUserFavorite>;
  /** Get uom by id */
  uomById?: Maybe<Uom>;
  /** Get uoms count. Sort params ignored and can be provided as [] */
  uomCount?: Maybe<Scalars['Int']>;
  /** User info for the currently authenticated user */
  userByAuth?: Maybe<User>;
  /** Alias for user query because WAG is creating a stink */
  userById?: Maybe<User>;
  /** Get user project by id */
  userProjectById?: Maybe<UserProject>;
  /** Get user role by id */
  userRoleById?: Maybe<UserRole>;
  /** Get user roles count. Sort params ignored and can be provided as [] */
  userRoleCount?: Maybe<Scalars['Int']>;
  /** Get user tool room by id */
  userToolRoomById?: Maybe<UserToolRoom>;
  /** Get user tool rooms count. Sort params ignored and can be provided as [] */
  userToolRoomCount?: Maybe<Scalars['Int']>;
  /** count for inventories by criteria */
  usersCountForSearch?: Maybe<Scalars['Int']>;
};


export type QueryCrewByIdArgs = {
  id: Scalars['ID'];
};


export type QueryCrewCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryEmployeeImageUrlArgs = {
  id: Scalars['ID'];
};


export type QueryEmployeePhotosCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryGroupedParentInventoryCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryInboundControlsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryInboundInterfaceByIdArgs = {
  id: Scalars['ID'];
};


export type QueryInboundProcessByIdArgs = {
  id: Scalars['ID'];
};


export type QueryInboundQueueByIdArgs = {
  id: Scalars['ID'];
};


export type QueryOutboundInterfaceByIdArgs = {
  id: Scalars['ID'];
};


export type QueryOutboundInterfaceCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryOutboundRetryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryOutboundRetryCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryPermissionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryProjectArgs = {
  id: Scalars['ID'];
};


export type QueryProjectConfigurationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryProjectConfigurationCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryProjectToolCatalogByIdArgs = {
  id: Scalars['ID'];
};


export type QueryProjectToolCatalogCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryRoleByIdArgs = {
  id: Scalars['ID'];
};


export type QueryRolePermissionScopeByIdArgs = {
  id: Scalars['ID'];
};


export type QueryScopeByIdArgs = {
  id: Scalars['Int'];
};


export type QuerySearchCrewsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchEmployeePhotossArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchGroupedParentInventoriesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchInboundControlssArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchInboundInterfacesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchInboundProcesssArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchInboundQueuesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchOutboundInterfacesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchOutboundRetriesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchPermissionsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchProjectConfigurationsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchProjectToolCatalogsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchProjectsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchRolePermissionScopesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchRolesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchScopesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolCatalogImagesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolCatalogsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolCategoriesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolCategoryStatssArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolCheckInItemssArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolCheckInsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolInventoriesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolInventoryPhysicalCountsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolInventoryStatussArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolOrderCatalogsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolOrderHistorysArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolOrderInventoryArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolOrderInventoryByOrderedForArgs = {
  userProjectId?: InputMaybe<Scalars['String']>;
};


export type QuerySearchToolOrdersArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolRoomsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolTransferHistorysArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolTransferItemsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolTransfersArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolTypesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchToolUserFavoritesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchUomsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchUserProjectsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchUserRolesArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchUserToolRoomsArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QuerySearchUsersArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolCatalogByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolCatalogImageCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolCatalogImageUrlArgs = {
  id: Scalars['ID'];
};


export type QueryToolCatalogsCountForSearchArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolCategoriesCountForSearchArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolCategoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolCategoryStatsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolCheckInByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolCheckInCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolCheckInItemsByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolCheckInItemsCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolInventoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolInventoryCountForSearchArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolInventoryPhysicalCountByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolInventoryPhysicalCountCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolInventoryStatsArgs = {
  toolInventoryInput?: InputMaybe<ToolInventoryInput>;
};


export type QueryToolInventoryStatusByIdArgs = {
  id: Scalars['Int'];
};


export type QueryToolInventoryStatusCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolOrderByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolOrderCatalogByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolOrderFamilyTreeArgs = {
  id: Scalars['ID'];
};


export type QueryToolOrderHistoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolOrderInventoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolOrderStatsArgs = {
  toolOrderStatsInput: ToolOrderStatsInput;
};


export type QueryToolOrdersCountForSearchArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolRoomArgs = {
  id: Scalars['ID'];
};


export type QueryToolRoomsCountForSearchArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolTransferByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolTransferCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolTransferHistoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolTransferHistoryCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolTransferItemByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolTransferItemCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryToolTypeByIdArgs = {
  id: Scalars['ID'];
};


export type QueryToolUserFavoriteByIdArgs = {
  id: Scalars['ID'];
};


export type QueryUomByIdArgs = {
  id: Scalars['Int'];
};


export type QueryUomCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryUserByIdArgs = {
  id: Scalars['ID'];
};


export type QueryUserProjectByIdArgs = {
  id: Scalars['ID'];
};


export type QueryUserRoleByIdArgs = {
  id: Scalars['ID'];
};


export type QueryUserRoleCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryUserToolRoomByIdArgs = {
  id: Scalars['ID'];
};


export type QueryUserToolRoomCountArgs = {
  searchInput?: InputMaybe<SearchInput>;
};


export type QueryUsersCountForSearchArgs = {
  searchInput?: InputMaybe<SearchInput>;
};

export type RetryFailedOutboundSubscriptionPayload = {
  __typename?: 'RetryFailedOutboundSubscriptionPayload';
  /** Unique Identifier of the Tool Room */
  id: Array<Maybe<Scalars['ID']>>;
  /** Last Updated date time of this tool room */
  updatedDate: Scalars['Datetime'];
};

export type RetryOutboundInterfaceInput = {
  /** Id */
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type Role = {
  __typename?: 'Role';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name: Scalars['String'];
  /** Project Id */
  projectId: Scalars['ID'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type RolePermissionScope = {
  __typename?: 'RolePermissionScope';
  /** Created by */
  createdBy?: Maybe<Scalars['String']>;
  /** Created date */
  createdDate?: Maybe<Scalars['Datetime']>;
  /** Id */
  id: Scalars['ID'];
  /** Permission */
  permission?: Maybe<Permission>;
  /** Permission id */
  permissionId: Scalars['ID'];
  /** Project Id */
  projectId: Scalars['ID'];
  /** Role  */
  role?: Maybe<Role>;
  /** Role id */
  roleId: Scalars['ID'];
  /** Scope id */
  scopeId: Scalars['Int'];
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']>;
  /** Updated date */
  updatedDate?: Maybe<Scalars['Datetime']>;
};

export enum SaveToolUserFavoriteError {
  CATALOG_IS_ALREADY_EXIST_IN_FAVORITE = 'CATALOG_IS_ALREADY_EXIST_IN_FAVORITE',
  FAILED_TO_INSERT_TOOL_USER_FAVORITE = 'FAILED_TO_INSERT_TOOL_USER_FAVORITE',
  INVALID_CATALOG_ITEM = 'INVALID_CATALOG_ITEM',
  TOOL_FAVORITE_NOT_FOUND = 'TOOL_FAVORITE_NOT_FOUND',
  TOOL_USER_FAVORITE_DELETE_FAILED = 'TOOL_USER_FAVORITE_DELETE_FAILED'
}

export type SaveToolUserFavoriteInput = {
  /** Any tool catalog ids being marked as favorites */
  additions: Array<Scalars['ID']>;
  /** Any tool catalog ids being unmarked as favorites */
  deletions: Array<Scalars['ID']>;
  /** User id of persn for whom we are tryng to manage favorites */
  userId: Scalars['ID'];
};

export type SaveToolUserFavoriteResult = {
  __typename?: 'SaveToolUserFavoriteResult';
  /** Error */
  error?: Maybe<SaveToolUserFavoriteError>;
  /** how many records were affected */
  recordsAffected: Scalars['Int'];
};

export type Scope = {
  __typename?: 'Scope';
  /** Id */
  id: Scalars['Int'];
  /** Name */
  name: Scalars['String'];
};

export type SearchCrewResult = {
  __typename?: 'SearchCrewResult';
  /** Actual results */
  items?: Maybe<Array<Crew>>;
};

export type SearchEmployeePhotosResult = {
  __typename?: 'SearchEmployeePhotosResult';
  /** Actual results */
  items?: Maybe<Array<EmployeePhotos>>;
};

export enum SearchGroupedInventoryError {
  TOOL_ROOM_ID_REQUIRED = 'TOOL_ROOM_ID_REQUIRED'
}

export type SearchGroupedInventoryResult = {
  __typename?: 'SearchGroupedInventoryResult';
  error?: Maybe<SearchGroupedInventoryError>;
  /** Actual results */
  items?: Maybe<Array<GroupedToolInventory>>;
};

export type SearchInboundControlsResult = {
  __typename?: 'SearchInboundControlsResult';
  /** Actual results */
  items?: Maybe<Array<InboundControls>>;
};

export type SearchInboundInterfaceResult = {
  __typename?: 'SearchInboundInterfaceResult';
  /** Actual results */
  items?: Maybe<Array<InboundInterface>>;
};

export type SearchInboundProcessResult = {
  __typename?: 'SearchInboundProcessResult';
  /** Actual results */
  items?: Maybe<Array<InboundProcess>>;
};

export type SearchInboundQueueResult = {
  __typename?: 'SearchInboundQueueResult';
  /** Actual results */
  items?: Maybe<Array<InboundQueue>>;
};

export type SearchInput = {
  /** Cursor Pagination input */
  cursorPaginationInput?: InputMaybe<CursorPaginationInput>;
  /** Filter input */
  filterInput?: InputMaybe<FilterInput>;
  /** Pagination input */
  paginationInput?: InputMaybe<PaginationInput>;
  /** Search text - only applicable for tool orders */
  searchText?: InputMaybe<Scalars['String']>;
  /** List of distinct fields to be selected */
  selectDistinctList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Sort input */
  sortInput: Array<SortInput>;
};

export type SearchOutboundInterfaceResult = {
  __typename?: 'SearchOutboundInterfaceResult';
  /** Actual results */
  items?: Maybe<Array<OutboundInterface>>;
};

export type SearchOutboundRetryResult = {
  __typename?: 'SearchOutboundRetryResult';
  /** Actual results */
  items?: Maybe<Array<OutboundRetry>>;
};

export type SearchPermissionResult = {
  __typename?: 'SearchPermissionResult';
  /** Actual results */
  items?: Maybe<Array<Permission>>;
};

export type SearchProjectConfigurationResult = {
  __typename?: 'SearchProjectConfigurationResult';
  /** Actual results */
  items?: Maybe<Array<ProjectConfiguration>>;
};

export type SearchProjectToolCatalogResult = {
  __typename?: 'SearchProjectToolCatalogResult';
  /** Actual results */
  items?: Maybe<Array<ProjectToolCatalog>>;
};

export type SearchProjectsResult = {
  __typename?: 'SearchProjectsResult';
  /** Actual results */
  items?: Maybe<Array<Project>>;
};

export type SearchRolePermissionScopeResult = {
  __typename?: 'SearchRolePermissionScopeResult';
  /** Actual results */
  items?: Maybe<Array<RolePermissionScope>>;
};

export type SearchRoleResult = {
  __typename?: 'SearchRoleResult';
  /** Actual results */
  items?: Maybe<Array<Role>>;
};

export type SearchScopeResult = {
  __typename?: 'SearchScopeResult';
  /** Actual results */
  items?: Maybe<Array<Scope>>;
};

export type SearchToolCatalogImageResult = {
  __typename?: 'SearchToolCatalogImageResult';
  /** Actual results */
  items?: Maybe<Array<ToolCatalogImage>>;
};

export type SearchToolCatalogResult = {
  __typename?: 'SearchToolCatalogResult';
  /** Actual results */
  items?: Maybe<Array<ToolCatalog>>;
};

export type SearchToolCategoryResult = {
  __typename?: 'SearchToolCategoryResult';
  /** Actual results */
  items?: Maybe<Array<ToolCategory>>;
};

export type SearchToolCategoryStatsResult = {
  __typename?: 'SearchToolCategoryStatsResult';
  /** Actual results */
  items?: Maybe<Array<ToolCategoryStats>>;
};

export type SearchToolCheckInItemsResult = {
  __typename?: 'SearchToolCheckInItemsResult';
  /** Actual results */
  items?: Maybe<Array<ToolCheckInItems>>;
};

export type SearchToolCheckInResult = {
  __typename?: 'SearchToolCheckInResult';
  /** Actual results */
  items?: Maybe<Array<ToolCheckIn>>;
};

export type SearchToolInventoryPhysicalCountResult = {
  __typename?: 'SearchToolInventoryPhysicalCountResult';
  /** Actual results */
  items?: Maybe<Array<ToolInventoryPhysicalCount>>;
};

export type SearchToolInventoryResult = {
  __typename?: 'SearchToolInventoryResult';
  /** Actual results */
  items?: Maybe<Array<ToolInventory>>;
  /** Page Info */
  pageInfo?: Maybe<PageInfo>;
};

export type SearchToolInventoryStatusResult = {
  __typename?: 'SearchToolInventoryStatusResult';
  /** Actual results */
  items?: Maybe<Array<ToolInventoryStatus>>;
};

export type SearchToolOrderCatalogResult = {
  __typename?: 'SearchToolOrderCatalogResult';
  /** Actual results */
  items?: Maybe<Array<ToolOrderCatalog>>;
};

export type SearchToolOrderHistoryResult = {
  __typename?: 'SearchToolOrderHistoryResult';
  /** Actual results */
  items?: Maybe<Array<ToolOrderHistory>>;
};

export type SearchToolOrderInventoryResult = {
  __typename?: 'SearchToolOrderInventoryResult';
  /** Actual results */
  items?: Maybe<Array<ToolOrderInventory>>;
};

export type SearchToolOrderResult = {
  __typename?: 'SearchToolOrderResult';
  /** Actual results */
  items?: Maybe<Array<ToolOrder>>;
};

export type SearchToolRoomResult = {
  __typename?: 'SearchToolRoomResult';
  /** Actual results */
  items?: Maybe<Array<ToolRoom>>;
};

export type SearchToolTransferHistoryResult = {
  __typename?: 'SearchToolTransferHistoryResult';
  /** Actual results */
  items?: Maybe<Array<ToolTransferHistory>>;
};

export type SearchToolTransferItemResult = {
  __typename?: 'SearchToolTransferItemResult';
  /** Actual results */
  items?: Maybe<Array<ToolTransferItem>>;
};

export type SearchToolTransferResult = {
  __typename?: 'SearchToolTransferResult';
  /** Actual results */
  items?: Maybe<Array<ToolTransfer>>;
};

export type SearchToolTypeResult = {
  __typename?: 'SearchToolTypeResult';
  /** Actual results */
  items?: Maybe<Array<ToolType>>;
};

export type SearchToolUserFavoriteResult = {
  __typename?: 'SearchToolUserFavoriteResult';
  /** Actual results */
  items?: Maybe<Array<ToolUserFavorite>>;
  /** Tool user favorite stats */
  stats?: Maybe<ToolUserFavoriteStats>;
};

export type SearchUomResult = {
  __typename?: 'SearchUomResult';
  /** Actual results */
  items?: Maybe<Array<Uom>>;
};

export type SearchUserProjectResult = {
  __typename?: 'SearchUserProjectResult';
  /** Actual results */
  items?: Maybe<Array<UserProject>>;
};

export type SearchUserResult = {
  __typename?: 'SearchUserResult';
  /** Actual results */
  items?: Maybe<Array<User>>;
};

export type SearchUserRoleResult = {
  __typename?: 'SearchUserRoleResult';
  /** Actual results */
  items?: Maybe<Array<UserRole>>;
};

export type SearchUserToolRoomResult = {
  __typename?: 'SearchUserToolRoomResult';
  /** Actual results */
  items?: Maybe<Array<UserToolRoom>>;
};

export type SortInput = {
  /** Field name to be sorted */
  field?: InputMaybe<Scalars['String']>;
  /** Sort type */
  sort?: InputMaybe<SortType>;
};

export enum SortType {
  /** Ascending */
  ASC = 'ASC',
  /** Descending */
  DESC = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscription event for Inbound Control Updated */
  inboundControlUpdated: InboundControlUpdatedSubscriptionPayload;
  /** Subscription event for update tool inventory */
  inventoryUpdated: ToolInventorySubscriptionPayload;
  /** CSV File Upload For Project Tool Catalog */
  projectToolCatalogCsv: ProjectToolCatalogCsvPayload;
  /** Subscription event for update outbound sync */
  retryFailedOutbound: RetryFailedOutboundSubscriptionPayload;
  /** Subscription event for  outbound  */
  toolHoundOutBound: ToolHoundOutboundSubscriptionPayload;
  /** Subscription event for Tool Order Create */
  toolOrderCreated: ToolOrderSubscriptionPayload;
  /** Tool order inventory created */
  toolOrderInventoryCreated: ToolOrderInventoryCreatedSubscriptionPayload;
  /** Subscription event for Tool Order Create */
  toolOrderStatusUpdated: ToolOrderStatusSubscriptionPayload;
  /** Subscription event for Tool Order Update */
  toolOrderUpdated: ToolOrderUpdatedSubscriptionPayload;
  /** Subscription event for Tool Room Update */
  toolRoomUpdated: ToolRoomSubscriptionPayload;
};

export enum ToggleCountRequiredError {
  INVALID_TOOL_INVENTORY_ID = 'INVALID_TOOL_INVENTORY_ID',
  TOGGLE_COUNT_REQUIRED_FAILED = 'TOGGLE_COUNT_REQUIRED_FAILED'
}

export type ToggleCountRequiredInput = {
  id: Scalars['ID'];
};

export type ToggleCountRequiredResult = {
  __typename?: 'ToggleCountRequiredResult';
  error?: Maybe<ToggleCountRequiredError>;
  toolInventory?: Maybe<ToolInventory>;
};

export type ToolCatalog = {
  __typename?: 'ToolCatalog';
  /** Bscn part number */
  bscnPartNumber: Scalars['String'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Inventory Type. The source of this is Tool Hound Inventory Types */
  inventoryType?: Maybe<Scalars['String']>;
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Whether this tool catalog item is marked as a favorite of the currently logged in user */
  isFavorite?: Maybe<Scalars['Boolean']>;
  /** Is Locked */
  isLocked?: Maybe<Scalars['Boolean']>;
  /** Limit Count */
  limitCount?: Maybe<Scalars['Int']>;
  /** Name */
  name?: Maybe<Scalars['String']>;
  /** Project Tool Catalog */
  projectToolCatalog?: Maybe<Array<Maybe<ProjectToolCatalog>>>;
  /** ToolHound Tool Catalog Id */
  thToolCatalogId?: Maybe<Scalars['String']>;
  /** Tool Catalog Image Url */
  toolCatalogImageUrl?: Maybe<Scalars['String']>;
  /** Tool category this catalog item belongs to */
  toolCategory?: Maybe<ToolCategory>;
  /** Tool Category ID */
  toolCategoryId?: Maybe<Scalars['ID']>;
  /** Uom */
  uom?: Maybe<Uom>;
  /** Uom */
  uomId?: Maybe<Scalars['Int']>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolCatalogImage = {
  __typename?: 'ToolCatalogImage';
  /** Id */
  id: Scalars['ID'];
  /** Thumbnail */
  thumbnail: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolCatalogImageUrlInput = {
  id: Scalars['ID'];
};

export type ToolCategory = {
  __typename?: 'ToolCategory';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name: Scalars['String'];
  /** Stats */
  toolCategoryStats?: Maybe<ToolCategoryStats>;
  /** Tool hound id */
  toolHoundId: Scalars['String'];
  /** Parent Tool type */
  toolType?: Maybe<ToolType>;
  /** Tool Type Id of the Tool category */
  toolTypeId: Scalars['ID'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolCategoryStats = {
  __typename?: 'ToolCategoryStats';
  /** Consumables count */
  consumablesCount?: Maybe<Scalars['Int']>;
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Equipment count */
  equipmentCount?: Maybe<Scalars['Int']>;
  /** Id */
  id: Scalars['ID'];
  /** Rigging count */
  riggingCount?: Maybe<Scalars['Int']>;
  /** Safety count */
  safetyCount?: Maybe<Scalars['Int']>;
  /** Tool category name */
  toolCategoryName: Scalars['String'];
  /** Tools count */
  toolsCount?: Maybe<Scalars['Int']>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolCheckIn = {
  __typename?: 'ToolCheckIn';
  /** Check in number */
  checkInNumber: Scalars['String'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Parent Checkin Id */
  parentCheckInId: Scalars['String'];
  /** Project id */
  projectId: Scalars['ID'];
  /** recipient id */
  recipientId: Scalars['String'];
  /** Th transaction id */
  thTransactionId?: Maybe<Scalars['String']>;
  /** Tool Check In Items */
  toolCheckInItems?: Maybe<Array<ToolCheckInItems>>;
  /** Tool room id */
  toolRoomId?: Maybe<Scalars['ID']>;
};

export type ToolCheckInErrors = {
  __typename?: 'ToolCheckInErrors';
  error?: Maybe<CreateToolCheckInError>;
  toolCatalogId?: Maybe<Scalars['String']>;
  toolInventoryId?: Maybe<Scalars['String']>;
  toolRoomId?: Maybe<Scalars['String']>;
  warning?: Maybe<CreateToolCheckInWarning>;
};

export type ToolCheckInInput = {
  /** recipient id */
  recipientId: Scalars['String'];
  /** items */
  toolCheckInItems: Array<ToolCheckInItemsInput>;
  /** Tool room id */
  toolRoomId: Scalars['ID'];
};

export type ToolCheckInItems = {
  __typename?: 'ToolCheckInItems';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** The tool hound id of the person to whom the tool was issued to originally from toolhound. */
  originallyIssuedToThId?: Maybe<Scalars['String']>;
  /** Project id */
  projectId: Scalars['ID'];
  /** Check in quantity */
  quantity: Scalars['Int'];
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** Tool checkin id */
  toolCheckInId: Scalars['ID'];
  /** Tool inventory id */
  toolInventoryId?: Maybe<Scalars['ID']>;
};

export type ToolCheckInItemsInput = {
  /** Requestor comments */
  comments?: InputMaybe<Scalars['String']>;
  /** Check in quantity */
  quantity: Scalars['Int'];
  /** Status code */
  statusCode: InventoryStatus;
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** Tool inventory id */
  toolInventoryId: Scalars['ID'];
};

export type ToolCheckInResult = {
  __typename?: 'ToolCheckInResult';
  errors?: Maybe<Array<Maybe<ToolCheckInErrors>>>;
  toolCheckIn?: Maybe<ToolCheckIn>;
  warnings?: Maybe<Array<Maybe<ToolCheckInErrors>>>;
};

export type ToolHoundOutboundSubscriptionPayload = {
  __typename?: 'ToolHoundOutboundSubscriptionPayload';
  /** Unique Identifier of the Tool Room */
  referenceId: Scalars['ID'];
};

export type ToolInventory = {
  __typename?: 'ToolInventory';
  /** Bar code */
  barCode?: Maybe<Scalars['String']>;
  /** Bar code id */
  barCodeId?: Maybe<Scalars['String']>;
  /** Count Required */
  countRequired?: Maybe<Scalars['Boolean']>;
  /** Created by */
  createdBy: Scalars['String'];
  /** User object for createdBy prop */
  createdByUser?: Maybe<User>;
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Currently Issued To Id */
  currentlyIssuedToId?: Maybe<Scalars['String']>;
  /** User object for currentlyIssuedToId prop */
  currentlyIssuedToUser?: Maybe<User>;
  /** Deleted date */
  deletedDate?: Maybe<Scalars['Datetime']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** In transit count */
  inTransitCount?: Maybe<Scalars['Int']>;
  /** Is Locked */
  isLocked?: Maybe<Scalars['Boolean']>;
  /** Is the tool a serialized tool i.e. reusable tool. For eg. A drill */
  isSerialized: Scalars['Boolean'];
  /** Issued count */
  issuedCount?: Maybe<Scalars['Int']>;
  /** Limit Count */
  limitCount?: Maybe<Scalars['Int']>;
  /** On hand count */
  onHandCount?: Maybe<Scalars['Int']>;
  /** On order count */
  onOrderCount?: Maybe<Scalars['Int']>;
  /** Project ID */
  projectId: Scalars['ID'];
  /** Status code */
  statusCode?: Maybe<Scalars['Int']>;
  /** Th inventory id */
  thInventoryId?: Maybe<Scalars['String']>;
  /** Th inventory id identifier */
  thInventoryIdIdentifier?: Maybe<Scalars['String']>;
  /** Tool catalog */
  toolCatalog?: Maybe<ToolCatalog>;
  /** Tool Catalog ID */
  toolCatalogId: Scalars['ID'];
  /** Tool room */
  toolRoom?: Maybe<ToolRoom>;
  /** Tool Room ID */
  toolRoomId: Scalars['ID'];
  /** Total count */
  totalCount?: Maybe<Scalars['Int']>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** User object for createdBy prop */
  updatedByUser?: Maybe<User>;
  /** Updated date */
  updatedDate: Scalars['Datetime'];
  /** Vendor */
  vendor?: Maybe<Scalars['String']>;
};

export enum ToolInventoryError {
  TOOL_INVENTORY_STATS_NOT_FOUND = 'TOOL_INVENTORY_STATS_NOT_FOUND'
}

export type ToolInventoryInput = {
  toolCatalogIds?: InputMaybe<Array<Scalars['ID']>>;
  toolRoomId: Scalars['ID'];
};

export type ToolInventoryPhysicalCount = {
  __typename?: 'ToolInventoryPhysicalCount';
  /** Adjusted count */
  adjustedCount: Scalars['Int'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Last status by */
  lastStatusBy?: Maybe<Scalars['String']>;
  /** User object for lastStatusBy prop */
  lastStatusByUser?: Maybe<User>;
  /** Last status date */
  lastStatusDate?: Maybe<Scalars['Datetime']>;
  /** Original count */
  originalCount: Scalars['Int'];
  /** Physical count */
  physicalCount: Scalars['Int'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Status */
  status?: Maybe<Scalars['String']>;
  /** Tool inventory id */
  toolInventoryId: Scalars['ID'];
  /** Tool room id */
  toolRoomId: Scalars['ID'];
  /** Total count */
  totalCount: Scalars['Int'];
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']>;
  /** User object for updatedBy prop */
  updatedByUser?: Maybe<User>;
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolInventoryStats = {
  __typename?: 'ToolInventoryStats';
  /** On hand count */
  id?: Maybe<Scalars['ID']>;
  /** On hand count */
  onHandCount?: Maybe<Scalars['Int']>;
  /** Tool catalog id */
  toolCatalogId?: Maybe<Scalars['ID']>;
};

export type ToolInventoryStatsResult = {
  __typename?: 'ToolInventoryStatsResult';
  error?: Maybe<ToolInventoryError>;
  stats?: Maybe<Array<Maybe<ToolInventoryStats>>>;
};

export type ToolInventoryStatus = {
  __typename?: 'ToolInventoryStatus';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['Int'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolInventorySubscriptionPayload = {
  __typename?: 'ToolInventorySubscriptionPayload';
  /** Unique Identifier of the Tool Room */
  toolInventoryIds: Array<Maybe<Scalars['ID']>>;
  /** Tool Room Id */
  toolRoomId: Scalars['ID'];
  /** Last Updated date time of this tool room */
  updatedDate: Scalars['Datetime'];
};

export type ToolOrder = {
  __typename?: 'ToolOrder';
  /** Available Inventory */
  availableToolInventories?: Maybe<Array<ToolOrderAvailableInventory>>;
  /** Checked out by */
  checkedOutBy?: Maybe<Scalars['String']>;
  /** User object for checkedOutBy prop */
  checkedOutByUser?: Maybe<User>;
  /** Checked out date */
  checkedOutDate?: Maybe<Scalars['Datetime']>;
  /** Created by */
  createdBy: Scalars['String'];
  /** User object for createdBy prop */
  createdByUser?: Maybe<User>;
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Crew count */
  crewCount?: Maybe<Scalars['Int']>;
  /** Dispatched by */
  dispatchedBy?: Maybe<Scalars['String']>;
  /** User object for dispatchedBy prop */
  dispatchedByUser?: Maybe<User>;
  /** Id */
  id: Scalars['ID'];
  /** Order date */
  orderDate?: Maybe<Scalars['Datetime']>;
  /** Order number */
  orderNumber?: Maybe<Scalars['String']>;
  /**
   * Order placed for
   * @deprecated Use recipientId instead. It is a foreign key to the UserProjects object
   */
  orderPlacedFor: Scalars['String'];
  /**
   * User object for orderPlacedFor prop
   * @deprecated Use recipientEmployee instead. It represents the UserProject object for recipientId
   */
  orderPlacedForUser?: Maybe<User>;
  /** Out of stock Order */
  outOfStockToolOrder?: Maybe<ToolOrder>;
  /** Parent Tool Order */
  parentToolOrder?: Maybe<ToolOrder>;
  /** Parent tool order id */
  parentToolOrderId?: Maybe<Scalars['String']>;
  /** Prepped by */
  preppedBy?: Maybe<Scalars['String']>;
  /** Prepped date */
  preppedDate?: Maybe<Scalars['String']>;
  /** Project id */
  projectId: Scalars['ID'];
  /** User Project aka Employee object for recipientId prop */
  recipientEmployee?: Maybe<UserProject>;
  /** User project id of the person for whom order was placed for */
  recipientId: Scalars['String'];
  /** Required start date */
  requiredStartDate?: Maybe<Scalars['Datetime']>;
  /** Tool Order Catalog Statistics */
  stats: ToolOrderItemsStats;
  /** Status id */
  status: Scalars['String'];
  /** Tool order history */
  statusHistory: Array<ToolOrderHistory>;
  /** TH transaction Id */
  thTransactionId?: Maybe<Scalars['String']>;
  /** TH transaction no */
  thTransactionNo?: Maybe<Scalars['String']>;
  /** Tool order catalogs */
  toolOrderCatalogs?: Maybe<Array<ToolOrderCatalog>>;
  /** Tool room */
  toolRoom?: Maybe<ToolRoom>;
  /** Tool room id */
  toolRoomId: Scalars['ID'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolOrderAvailableInventory = {
  __typename?: 'ToolOrderAvailableInventory';
  /** Quantity On Hand */
  quantityOnHand?: Maybe<Scalars['Int']>;
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** Tool order id */
  toolOrderId: Scalars['ID'];
};

export type ToolOrderCatalog = {
  __typename?: 'ToolOrderCatalog';
  /** Already issued count */
  alreadyIssuedCount?: Maybe<Scalars['Int']>;
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Dispatcher comments */
  dispatcherComments?: Maybe<Scalars['String']>;
  /** Dispatcher comments by */
  dispatcherCommentsBy?: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** Non Catalog Description */
  nonCatalogDescription?: Maybe<Scalars['String']>;
  /** Non Catalog Reference Url */
  nonCatalogReferenceUrl?: Maybe<Scalars['String']>;
  /** Non Catalog Similar To Id */
  nonCatalogSimilarToId?: Maybe<Scalars['String']>;
  /** non Catalog Uom Id */
  nonCatalogUomId?: Maybe<Scalars['Int']>;
  /** Quantity */
  quantity: Scalars['Int'];
  /** Requester comments */
  requesterComments?: Maybe<Scalars['String']>;
  /** Requester comments by */
  requesterCommentsBy?: Maybe<Scalars['String']>;
  /** User object for requesterCommentsBy prop */
  requesterCommentsByUser?: Maybe<User>;
  /** Tool Catalog Similar */
  similarToolCatalog?: Maybe<ToolCatalog>;
  /** Tool Catalog */
  toolCatalog?: Maybe<ToolCatalog>;
  /** Tool catalog id */
  toolCatalogId?: Maybe<Scalars['ID']>;
  /** Tool order id */
  toolOrderId: Scalars['ID'];
  /** Tool order inventory */
  toolOrderInventories: Array<ToolOrderInventory>;
  /** Uom */
  uom?: Maybe<Uom>;
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']>;
  /** Updated date */
  updatedDate?: Maybe<Scalars['Datetime']>;
};

export type ToolOrderHistory = {
  __typename?: 'ToolOrderHistory';
  /** Created by */
  createdBy: Scalars['String'];
  /** User object for createdBy prop */
  createdByUser?: Maybe<User>;
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Tool Order Catalog Statistics */
  stats: ToolOrderItemsStats;
  /** Status */
  status: Scalars['String'];
  /** Tool order id */
  toolOrderId: Scalars['ID'];
};

export type ToolOrderInventory = {
  __typename?: 'ToolOrderInventory';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Dispatched quantity */
  dispatchQuantity: Scalars['Int'];
  /** Dispatcher comments */
  dispatcherComments?: Maybe<Scalars['String']>;
  /** Dispatcher comments by */
  dispatcherCommentsBy?: Maybe<Scalars['String']>;
  /** User object for dispatcherCommentsBy prop */
  dispatcherCommentsByUser?: Maybe<User>;
  /** Id */
  id: Scalars['ID'];
  /** Tool inventory status */
  status: Scalars['String'];
  /** Tool Inventory */
  toolInventory?: Maybe<ToolInventory>;
  /** Tool inventory id */
  toolInventoryId?: Maybe<Scalars['ID']>;
  /** Tool Order Catalog */
  toolOrderCatalog?: Maybe<ToolOrderCatalog>;
  /** Tool order catalog id */
  toolOrderCatalogId: Scalars['ID'];
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']>;
  /** Updated date */
  updatedDate?: Maybe<Scalars['Datetime']>;
};

export type ToolOrderInventoryCreatedSubscriptionPayload = {
  __typename?: 'ToolOrderInventoryCreatedSubscriptionPayload';
  /** Created By */
  createdBy: Scalars['String'];
  /** Created Date */
  createdDate: Scalars['Datetime'];
  /** Quantity Picked */
  quantityPicked: Scalars['Int'];
  /** Tool Order Catalog Id */
  toolOrderCatalogId: Scalars['ID'];
  /** Tool Order Id */
  toolOrderId: Scalars['ID'];
  /** Tool Order Inventory Id */
  toolOrderInventoryId: Scalars['ID'];
};

export enum ToolOrderInventoryStatus {
  NOT_FULFILLED = 'NOT_FULFILLED',
  OUTOFSTOCK = 'OUTOFSTOCK',
  PICKED = 'PICKED'
}

export type ToolOrderItemsStats = {
  __typename?: 'ToolOrderItemsStats';
  /** Total Count of consumables in order */
  consumablesCount?: Maybe<Scalars['Int']>;
  /** Id */
  id: Scalars['ID'];
  /** Total Count of tools in order */
  toolsCount?: Maybe<Scalars['Int']>;
};

export type ToolOrderStats = {
  __typename?: 'ToolOrderStats';
  /** Count of the orders for that particular status */
  orderCount: Scalars['ID'];
  /** Tool order status */
  status: Scalars['String'];
};

export enum ToolOrderStatsError {
  EITHER_USER_ID_OR_TOOL_ROOM_ID_REQUIRED = 'EITHER_USER_ID_OR_TOOL_ROOM_ID_REQUIRED',
  INVALID_USER_ID = 'INVALID_USER_ID',
  USER_ID_OR_TOOL_ROOM_ID_NULL = 'USER_ID_OR_TOOL_ROOM_ID_NULL'
}

export type ToolOrderStatsInput = {
  /** Tool Room ID for which stats are required. */
  toolRoomId?: InputMaybe<Scalars['ID']>;
  /** User for whom tool order stats are required */
  userId?: InputMaybe<Scalars['ID']>;
};

export type ToolOrderStatsResponse = {
  __typename?: 'ToolOrderStatsResponse';
  error?: Maybe<ToolOrderStatsError>;
  result?: Maybe<ToolOrderStatsResult>;
};

export type ToolOrderStatsResult = {
  __typename?: 'ToolOrderStatsResult';
  /** Cancelled order count */
  cancelledCount: Scalars['Int'];
  /** Completed order count */
  completedCount: Scalars['Int'];
  /** Stats ID */
  id: Scalars['ID'];
  /** Open orders count */
  openCount: Scalars['Int'];
  /** Out of stock orders count */
  outOfStockCount: Scalars['Int'];
  /** Prepared order count */
  preparedCount: Scalars['Int'];
};

export enum ToolOrderStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  OPEN = 'OPEN',
  OUTOFSTOCK = 'OUTOFSTOCK',
  OUTOFSTOCK_PARTIAL_READY = 'OUTOFSTOCK_PARTIAL_READY',
  PLACED = 'PLACED',
  PREPARED = 'PREPARED'
}

/** Not to be confused with the ToolOrderStatus enum this is for the data from the DB for the ToolOrder Status rows */
export type ToolOrderStatusData = {
  __typename?: 'ToolOrderStatusData';
  /** Description */
  description?: Maybe<Scalars['String']>;
  /** Id */
  id: Scalars['Int'];
  /** Sort order */
  sortOrder: Scalars['String'];
  /** Status */
  status: Scalars['String'];
};

export type ToolOrderStatusSubscriptionPayload = {
  __typename?: 'ToolOrderStatusSubscriptionPayload';
  /** Id */
  id: Scalars['ID'];
  /** Tool Order Status */
  toolOrderStatus?: Maybe<Scalars['String']>;
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolOrderSubscriptionPayload = {
  __typename?: 'ToolOrderSubscriptionPayload';
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Tool Order Status */
  toolOrderStatus?: Maybe<Scalars['String']>;
  /** Tool Room Id */
  toolRoomId: Scalars['ID'];
};

export type ToolOrderUpdatedSubscriptionPayload = {
  __typename?: 'ToolOrderUpdatedSubscriptionPayload';
  /** Id */
  id: Scalars['ID'];
  /** Tool Order Status */
  toolOrderStatus?: Maybe<Scalars['String']>;
  /** Tool Room Id */
  toolRoomId: Scalars['ID'];
  /** Created date */
  updatedDate: Scalars['Datetime'];
};

export type ToolRoom = {
  __typename?: 'ToolRoom';
  /** Is adoc active for this tool room */
  adhocEnabled?: Maybe<Scalars['Boolean']>;
  attendantIds?: Maybe<Array<Scalars['ID']>>;
  /** Attendent incharge of this Tool Room */
  attendants?: Maybe<Array<User>>;
  /** Bar code id of Tool Room */
  barCode: Scalars['String'];
  /** Description that states details about the Tool Room */
  description: Scalars['String'];
  /** Unique Identifier of the Tool Room */
  id: Scalars['ID'];
  /** Is this tool room active? */
  isActive: Scalars['Boolean'];
  /** Latitude */
  latitude?: Maybe<Scalars['Float']>;
  /** Longitude */
  longitude?: Maybe<Scalars['Float']>;
  /** Name of the Tool Room, usually to uniquely identify it on project */
  name: Scalars['String'];
  /** Project Id */
  projectId: Scalars['ID'];
  /** Tool hound location id of Tool Room */
  thLocationId: Scalars['String'];
  /** Is transfer active for this tool room */
  transferEnabled?: Maybe<Scalars['Boolean']>;
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']>;
  /** Last Updated date and time */
  updatedDate?: Maybe<Scalars['Datetime']>;
};

export type ToolRoomSubscriptionPayload = {
  __typename?: 'ToolRoomSubscriptionPayload';
  /** Unique Identifier of the Tool Room */
  toolRoomId: Scalars['ID'];
  /** Last Updated date time of this tool room */
  updatedDate: Scalars['Datetime'];
};

export type ToolTransfer = {
  __typename?: 'ToolTransfer';
  /** Comment */
  comment?: Maybe<Scalars['String']>;
  /** Created by */
  createdBy: Scalars['String'];
  /** User object for createdBy prop */
  createdByUser?: Maybe<User>;
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Destination tool room */
  destinationToolRoom?: Maybe<ToolRoom>;
  /** Destination tool room id */
  destinationToolRoomId: Scalars['ID'];
  /** Id */
  id: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Received by */
  receivedBy?: Maybe<Scalars['String']>;
  /** User object for receivedBy prop */
  receivedByUser?: Maybe<User>;
  /** Received date */
  receivedDate?: Maybe<Scalars['Datetime']>;
  /** Source action */
  sourceAction?: Maybe<Scalars['String']>;
  /** Source tool room */
  sourceToolRoom?: Maybe<ToolRoom>;
  /** Source tool room id */
  sourceToolRoomId: Scalars['ID'];
  /** Tool transfer stats */
  stats?: Maybe<ToolTransferStats>;
  /** Status */
  status: Scalars['String'];
  /** Th receipt id */
  thReceiptId?: Maybe<Scalars['String']>;
  /** Th transfer id */
  thTransferId?: Maybe<Scalars['String']>;
  /** Tool Transfer Items */
  toolTransferItems: Array<ToolTransferItem>;
  /** Tool transfer number */
  toolTransferNumber: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** User object for updatedBy prop */
  updatedByUser?: Maybe<User>;
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolTransferHistory = {
  __typename?: 'ToolTransferHistory';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Status */
  status: Scalars['String'];
  /** Tool transfer id */
  toolTransferId: Scalars['ID'];
  /** Tool transfer stats */
  toolTransferStats: Scalars['String'];
};

export type ToolTransferItem = {
  __typename?: 'ToolTransferItem';
  /** Created by */
  createdBy: Scalars['String'];
  /** User object for createdBy prop */
  createdByUser?: Maybe<User>;
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Received quantity */
  receivedQuantity?: Maybe<Scalars['Int']>;
  /** Requested quantity */
  requestedQuantity: Scalars['Int'];
  /** Tool Inventory */
  toolInventory?: Maybe<ToolInventory>;
  /** Tool inventory id */
  toolInventoryId: Scalars['ID'];
  /** Tool transfer id */
  toolTransferId: Scalars['ID'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** User object for updatedBy prop */
  updatedByUser?: Maybe<User>;
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolTransferStats = {
  __typename?: 'ToolTransferStats';
  /** Total Count of consumables in tool transfer */
  consumables?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Total Count of tools in tool transfer */
  tools?: Maybe<Scalars['Int']>;
};

export enum ToolTransferStatuses {
  CANCELLED = 'CANCELLED',
  RECEIVED = 'RECEIVED',
  REQUESTED = 'REQUESTED'
}

export type ToolType = {
  __typename?: 'ToolType';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Name */
  name: Scalars['String'];
  /** Tool hound id */
  toolHoundId: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type ToolUserFavorite = {
  __typename?: 'ToolUserFavorite';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** is Favorite */
  isFavorite?: Maybe<Scalars['Boolean']>;
  /** Project id */
  projectId?: Maybe<Scalars['ID']>;
  /** Tool Catalog */
  toolCatalog?: Maybe<ToolCatalog>;
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
  /** User id */
  userId: Scalars['ID'];
};

export type ToolUserFavoriteStats = {
  __typename?: 'ToolUserFavoriteStats';
  /** Consumable count */
  consumables: Scalars['Int'];
  /** id */
  id: Scalars['ID'];
  /** Tools count */
  tools: Scalars['Int'];
};

export type Uom = {
  __typename?: 'Uom';
  /** Abbreviation */
  abbreviation: Scalars['String'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['Int'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export enum UpdateCrewError {
  FAILED_TO_UPDATE_CREW = 'FAILED_TO_UPDATE_CREW',
  INVALID_CREW = 'INVALID_CREW'
}

export type UpdateCrewInput = {
  /** Crew number */
  crewNumber: Scalars['String'];
  /** Foreman id */
  foremanId?: InputMaybe<Scalars['ID']>;
  /** General foreman id */
  generalForemanId?: InputMaybe<Scalars['ID']>;
  /** Id */
  id: Scalars['ID'];
  /** Superintendent id */
  superintendentId?: InputMaybe<Scalars['ID']>;
};

export type UpdateCrewResult = {
  __typename?: 'UpdateCrewResult';
  crew?: Maybe<Crew>;
  errors?: Maybe<Array<UpdateCrewError>>;
};

export enum UpdateEmployeePhotosError {
  EMPLOYEE_IMAGE_NOT_FOUND = 'EMPLOYEE_IMAGE_NOT_FOUND',
  FAILED_TO_UPDATE_EMPLOYEE_PHOTOS = 'FAILED_TO_UPDATE_EMPLOYEE_PHOTOS',
  INVALID_EMPLOYEE_PHOTOS = 'INVALID_EMPLOYEE_PHOTOS'
}

export type UpdateEmployeePhotosInput = {
  /** Id */
  id: Scalars['ID'];
  /** Thumbnail */
  thumbnail: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type UpdateEmployeePhotosResult = {
  __typename?: 'UpdateEmployeePhotosResult';
  employeePhotos?: Maybe<EmployeePhotos>;
  errors?: Maybe<Array<UpdateEmployeePhotosError>>;
};

export type UpdateInboundControlsInput = {
  endDate?: InputMaybe<Scalars['Datetime']>;
  /** Error details */
  errorDetails?: InputMaybe<Scalars['String']>;
  /** Error summray */
  errorSummary?: InputMaybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** Import summray */
  importSummary?: InputMaybe<Scalars['JSON']>;
  /** Interface id */
  interfaceId: Scalars['ID'];
  /** Project id */
  projectId?: InputMaybe<Scalars['ID']>;
  /** Status */
  status: Scalars['String'];
  /** Updated date */
  updatedDate?: InputMaybe<Scalars['Datetime']>;
};

export enum UpdateOutboundInterfaceError {
  FAILED_TO_UPDATE_OUTBOUND_INTERFACE = 'FAILED_TO_UPDATE_OUTBOUND_INTERFACE',
  INVALID_OUTBOUND_INTERFACE = 'INVALID_OUTBOUND_INTERFACE'
}

export type UpdateOutboundInterfaceInput = {
  /** Error type */
  errorType?: InputMaybe<OutboundErrorType>;
  /** Id */
  id: Scalars['ID'];
  /** Next schedule date */
  nextScheduleDate?: InputMaybe<Scalars['Datetime']>;
  /** referenceId */
  referenceId?: InputMaybe<Scalars['String']>;
  /** Response */
  response?: InputMaybe<Scalars['String']>;
  /** Status */
  status: OutboundStatus;
  /** Updated By */
  updatedBy: Scalars['String'];
  /** Updated Date */
  updatedDate: Scalars['Datetime'];
};

export type UpdateOutboundInterfaceResult = {
  __typename?: 'UpdateOutboundInterfaceResult';
  errors?: Maybe<Array<UpdateOutboundInterfaceError>>;
  outboundInterface?: Maybe<OutboundInterface>;
};

export enum UpdateOutboundRetryError {
  FAILED_TO_UPDATE_OUTBOUND_RETRY = 'FAILED_TO_UPDATE_OUTBOUND_RETRY',
  INVALID_OUTBOUND_RETRY = 'INVALID_OUTBOUND_RETRY'
}

export type UpdateOutboundRetryInput = {
  /** Action type */
  actionType: OutboundRetryActionType;
  /** Error type */
  errorType?: InputMaybe<OutboundErrorType>;
  /** Id */
  id: Scalars['ID'];
  /** Next schedule date */
  nextScheduleDate: Scalars['Datetime'];
  /** Outbound interface id */
  outboundInterfaceId: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Response */
  response?: InputMaybe<Scalars['String']>;
  /** Retry count */
  retryCount: Scalars['Int'];
  /** Status */
  status: OutboundStatus;
};

export type UpdateOutboundRetryResult = {
  __typename?: 'UpdateOutboundRetryResult';
  errors?: Maybe<Array<UpdateOutboundRetryError>>;
  outboundRetry?: Maybe<OutboundRetry>;
};

export enum UpdatePermissionError {
  FAILED_TO_UPDATE_PERMISSION = 'FAILED_TO_UPDATE_PERMISSION',
  INVALID_PERMISSION = 'INVALID_PERMISSION'
}

export type UpdatePermissionInput = {
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
  /** Name */
  name: Scalars['String'];
};

export type UpdatePermissionResult = {
  __typename?: 'UpdatePermissionResult';
  errors?: Maybe<Array<UpdatePermissionError>>;
  permission?: Maybe<Permission>;
};

export enum UpdateProjectConfigurationError {
  FAILED_TO_UPDATE_PROJECT_CONFIGURATION = 'FAILED_TO_UPDATE_PROJECT_CONFIGURATION',
  INVALID_PROJECT_CONFIGURATION = 'INVALID_PROJECT_CONFIGURATION'
}

export type UpdateProjectConfigurationInput = {
  /** Configuration name */
  configurationName: Scalars['String'];
  /** Configuration value */
  configurationValue: Scalars['JSON'];
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type UpdateProjectConfigurationResult = {
  __typename?: 'UpdateProjectConfigurationResult';
  errors?: Maybe<Array<UpdateProjectConfigurationError>>;
  projectConfiguration?: Maybe<ProjectConfiguration>;
};

export enum UpdateProjectToolCatalogError {
  FAILED_TO_UPDATE_PROJECT_TOOL_CATALOG = 'FAILED_TO_UPDATE_PROJECT_TOOL_CATALOG',
  INVALID_PROJECT_TOOL_CATALOG = 'INVALID_PROJECT_TOOL_CATALOG'
}

export type UpdateProjectToolCatalogInput = {
  /** Id */
  id: Scalars['ID'];
  /** Is Locked */
  isLocked?: InputMaybe<Scalars['Boolean']>;
  /** Limit Count */
  limitCount?: InputMaybe<Scalars['Int']>;
  /** Project id */
  projectId?: InputMaybe<Scalars['ID']>;
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
};

export type UpdateProjectToolCatalogResult = {
  __typename?: 'UpdateProjectToolCatalogResult';
  errors?: Maybe<Array<UpdateProjectToolCatalogError>>;
  projectToolCatalog?: Maybe<ProjectToolCatalog>;
};

export enum UpdateRoleError {
  FAILED_TO_UPDATE_ROLE = 'FAILED_TO_UPDATE_ROLE',
  INVALID_ROLE = 'INVALID_ROLE'
}

export type UpdateRoleInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export enum UpdateRolePermissionScopeError {
  FAILED_TO_UPDATE_ROLE_PERMISSION_SCOPE = 'FAILED_TO_UPDATE_ROLE_PERMISSION_SCOPE',
  INVALID_ROLE_PERMISSION_SCOPE = 'INVALID_ROLE_PERMISSION_SCOPE'
}

export type UpdateRolePermissionScopeInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Permission id */
  permissionId: Scalars['ID'];
  /** Role id */
  roleId: Scalars['ID'];
  /** Scope id */
  scopeId: Scalars['Int'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type UpdateRolePermissionScopeResult = {
  __typename?: 'UpdateRolePermissionScopeResult';
  errors?: Maybe<Array<UpdateRolePermissionScopeError>>;
  rolePermissionScope?: Maybe<RolePermissionScope>;
};

export type UpdateRoleResult = {
  __typename?: 'UpdateRoleResult';
  errors?: Maybe<Array<UpdateRoleError>>;
  role?: Maybe<Role>;
};

export enum UpdateScopeError {
  FAILED_TO_UPDATE_SCOPE = 'FAILED_TO_UPDATE_SCOPE',
  INVALID_SCOPE = 'INVALID_SCOPE'
}

export type UpdateScopeInput = {
  /** Id */
  id: Scalars['Int'];
  /** Name */
  name: Scalars['String'];
};

export type UpdateScopeResult = {
  __typename?: 'UpdateScopeResult';
  errors?: Maybe<Array<UpdateScopeError>>;
  scope?: Maybe<Scope>;
};

export enum UpdateToolCatalogError {
  FAILED_TO_UPDATE_TOOL_CATALOG = 'FAILED_TO_UPDATE_TOOL_CATALOG'
}

export enum UpdateToolCatalogImageError {
  FAILED_TO_UPDATE_TOOL_CATALOG_IMAGE = 'FAILED_TO_UPDATE_TOOL_CATALOG_IMAGE',
  INVALID_TOOL_CATALOG_IMAGE = 'INVALID_TOOL_CATALOG_IMAGE'
}

export type UpdateToolCatalogImageInput = {
  /** Id */
  id: Scalars['ID'];
  /** Thumbnail */
  thumbnail: Scalars['String'];
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type UpdateToolCatalogImageResult = {
  __typename?: 'UpdateToolCatalogImageResult';
  errors?: Maybe<Array<UpdateToolCatalogImageError>>;
  toolCatalogImage?: Maybe<ToolCatalogImage>;
};

export type UpdateToolCatalogInput = {
  /** Bscn part number */
  bscnPartNumber: Scalars['String'];
  /** Unique Identifier of the Tool Room */
  id: Scalars['ID'];
  /** Inventory Type */
  inventoryType?: InputMaybe<Scalars['String']>;
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Is Locked */
  isLocked?: InputMaybe<Scalars['Boolean']>;
  /** Limit Count */
  limitCount?: InputMaybe<Scalars['Int']>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** ToolHound Tool Catalog Id */
  thToolCatalogId?: InputMaybe<Scalars['String']>;
  /** Tool category id */
  toolCategoryId: Scalars['ID'];
  /** Uom */
  uomId?: InputMaybe<Scalars['Int']>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
};

export type UpdateToolCatalogResult = {
  __typename?: 'UpdateToolCatalogResult';
  /** Error */
  error?: Maybe<UpdateToolCatalogError>;
  /** Tool Room updated with the mutation */
  toolRoom?: Maybe<ToolCatalog>;
};

export enum UpdateToolCategoryError {
  FAILED_TO_UPDATE_TOOL_CATEGORY = 'FAILED_TO_UPDATE_TOOL_CATEGORY'
}

export type UpdateToolCategoryInput = {
  /** Unique Identifier of the Tool Room */
  id: Scalars['ID'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Name */
  name: Scalars['String'];
  /** Tool hound id */
  toolHoundId: Scalars['String'];
  /** Tool type id */
  toolTypeId: Scalars['ID'];
  /** Updated By */
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type UpdateToolCategoryResult = {
  __typename?: 'UpdateToolCategoryResult';
  /** Error */
  error?: Maybe<UpdateToolCategoryError>;
  /** Tool Room updated with the mutation */
  toolRoom?: Maybe<ToolCategory>;
};

export enum UpdateToolCheckInError {
  FAILED_TO_UPDATE_TOOL_CHECK_IN = 'FAILED_TO_UPDATE_TOOL_CHECK_IN',
  INVALID_TOOL_CHECK_IN = 'INVALID_TOOL_CHECK_IN'
}

export type UpdateToolCheckInInput = {
  /** Check in number */
  checkInNumber: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
  /** Th transaction id */
  thTransactionId: Scalars['String'];
  /** Tool room id */
  toolRoomId: Scalars['ID'];
};

export enum UpdateToolCheckInItemsError {
  FAILED_TO_UPDATE_TOOL_CHECK_IN_ITEMS = 'FAILED_TO_UPDATE_TOOL_CHECK_IN_ITEMS',
  INVALID_TOOL_CHECK_IN_ITEMS = 'INVALID_TOOL_CHECK_IN_ITEMS'
}

export type UpdateToolCheckInItemsInput = {
  /** Id */
  id: Scalars['ID'];
  /** Check in quantity */
  quantity: Scalars['Int'];
  /** Tool catalog id */
  toolCatalogId: Scalars['ID'];
  /** Tool checkin id */
  toolCheckInId: Scalars['ID'];
  /** Tool inventory id */
  toolInventoryId?: InputMaybe<Scalars['ID']>;
};

export type UpdateToolCheckInItemsResult = {
  __typename?: 'UpdateToolCheckInItemsResult';
  errors?: Maybe<Array<UpdateToolCheckInItemsError>>;
  toolCheckInItems?: Maybe<ToolCheckInItems>;
};

export type UpdateToolCheckInResult = {
  __typename?: 'UpdateToolCheckInResult';
  errors?: Maybe<Array<UpdateToolCheckInError>>;
  toolCheckIn?: Maybe<ToolCheckIn>;
};

export enum UpdateToolInventoryError {
  FAILED_TO_UPDATE_TOOL_INVENTORY = 'FAILED_TO_UPDATE_TOOL_INVENTORY',
  INVALID_TOOL_INVENTORY = 'INVALID_TOOL_INVENTORY'
}

export type UpdateToolInventoryInput = {
  /** Count Required */
  countRequired?: InputMaybe<Scalars['Boolean']>;
  /** Currently Issued To Id */
  currentlyIssuedToId?: InputMaybe<Scalars['String']>;
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** Is Locked */
  isLocked?: InputMaybe<Scalars['Boolean']>;
  /** Issued count */
  issuedCount?: InputMaybe<Scalars['Int']>;
  /** Limit Count */
  limitCount?: InputMaybe<Scalars['Int']>;
  /** On Hand count */
  onHandCount?: InputMaybe<Scalars['Int']>;
  /** Total count */
  totalCount?: InputMaybe<Scalars['Int']>;
};

export enum UpdateToolInventoryPhysicalCountError {
  FAILED_TO_UPDATE_TOOL_INVENTORY_PHYSICAL_COUNT = 'FAILED_TO_UPDATE_TOOL_INVENTORY_PHYSICAL_COUNT',
  INVALID_TOOL_INVENTORY_PHYSICAL_COUNT = 'INVALID_TOOL_INVENTORY_PHYSICAL_COUNT'
}

export type UpdateToolInventoryPhysicalCountInput = {
  /** Adjusted count */
  adjustedCount: Scalars['Int'];
  /** Id */
  id: Scalars['ID'];
  /** Last status by */
  lastStatusBy?: InputMaybe<Scalars['String']>;
  /** Last status date */
  lastStatusDate?: InputMaybe<Scalars['Datetime']>;
  /** Original count */
  originalCount: Scalars['Int'];
  /** Physical count */
  physicalCount: Scalars['Int'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Status */
  status?: InputMaybe<Scalars['String']>;
  /** Tool inventory id */
  toolInventoryId: Scalars['ID'];
  /** Tool room id */
  toolRoomId: Scalars['ID'];
  /** Total count */
  totalCount: Scalars['Int'];
};

export type UpdateToolInventoryPhysicalCountResult = {
  __typename?: 'UpdateToolInventoryPhysicalCountResult';
  errors?: Maybe<Array<UpdateToolInventoryPhysicalCountError>>;
  toolInventoryPhysicalCount?: Maybe<ToolInventoryPhysicalCount>;
};

export type UpdateToolInventoryResult = {
  __typename?: 'UpdateToolInventoryResult';
  errors?: Maybe<Array<UpdateToolInventoryError>>;
  toolInventory?: Maybe<ToolInventory>;
};

export enum UpdateToolInventoryStatusError {
  FAILED_TO_UPDATE_TOOL_INVENTORY_STATUS = 'FAILED_TO_UPDATE_TOOL_INVENTORY_STATUS',
  INVALID_TOOL_INVENTORY_STATUS = 'INVALID_TOOL_INVENTORY_STATUS'
}

export type UpdateToolInventoryStatusInput = {
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['Int'];
  /** Updated by */
  updatedBy: Scalars['String'];
};

export type UpdateToolInventoryStatusResult = {
  __typename?: 'UpdateToolInventoryStatusResult';
  errors?: Maybe<Array<UpdateToolInventoryStatusError>>;
  toolInventoryStatus?: Maybe<ToolInventoryStatus>;
};

export enum UpdateToolOrderCatalogError {
  FAILED_TO_UPDATE_TOOL_ORDER_CATALOG = 'FAILED_TO_UPDATE_TOOL_ORDER_CATALOG',
  INVALID_TOOL_ORDER_CATALOG = 'INVALID_TOOL_ORDER_CATALOG'
}

export type UpdateToolOrderCatalogInput = {
  /** Dispatcher comments */
  dispatcherComments?: InputMaybe<Scalars['String']>;
  /** Dispatcher comments by */
  dispatcherCommentsBy?: InputMaybe<Scalars['String']>;
  /** Id */
  id?: InputMaybe<Scalars['ID']>;
  /** Non Catalog Description */
  nonCatalogDescription?: InputMaybe<Scalars['String']>;
  /** Non Catalog Reference Url */
  nonCatalogReferenceUrl?: InputMaybe<Scalars['String']>;
  /** Non Catalog Similar To Id */
  nonCatalogSimilarToId?: InputMaybe<Scalars['String']>;
  /** non Catalog Uom Id */
  nonCatalogUomId?: InputMaybe<Scalars['Int']>;
  /** Quantity */
  quantity: Scalars['Int'];
  /** Requester comments */
  requesterComments?: InputMaybe<Scalars['String']>;
  /** Requester comments by */
  requesterCommentsBy?: InputMaybe<Scalars['String']>;
  /** Tool catalog id */
  toolCatalogId?: InputMaybe<Scalars['ID']>;
  /** Tool order id */
  toolOrderId?: InputMaybe<Scalars['ID']>;
};

export type UpdateToolOrderCatalogResult = {
  __typename?: 'UpdateToolOrderCatalogResult';
  errors?: Maybe<Array<UpdateToolOrderCatalogError>>;
  toolOrderCatalog?: Maybe<ToolOrderCatalog>;
};

export enum UpdateToolOrderError {
  CATALOG_QUANTITY_CAN_NOT_BE_ZERO = 'CATALOG_QUANTITY_CAN_NOT_BE_ZERO',
  FAILED_TO_UPDATE_TOOL_ORDER = 'FAILED_TO_UPDATE_TOOL_ORDER',
  INVALID_ADVANCEMENT_OF_TOOL_ORDER = 'INVALID_ADVANCEMENT_OF_TOOL_ORDER',
  INVALID_REQUIRED_START_DATE = 'INVALID_REQUIRED_START_DATE',
  INVALID_TOOL_ROOM_ID = 'INVALID_TOOL_ROOM_ID',
  ORDER_DATE_REQUIRED_AFTER_DRAFT = 'ORDER_DATE_REQUIRED_AFTER_DRAFT',
  ORDER_LIMIT_EXEEDS = 'ORDER_LIMIT_EXEEDS',
  REQUESTER_DOESNT_HAVE_TOOL_HOUND_ID = 'REQUESTER_DOESNT_HAVE_TOOL_HOUND_ID',
  TOOL_ORDER_NOT_FOUND = 'TOOL_ORDER_NOT_FOUND'
}

export enum UpdateToolOrderHistoryError {
  FAILED_TO_UPDATE_TOOL_ORDER_HISTORY = 'FAILED_TO_UPDATE_TOOL_ORDER_HISTORY',
  INVALID_TOOL_ORDER_HISTORY = 'INVALID_TOOL_ORDER_HISTORY'
}

export type UpdateToolOrderHistoryInput = {
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Status */
  status: Scalars['String'];
  /** Tool order id */
  toolOrderId: Scalars['ID'];
};

export type UpdateToolOrderHistoryResult = {
  __typename?: 'UpdateToolOrderHistoryResult';
  errors?: Maybe<Array<UpdateToolOrderHistoryError>>;
  toolOrderHistory?: Maybe<ToolOrderHistory>;
};

export type UpdateToolOrderInput = {
  /** Checked out by */
  checkedOutBy?: InputMaybe<Scalars['String']>;
  /** Checked out date */
  checkedOutDate?: InputMaybe<Scalars['Datetime']>;
  /** Dispatched by */
  dispatchedBy?: InputMaybe<Scalars['String']>;
  /** Tool order id */
  id: Scalars['ID'];
  /** Order date */
  orderDate?: InputMaybe<Scalars['Datetime']>;
  /** Order placed for */
  orderPlacedFor: Scalars['String'];
  /** Parent tool order id */
  parentToolOrderId?: InputMaybe<Scalars['String']>;
  /** Prepped by */
  preppedBy?: InputMaybe<Scalars['String']>;
  /** Prepped date */
  preppedDate?: InputMaybe<Scalars['String']>;
  /** project id */
  projectId: Scalars['String'];
  /** Recipient ID */
  recipientId: Scalars['String'];
  /** Required start date */
  requiredStartDate: Scalars['Datetime'];
  /** Status id */
  status: ToolOrderStatus;
  /** tool order catalog */
  toolOrderCatalog: Array<InputMaybe<UpdateToolOrderCatalogInput>>;
  /** Tool room id */
  toolRoomId: Scalars['ID'];
};

export enum UpdateToolOrderInventoryError {
  FAILED_TO_UPDATE_TOOL_ORDER_INVENTORY = 'FAILED_TO_UPDATE_TOOL_ORDER_INVENTORY',
  INVALID_TOOL_ORDER_INVENTORY = 'INVALID_TOOL_ORDER_INVENTORY'
}

export type UpdateToolOrderInventoryInput = {
  /** Dispatched quantity */
  dispatchQuantity: Scalars['Int'];
  /** Dispatcher comments */
  dispatcherComments?: InputMaybe<Scalars['String']>;
  /** Dispatcher comments by */
  dispatcherCommentsBy?: InputMaybe<Scalars['String']>;
  /** Id */
  id: Scalars['ID'];
  /** Tool inventory status */
  status: ToolOrderInventoryStatus;
  /** Tool inventory id */
  toolInventoryId?: InputMaybe<Scalars['ID']>;
  /** Tool order catalog id */
  toolOrderCatalogId: Scalars['ID'];
};

export type UpdateToolOrderInventoryResult = {
  __typename?: 'UpdateToolOrderInventoryResult';
  errors?: Maybe<Array<UpdateToolOrderInventoryError>>;
  toolOrderInventory?: Maybe<ToolOrderInventory>;
};

export type UpdateToolOrderResult = {
  __typename?: 'UpdateToolOrderResult';
  error?: Maybe<UpdateToolOrderError>;
  /** Tool Order updated with the mutation */
  toolOrder?: Maybe<ToolOrder>;
};

export enum UpdateToolRoomError {
  TOOL_ROOM_NOT_FOUND = 'TOOL_ROOM_NOT_FOUND'
}

export type UpdateToolRoomInput = {
  /** Is adhoc available? */
  adhocEnabled: Scalars['Boolean'];
  /** Bar code id of Tool Room */
  barCode: Scalars['String'];
  /** Description that states details about the Tool Room */
  description: Scalars['String'];
  /** Unique Identifier of the Tool Room */
  id: Scalars['ID'];
  /** Is this tool room active? */
  isActive: Scalars['Boolean'];
  /** Latitude */
  latitude?: InputMaybe<Scalars['Float']>;
  /** Longitude */
  longitude?: InputMaybe<Scalars['Float']>;
  /** Name of the Tool Room, usually to uniquely identify it on project */
  name: Scalars['String'];
  /** Tool hound location id of Tool Room */
  thLocationId: Scalars['String'];
  /** Is transfer available? */
  transferEnabled: Scalars['Boolean'];
  /** Updated By */
  updatedBy: Scalars['String'];
};

export type UpdateToolRoomResult = {
  __typename?: 'UpdateToolRoomResult';
  /** Error */
  error?: Maybe<UpdateToolRoomError>;
  /** Tool Room updated with the mutation */
  toolRoom?: Maybe<ToolRoom>;
};

export enum UpdateToolTransferError {
  FAILED_TO_UPDATE_TOOL_TRANSFER = 'FAILED_TO_UPDATE_TOOL_TRANSFER',
  INVALID_TOOL_TRANSFER = 'INVALID_TOOL_TRANSFER'
}

export type UpdateToolTransferInput = {
  /** Comment */
  comment?: InputMaybe<Scalars['String']>;
  /** Destination tool room id */
  destinationToolRoomId: Scalars['ID'];
  /** Id */
  id: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Received by */
  receivedBy?: InputMaybe<Scalars['String']>;
  /** Received date */
  receivedDate?: InputMaybe<Scalars['Datetime']>;
  /** Source action */
  sourceAction?: InputMaybe<Scalars['String']>;
  /** Source tool room id */
  sourceToolRoomId: Scalars['ID'];
  /** Status */
  status: Scalars['String'];
  /** Th receipt id */
  thReceiptId?: InputMaybe<Scalars['String']>;
  /** Th transfer id */
  thTransferId?: InputMaybe<Scalars['String']>;
  /** Tool transfer number */
  toolTransferNumber: Scalars['String'];
};

export enum UpdateToolTransferItemError {
  FAILED_TO_UPDATE_TOOL_TRANSFER_ITEM = 'FAILED_TO_UPDATE_TOOL_TRANSFER_ITEM',
  INVALID_TOOL_TRANSFER_ITEM = 'INVALID_TOOL_TRANSFER_ITEM'
}

export type UpdateToolTransferItemInput = {
  /** Id */
  id: Scalars['ID'];
  /** Project id */
  projectId: Scalars['ID'];
  /** Received quantity */
  receivedQuantity?: InputMaybe<Scalars['Int']>;
  /** Requested quantity */
  requestedQuantity: Scalars['Int'];
  /** Tool inventory id */
  toolInventoryId: Scalars['ID'];
  /** Tool transfer id */
  toolTransferId: Scalars['ID'];
};

export type UpdateToolTransferItemResult = {
  __typename?: 'UpdateToolTransferItemResult';
  errors?: Maybe<Array<UpdateToolTransferItemError>>;
  toolTransferItem?: Maybe<ToolTransferItem>;
};

export type UpdateToolTransferResult = {
  __typename?: 'UpdateToolTransferResult';
  errors?: Maybe<Array<UpdateToolTransferError>>;
  toolTransfer?: Maybe<ToolTransfer>;
};

export enum UpdateUomError {
  FAILED_TO_UPDATE_UOM = 'FAILED_TO_UPDATE_UOM',
  INVALID_UOM = 'INVALID_UOM'
}

export type UpdateUomInput = {
  /** Abbreviation */
  abbreviation: Scalars['String'];
  /** Description */
  description: Scalars['String'];
  /** Id */
  id: Scalars['Int'];
};

export type UpdateUomResult = {
  __typename?: 'UpdateUomResult';
  errors?: Maybe<Array<UpdateUomError>>;
  uom?: Maybe<Uom>;
};

export type UpdateUserAccountInput = {
  /** Login name */
  bun?: InputMaybe<Scalars['String']>;
  /** Exempted from import */
  exemptedFromImport?: InputMaybe<Scalars['Boolean']>;
  /** Id */
  id: Scalars['ID'];
  /** User active status */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** lobEmployeeId */
  lobEmployeeId: Scalars['String'];
  /** First name of the User */
  nameFirst: Scalars['String'];
  /** Last name of the User */
  nameLast: Scalars['String'];
  /** Middle name of the User */
  nameMiddle?: InputMaybe<Scalars['String']>;
  /** Persona */
  persona?: InputMaybe<Scalars['String']>;
  /** Role Id */
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Supervisor Id */
  supervisorId?: InputMaybe<Scalars['ID']>;
  /** Tool Room Ids */
  toolRoomIds?: InputMaybe<Array<Scalars['ID']>>;
  /** UPN */
  upn?: InputMaybe<Scalars['String']>;
};

export type UpdateUserAccountResult = {
  __typename?: 'UpdateUserAccountResult';
  /** Error */
  error?: Maybe<UpdateUserError>;
  /** User reated during the mutation */
  userAccount?: Maybe<User>;
};

export enum UpdateUserDefaultProjectError {
  FAILED_TO_UPDATE_USER_PROJECT = 'FAILED_TO_UPDATE_USER_PROJECT',
  INVALID_PROJECT = 'INVALID_PROJECT',
  INVALID_USER = 'INVALID_USER'
}

export type UpdateUserDefaultProjectInput = {
  projectId: Scalars['ID'];
};

export type UpdateUserDefaultProjectResult = {
  __typename?: 'UpdateUserDefaultProjectResult';
  errors?: Maybe<Array<Maybe<UpdateUserDefaultProjectError>>>;
  user?: Maybe<User>;
};

export enum UpdateUserError {
  DUPLICATE = 'DUPLICATE',
  NO_CORRESPONDING_TH6_ROLE = 'NO_CORRESPONDING_TH6_ROLE',
  SEARCH_USER_API_FAIL = 'SEARCH_USER_API_FAIL',
  USER_NOT_FOUND = 'USER_NOT_FOUND'
}

export type UpdateUserInput = {
  /** Login name */
  bun?: InputMaybe<Scalars['String']>;
  /** User email */
  email?: InputMaybe<Scalars['String']>;
  /** Exempted from import */
  exemptedFromImport?: InputMaybe<Scalars['Boolean']>;
  /** First name of the User */
  firstName: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
  /** User active status */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Last name of the User */
  lastName: Scalars['String'];
  /** lobEmployeeId */
  lobEmployeeId: Scalars['String'];
  /** Middle name of the User */
  middleName?: InputMaybe<Scalars['String']>;
  /** Persona */
  persona?: InputMaybe<Scalars['String']>;
  /** Role Id */
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Supervisor Id */
  supervisorId?: InputMaybe<Scalars['ID']>;
  /** Tool Room Ids */
  toolRoomIds?: InputMaybe<Array<Scalars['ID']>>;
  /** UPN */
  upn?: InputMaybe<Scalars['String']>;
};

export enum UpdateUserProjectError {
  FAILED_TO_UPDATE_USER_PROJECT = 'FAILED_TO_UPDATE_USER_PROJECT',
  INVALID_USER_PROJECT = 'INVALID_USER_PROJECT'
}

export type UpdateUserProjectInput = {
  /** Badge barcode id */
  badgeBarcodeId?: InputMaybe<Scalars['String']>;
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Crew number */
  crewNumber?: InputMaybe<Scalars['String']>;
  /** Email */
  email?: InputMaybe<Scalars['String']>;
  /** First name */
  firstName: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Last name */
  lastName: Scalars['String'];
  /** Lob employee id */
  lobEmployeeId: Scalars['String'];
  /** Middle name */
  middleName?: InputMaybe<Scalars['String']>;
  /** Persona */
  persona?: InputMaybe<Scalars['String']>;
  /** Project id */
  projectId: Scalars['ID'];
  /** Supervisor id */
  supervisorId?: InputMaybe<Scalars['String']>;
  /** Tool hound user id */
  thUserId?: InputMaybe<Scalars['String']>;
  /** Tool hound user login */
  thUserLogin?: InputMaybe<Scalars['String']>;
  /** Tool hound id */
  toolHoundId?: InputMaybe<Scalars['String']>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
  /** User id */
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateUserProjectResult = {
  __typename?: 'UpdateUserProjectResult';
  errors?: Maybe<Array<UpdateUserProjectError>>;
  userProject?: Maybe<UserProject>;
};

export type UpdateUserResult = {
  __typename?: 'UpdateUserResult';
  /** Error */
  error?: Maybe<UpdateUserError>;
  /** User reated during the mutation */
  userAccount?: Maybe<User>;
};

export enum UpdateUserRoleError {
  FAILED_TO_UPDATE_USER_ROLE = 'FAILED_TO_UPDATE_USER_ROLE',
  INVALID_USER_ROLE = 'INVALID_USER_ROLE'
}

export type UpdateUserRoleInput = {
  /** Id */
  id: Scalars['ID'];
  /** Role id */
  roleId: Scalars['ID'];
  /** User id */
  userId: Scalars['ID'];
};

export type UpdateUserRoleResult = {
  __typename?: 'UpdateUserRoleResult';
  errors?: Maybe<Array<UpdateUserRoleError>>;
  userRole?: Maybe<UserRole>;
};

export enum UpdateUserToolRoomError {
  FAILED_TO_UPDATE_USER_TOOL_ROOM = 'FAILED_TO_UPDATE_USER_TOOL_ROOM',
  INVALID_USER_TOOL_ROOM = 'INVALID_USER_TOOL_ROOM'
}

export type UpdateUserToolRoomInput = {
  /** Id */
  id: Scalars['ID'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Tool room id */
  toolRoomId: Scalars['ID'];
  /** User id */
  userId: Scalars['ID'];
};

export type UpdateUserToolRoomResult = {
  __typename?: 'UpdateUserToolRoomResult';
  errors?: Maybe<Array<UpdateUserToolRoomError>>;
  userToolRoom?: Maybe<UserToolRoom>;
};

export type User = {
  __typename?: 'User';
  /** BUN */
  bun: Scalars['String'];
  /** Default Project */
  defaultProject?: Maybe<Project>;
  /** Default project id */
  defaultProjectId: Scalars['ID'];
  /** User email */
  email?: Maybe<Scalars['String']>;
  /** Employee record of the user for their default project */
  employee?: Maybe<UserProject>;
  /**
   * Employee Image Url
   * @deprecated Use employee.imageUrl instead
   */
  employeeImageUrl?: Maybe<Scalars['String']>;
  /** First name of the User */
  firstName: Scalars['String'];
  /** Unique Identifier of the User Account */
  id: Scalars['ID'];
  /** User active status */
  isActive: Scalars['Boolean'];
  /** Last name of the User */
  lastName: Scalars['String'];
  /**
   * eTrackID or sap employee id of the user from the current Project's context
   * @deprecated Use employee.lobEmployeeId instead
   */
  lobEmployeeId?: Maybe<Scalars['String']>;
  /** Middle name of the User */
  middleName?: Maybe<Scalars['String']>;
  /** All PermissionScopes of the user */
  permissionScopes?: Maybe<Array<PermissionScope>>;
  /** List of projects for which the user have access to */
  projects?: Maybe<Array<Maybe<Project>>>;
  /** All roles of the user. This doesnt actually convey permissions and is just role names. Check [permissionScopes for Permissions] */
  roles?: Maybe<Array<Role>>;
  /** List of tool rooms for which the user have access to */
  toolRooms?: Maybe<Array<Maybe<ToolRoom>>>;
  /** Employee record of the user for their default project */
  upn?: Maybe<Scalars['String']>;
};

export type UserProject = {
  __typename?: 'UserProject';
  /** Badge barcode id */
  badgeBarcodeId?: Maybe<Scalars['String']>;
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Crew */
  crew?: Maybe<Crew>;
  /** Crew id */
  crewId?: Maybe<Scalars['String']>;
  /** Crew number */
  crewNumber?: Maybe<Scalars['String']>;
  /** Email */
  email?: Maybe<Scalars['String']>;
  /** Exempted from import */
  exemptedFromImport?: Maybe<Scalars['Boolean']>;
  /** First name */
  firstName: Scalars['String'];
  /** Id */
  id: Scalars['ID'];
  /** Image url of employee */
  imageUrl?: Maybe<Scalars['String']>;
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Last name */
  lastName: Scalars['String'];
  /** Lob employee id */
  lobEmployeeId: Scalars['String'];
  /** Middle name */
  middleName?: Maybe<Scalars['String']>;
  /** Persona */
  persona?: Maybe<Scalars['String']>;
  /** Project */
  project?: Maybe<Project>;
  /** Project id */
  projectId: Scalars['ID'];
  /** Supervisor detail */
  supervisor?: Maybe<UserProject>;
  /** Supervisor id */
  supervisorId?: Maybe<Scalars['String']>;
  /** Th Role */
  thRole?: Maybe<Scalars['String']>;
  /** Tool hound user id */
  thUserId?: Maybe<Scalars['String']>;
  /** Tool hound user login */
  thUserLogin?: Maybe<Scalars['String']>;
  /** Tool hound id */
  toolHoundId?: Maybe<Scalars['String']>;
  /** Updated by */
  updatedBy: Scalars['String'];
  /** Updated date */
  updatedDate: Scalars['Datetime'];
  /** User object for userId */
  user?: Maybe<User>;
  /** User id */
  userId?: Maybe<Scalars['ID']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created By User */
  createdByUser?: Maybe<User>;
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Project Id */
  projectId: Scalars['ID'];
  /** Role object for roleId */
  role: Role;
  /** Role id */
  roleId: Scalars['ID'];
  /** User id */
  userId: Scalars['ID'];
};

export type UserToolRoom = {
  __typename?: 'UserToolRoom';
  /** Created by */
  createdBy: Scalars['String'];
  /** Created date */
  createdDate: Scalars['Datetime'];
  /** Id */
  id: Scalars['ID'];
  /** Is active */
  isActive: Scalars['Boolean'];
  /** Tool Room */
  toolRoom?: Maybe<ToolRoom>;
  /** Tool room id */
  toolRoomId: Scalars['ID'];
  /** Updated by */
  updatedBy?: Maybe<Scalars['String']>;
  /** Updated date */
  updatedDate?: Maybe<Scalars['Datetime']>;
  /** User id */
  userId: Scalars['ID'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;

export type ReferenceResolver<TResult, TReference, TContext> = (
      reference: TReference,
      context: TContext,
      info: GraphQLResolveInfo
    ) => Promise<TResult> | TResult;

      type ScalarCheck<T, S> = S extends true ? T : NullableCheck<T, S>;
      type NullableCheck<T, S> = Maybe<T> extends T ? Maybe<ListCheck<NonNullable<T>, S>> : ListCheck<T, S>;
      type ListCheck<T, S> = T extends (infer U)[] ? NullableCheck<U, S>[] : GraphQLRecursivePick<T, S>;
      export type GraphQLRecursivePick<T, S> = { [K in keyof T & keyof S]: ScalarCheck<T[K], S[K]> };
    

export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AddDeleteRolePermissionScopeResult: ResolverTypeWrapper<AddDeleteRolePermissionScopeResult>;
  AddDeleteRolePermissionsInput: AddDeleteRolePermissionsInput;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  AdhocOrderError: AdhocOrderError;
  AdhocOrderResult: ResolverTypeWrapper<AdhocOrderResult>;
  AdvanceToolOrderStatusError: AdvanceToolOrderStatusError;
  AdvanceToolOrderStatusInput: AdvanceToolOrderStatusInput;
  String: ResolverTypeWrapper<Scalars['String']>;
  AdvanceToolOrderStatusResult: ResolverTypeWrapper<AdvanceToolOrderStatusResult>;
  AuthPermission: AuthPermission;
  BulkMergeResult: ResolverTypeWrapper<BulkMergeResult>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  BulkUpdateToolInventoryInput: BulkUpdateToolInventoryInput;
  BulkUpdateToolInventoryResult: ResolverTypeWrapper<BulkUpdateToolInventoryResult>;
  CancelToolOrderError: CancelToolOrderError;
  CancelToolOrderInput: CancelToolOrderInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  CancelToolOrderResult: ResolverTypeWrapper<CancelToolOrderResult>;
  CreateAdhocOrderInput: CreateAdhocOrderInput;
  CreateAdhocOrderInventory: CreateAdhocOrderInventory;
  CreateAdhocToolOrderInventoryInput: CreateAdhocToolOrderInventoryInput;
  CreateCrewError: CreateCrewError;
  CreateCrewInput: CreateCrewInput;
  CreateCrewResult: ResolverTypeWrapper<CreateCrewResult>;
  CreateEmployeePhotosError: CreateEmployeePhotosError;
  CreateEmployeePhotosInput: CreateEmployeePhotosInput;
  CreateEmployeePhotosResult: ResolverTypeWrapper<CreateEmployeePhotosResult>;
  CreateInboundControlsInput: CreateInboundControlsInput;
  CreateInboundInterfaceError: CreateInboundInterfaceError;
  CreateInboundInterfaceInput: CreateInboundInterfaceInput;
  CreateInboundInterfaceResult: ResolverTypeWrapper<CreateInboundInterfaceResult>;
  CreateInboundProcessError: CreateInboundProcessError;
  CreateInboundProcessInput: CreateInboundProcessInput;
  CreateInboundProcessResult: ResolverTypeWrapper<CreateInboundProcessResult>;
  CreateInboundQueueError: CreateInboundQueueError;
  CreateInboundQueueInput: CreateInboundQueueInput;
  CreateInboundQueueResult: ResolverTypeWrapper<CreateInboundQueueResult>;
  CreateOutboundInterfaceError: CreateOutboundInterfaceError;
  CreateOutboundInterfaceInput: CreateOutboundInterfaceInput;
  CreateOutboundInterfaceResult: ResolverTypeWrapper<CreateOutboundInterfaceResult>;
  CreateOutboundRetryError: CreateOutboundRetryError;
  CreateOutboundRetryInput: CreateOutboundRetryInput;
  CreateOutboundRetryResult: ResolverTypeWrapper<CreateOutboundRetryResult>;
  CreatePermissionError: CreatePermissionError;
  CreatePermissionInput: CreatePermissionInput;
  CreatePermissionResult: ResolverTypeWrapper<CreatePermissionResult>;
  CreateProjectConfigurationError: CreateProjectConfigurationError;
  CreateProjectConfigurationInput: CreateProjectConfigurationInput;
  CreateProjectConfigurationResult: ResolverTypeWrapper<CreateProjectConfigurationResult>;
  CreateProjectToolCatalogError: CreateProjectToolCatalogError;
  CreateProjectToolCatalogInput: CreateProjectToolCatalogInput;
  CreateProjectToolCatalogResult: ResolverTypeWrapper<CreateProjectToolCatalogResult>;
  CreateRoleError: CreateRoleError;
  CreateRoleInput: CreateRoleInput;
  CreateRolePermissionScopeError: CreateRolePermissionScopeError;
  CreateRolePermissionScopeInput: CreateRolePermissionScopeInput;
  CreateRolePermissionScopeResult: ResolverTypeWrapper<CreateRolePermissionScopeResult>;
  CreateRoleResult: ResolverTypeWrapper<CreateRoleResult>;
  CreateScopeError: CreateScopeError;
  CreateScopeInput: CreateScopeInput;
  CreateScopeResult: ResolverTypeWrapper<CreateScopeResult>;
  CreateToolCatalogError: CreateToolCatalogError;
  CreateToolCatalogImageError: CreateToolCatalogImageError;
  CreateToolCatalogImageInput: CreateToolCatalogImageInput;
  CreateToolCatalogImageResult: ResolverTypeWrapper<CreateToolCatalogImageResult>;
  CreateToolCatalogInput: CreateToolCatalogInput;
  CreateToolCatalogResult: ResolverTypeWrapper<CreateToolCatalogResult>;
  CreateToolCategoryError: CreateToolCategoryError;
  CreateToolCategoryInput: CreateToolCategoryInput;
  CreateToolCategoryResult: ResolverTypeWrapper<CreateToolCategoryResult>;
  CreateToolCheckInError: CreateToolCheckInError;
  CreateToolCheckInInput: CreateToolCheckInInput;
  CreateToolCheckInItemsError: CreateToolCheckInItemsError;
  CreateToolCheckInItemsInput: CreateToolCheckInItemsInput;
  CreateToolCheckInItemsResult: ResolverTypeWrapper<CreateToolCheckInItemsResult>;
  CreateToolCheckInResult: ResolverTypeWrapper<CreateToolCheckInResult>;
  CreateToolCheckInWarning: CreateToolCheckInWarning;
  CreateToolInventoryError: CreateToolInventoryError;
  CreateToolInventoryInput: CreateToolInventoryInput;
  CreateToolInventoryPhysicalCountError: CreateToolInventoryPhysicalCountError;
  CreateToolInventoryPhysicalCountInput: CreateToolInventoryPhysicalCountInput;
  CreateToolInventoryPhysicalCountResult: ResolverTypeWrapper<CreateToolInventoryPhysicalCountResult>;
  CreateToolInventoryResult: ResolverTypeWrapper<CreateToolInventoryResult>;
  CreateToolInventoryStatusError: CreateToolInventoryStatusError;
  CreateToolInventoryStatusInput: CreateToolInventoryStatusInput;
  CreateToolInventoryStatusResult: ResolverTypeWrapper<CreateToolInventoryStatusResult>;
  CreateToolOrderCatalogError: CreateToolOrderCatalogError;
  CreateToolOrderCatalogInput: CreateToolOrderCatalogInput;
  CreateToolOrderCatalogResult: ResolverTypeWrapper<CreateToolOrderCatalogResult>;
  CreateToolOrderError: CreateToolOrderError;
  CreateToolOrderHistoryError: CreateToolOrderHistoryError;
  CreateToolOrderHistoryInput: CreateToolOrderHistoryInput;
  CreateToolOrderHistoryResult: ResolverTypeWrapper<CreateToolOrderHistoryResult>;
  CreateToolOrderInput: CreateToolOrderInput;
  CreateToolOrderInventoryError: CreateToolOrderInventoryError;
  CreateToolOrderInventoryInput: CreateToolOrderInventoryInput;
  CreateToolOrderInventoryResult: ResolverTypeWrapper<CreateToolOrderInventoryResult>;
  CreateToolOrderResult: ResolverTypeWrapper<CreateToolOrderResult>;
  CreateToolRoomError: CreateToolRoomError;
  CreateToolRoomInput: CreateToolRoomInput;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  CreateToolTransferError: CreateToolTransferError;
  CreateToolTransferHistoryError: CreateToolTransferHistoryError;
  CreateToolTransferHistoryInput: CreateToolTransferHistoryInput;
  CreateToolTransferHistoryResult: ResolverTypeWrapper<CreateToolTransferHistoryResult>;
  CreateToolTransferInput: CreateToolTransferInput;
  CreateToolTransferItemError: CreateToolTransferItemError;
  CreateToolTransferItemInput: CreateToolTransferItemInput;
  CreateToolTransferItemResult: ResolverTypeWrapper<CreateToolTransferItemResult>;
  CreateToolTransferResult: ResolverTypeWrapper<CreateToolTransferResult>;
  CreateToolTypeError: CreateToolTypeError;
  CreateToolTypeInput: CreateToolTypeInput;
  CreateToolTypeResult: ResolverTypeWrapper<CreateToolTypeResult>;
  CreateToolUserFavoriteError: CreateToolUserFavoriteError;
  CreateToolUserFavoriteInput: CreateToolUserFavoriteInput;
  CreateToolUserFavoriteResult: ResolverTypeWrapper<CreateToolUserFavoriteResult>;
  CreateUomError: CreateUomError;
  CreateUomInput: CreateUomInput;
  CreateUomResult: ResolverTypeWrapper<CreateUomResult>;
  CreateUserAccountInput: CreateUserAccountInput;
  CreateUserAccountResult: ResolverTypeWrapper<CreateUserAccountResult>;
  CreateUserError: CreateUserError;
  CreateUserInput: CreateUserInput;
  CreateUserInputWithProjectIds: CreateUserInputWithProjectIds;
  CreateUserProjectError: CreateUserProjectError;
  CreateUserProjectInput: CreateUserProjectInput;
  CreateUserProjectResult: ResolverTypeWrapper<CreateUserProjectResult>;
  CreateUserResult: ResolverTypeWrapper<CreateUserResult>;
  CreateUserRoleError: CreateUserRoleError;
  CreateUserRoleInput: CreateUserRoleInput;
  CreateUserRoleResult: ResolverTypeWrapper<CreateUserRoleResult>;
  CreateUserToolRoomError: CreateUserToolRoomError;
  CreateUserToolRoomInput: CreateUserToolRoomInput;
  CreateUserToolRoomResult: ResolverTypeWrapper<CreateUserToolRoomResult>;
  Crew: ResolverTypeWrapper<Crew>;
  CursorPaginationInput: CursorPaginationInput;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  Datetime: ResolverTypeWrapper<Scalars['Datetime']>;
  DaysOfWeek: DaysOfWeek;
  DeleteCrewError: DeleteCrewError;
  DeleteCrewInput: DeleteCrewInput;
  DeleteCrewResult: ResolverTypeWrapper<DeleteCrewResult>;
  DeleteEmployeePhotosError: DeleteEmployeePhotosError;
  DeleteEmployeePhotosInput: DeleteEmployeePhotosInput;
  DeleteEmployeePhotosResult: ResolverTypeWrapper<DeleteEmployeePhotosResult>;
  DeleteOutboundInterfaceError: DeleteOutboundInterfaceError;
  DeleteOutboundInterfaceInput: DeleteOutboundInterfaceInput;
  DeleteOutboundInterfaceResult: ResolverTypeWrapper<DeleteOutboundInterfaceResult>;
  DeleteOutboundRetryError: DeleteOutboundRetryError;
  DeleteOutboundRetryInput: DeleteOutboundRetryInput;
  DeleteOutboundRetryResult: ResolverTypeWrapper<DeleteOutboundRetryResult>;
  DeletePermissionError: DeletePermissionError;
  DeletePermissionInput: DeletePermissionInput;
  DeletePermissionResult: ResolverTypeWrapper<DeletePermissionResult>;
  DeleteProjectConfigurationError: DeleteProjectConfigurationError;
  DeleteProjectConfigurationInput: DeleteProjectConfigurationInput;
  DeleteProjectConfigurationResult: ResolverTypeWrapper<DeleteProjectConfigurationResult>;
  DeleteProjectToolCatalogError: DeleteProjectToolCatalogError;
  DeleteProjectToolCatalogInput: DeleteProjectToolCatalogInput;
  DeleteProjectToolCatalogResult: ResolverTypeWrapper<DeleteProjectToolCatalogResult>;
  DeleteRoleError: DeleteRoleError;
  DeleteRoleInput: DeleteRoleInput;
  DeleteRolePermissionScopeError: DeleteRolePermissionScopeError;
  DeleteRolePermissionScopeInput: DeleteRolePermissionScopeInput;
  DeleteRolePermissionScopeResult: ResolverTypeWrapper<DeleteRolePermissionScopeResult>;
  DeleteRoleResult: ResolverTypeWrapper<DeleteRoleResult>;
  DeleteScopeError: DeleteScopeError;
  DeleteScopeInput: DeleteScopeInput;
  DeleteScopeResult: ResolverTypeWrapper<DeleteScopeResult>;
  DeleteToolCatalogImageError: DeleteToolCatalogImageError;
  DeleteToolCatalogImageInput: DeleteToolCatalogImageInput;
  DeleteToolCatalogImageResult: ResolverTypeWrapper<DeleteToolCatalogImageResult>;
  DeleteToolCheckInError: DeleteToolCheckInError;
  DeleteToolCheckInInput: DeleteToolCheckInInput;
  DeleteToolCheckInItemsError: DeleteToolCheckInItemsError;
  DeleteToolCheckInItemsInput: DeleteToolCheckInItemsInput;
  DeleteToolCheckInItemsResult: ResolverTypeWrapper<DeleteToolCheckInItemsResult>;
  DeleteToolCheckInResult: ResolverTypeWrapper<DeleteToolCheckInResult>;
  DeleteToolInventoryError: DeleteToolInventoryError;
  DeleteToolInventoryInput: DeleteToolInventoryInput;
  DeleteToolInventoryPhysicalCountError: DeleteToolInventoryPhysicalCountError;
  DeleteToolInventoryPhysicalCountInput: DeleteToolInventoryPhysicalCountInput;
  DeleteToolInventoryPhysicalCountResult: ResolverTypeWrapper<DeleteToolInventoryPhysicalCountResult>;
  DeleteToolInventoryResult: ResolverTypeWrapper<DeleteToolInventoryResult>;
  DeleteToolInventoryStatusError: DeleteToolInventoryStatusError;
  DeleteToolInventoryStatusInput: DeleteToolInventoryStatusInput;
  DeleteToolInventoryStatusResult: ResolverTypeWrapper<DeleteToolInventoryStatusResult>;
  DeleteToolOrderCatalogError: DeleteToolOrderCatalogError;
  DeleteToolOrderCatalogInput: DeleteToolOrderCatalogInput;
  DeleteToolOrderCatalogResult: ResolverTypeWrapper<DeleteToolOrderCatalogResult>;
  DeleteToolOrderError: DeleteToolOrderError;
  DeleteToolOrderHistoryError: DeleteToolOrderHistoryError;
  DeleteToolOrderHistoryInput: DeleteToolOrderHistoryInput;
  DeleteToolOrderHistoryResult: ResolverTypeWrapper<DeleteToolOrderHistoryResult>;
  DeleteToolOrderInput: DeleteToolOrderInput;
  DeleteToolOrderInventoryError: DeleteToolOrderInventoryError;
  DeleteToolOrderInventoryInput: DeleteToolOrderInventoryInput;
  DeleteToolOrderInventoryResult: ResolverTypeWrapper<DeleteToolOrderInventoryResult>;
  DeleteToolOrderResult: ResolverTypeWrapper<DeleteToolOrderResult>;
  DeleteToolTransferError: DeleteToolTransferError;
  DeleteToolTransferInput: DeleteToolTransferInput;
  DeleteToolTransferItemError: DeleteToolTransferItemError;
  DeleteToolTransferItemInput: DeleteToolTransferItemInput;
  DeleteToolTransferItemResult: ResolverTypeWrapper<DeleteToolTransferItemResult>;
  DeleteToolTransferResult: ResolverTypeWrapper<DeleteToolTransferResult>;
  DeleteToolUserFavoriteError: DeleteToolUserFavoriteError;
  DeleteToolUserFavoriteResult: ResolverTypeWrapper<DeleteToolUserFavoriteResult>;
  DeleteUomError: DeleteUomError;
  DeleteUomInput: DeleteUomInput;
  DeleteUomResult: ResolverTypeWrapper<DeleteUomResult>;
  DeleteUserProjectError: DeleteUserProjectError;
  DeleteUserProjectInput: DeleteUserProjectInput;
  DeleteUserProjectResult: ResolverTypeWrapper<DeleteUserProjectResult>;
  DeleteUserRoleError: DeleteUserRoleError;
  DeleteUserRoleInput: DeleteUserRoleInput;
  DeleteUserRoleResult: ResolverTypeWrapper<DeleteUserRoleResult>;
  DeleteUserToolRoomError: DeleteUserToolRoomError;
  DeleteUserToolRoomInput: DeleteUserToolRoomInput;
  DeleteUserToolRoomResult: ResolverTypeWrapper<DeleteUserToolRoomResult>;
  DispatchNotFulfilledInventoryInput: DispatchNotFulfilledInventoryInput;
  DispatchToolOrderInput: DispatchToolOrderInput;
  DispatchToolOrderStatusError: DispatchToolOrderStatusError;
  DispatchToolOrderStatusResult: ResolverTypeWrapper<DispatchToolOrderStatusResult>;
  EmployeeImageInput: EmployeeImageInput;
  EmployeePhotos: ResolverTypeWrapper<EmployeePhotos>;
  ExceptionCode: ExceptionCode;
  FilterConditionInput: FilterConditionInput;
  FilterInput: FilterInput;
  GeoLocation: ResolverTypeWrapper<GeoLocation>;
  GeoLocationInput: GeoLocationInput;
  GroupedToolInventory: ResolverTypeWrapper<GroupedToolInventory>;
  ImportCatalogStatus: ResolverTypeWrapper<ImportCatalogStatus>;
  ImportError: ImportError;
  ImportInput: ImportInput;
  ImportResult: ResolverTypeWrapper<ImportResult>;
  ImportStatus: ImportStatus;
  ImportType: ImportType;
  InboundControlUpdatedSubscriptionPayload: ResolverTypeWrapper<InboundControlUpdatedSubscriptionPayload>;
  InboundControls: ResolverTypeWrapper<InboundControls>;
  InboundControlsError: InboundControlsError;
  InboundControlsResult: ResolverTypeWrapper<InboundControlsResult>;
  InboundInterface: ResolverTypeWrapper<InboundInterface>;
  InboundProcess: ResolverTypeWrapper<InboundProcess>;
  InboundQueue: ResolverTypeWrapper<InboundQueue>;
  InterfaceControlStatus: InterfaceControlStatus;
  InterfaceName: InterfaceName;
  InterfaceType: InterfaceType;
  InventoryStatus: InventoryStatus;
  InventoryType: InventoryType;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  MergeBulkToolCategoryStatsImportError: MergeBulkToolCategoryStatsImportError;
  MergeBulkToolCategoryStatsImportResponse: ResolverTypeWrapper<MergeBulkToolCategoryStatsImportResponse>;
  MergeBulkToolCategoryStatsImportResult: ResolverTypeWrapper<MergeBulkToolCategoryStatsImportResult>;
  Mutation: ResolverTypeWrapper<{}>;
  OperationType: OperationType;
  OperatorType: OperatorType;
  OutboundAction: OutboundAction;
  OutboundErrorType: OutboundErrorType;
  OutboundInterface: ResolverTypeWrapper<OutboundInterface>;
  OutboundRetry: ResolverTypeWrapper<OutboundRetry>;
  OutboundRetryActionType: OutboundRetryActionType;
  OutboundStatus: OutboundStatus;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PaginationInput: PaginationInput;
  Permission: ResolverTypeWrapper<Permission>;
  PermissionScope: ResolverTypeWrapper<PermissionScope>;
  PickToolOrderInventoryError: PickToolOrderInventoryError;
  PickToolOrderInventoryInput: PickToolOrderInventoryInput;
  PickToolOrderInventoryResponse: ResolverTypeWrapper<PickToolOrderInventoryResponse>;
  PickToolOrderInventoryResult: ResolverTypeWrapper<PickToolOrderInventoryResult>;
  Project: ResolverTypeWrapper<Project>;
  ProjectConfiguration: ResolverTypeWrapper<ProjectConfiguration>;
  ProjectToolCatalog: ResolverTypeWrapper<ProjectToolCatalog>;
  ProjectToolCatalogCsvPayload: ResolverTypeWrapper<ProjectToolCatalogCsvPayload>;
  Query: ResolverTypeWrapper<{}>;
  RetryFailedOutboundSubscriptionPayload: ResolverTypeWrapper<RetryFailedOutboundSubscriptionPayload>;
  RetryOutboundInterfaceInput: RetryOutboundInterfaceInput;
  Role: ResolverTypeWrapper<Role>;
  RolePermissionScope: ResolverTypeWrapper<RolePermissionScope>;
  SaveToolUserFavoriteError: SaveToolUserFavoriteError;
  SaveToolUserFavoriteInput: SaveToolUserFavoriteInput;
  SaveToolUserFavoriteResult: ResolverTypeWrapper<SaveToolUserFavoriteResult>;
  Scope: ResolverTypeWrapper<Scope>;
  SearchCrewResult: ResolverTypeWrapper<SearchCrewResult>;
  SearchEmployeePhotosResult: ResolverTypeWrapper<SearchEmployeePhotosResult>;
  SearchGroupedInventoryError: SearchGroupedInventoryError;
  SearchGroupedInventoryResult: ResolverTypeWrapper<SearchGroupedInventoryResult>;
  SearchInboundControlsResult: ResolverTypeWrapper<SearchInboundControlsResult>;
  SearchInboundInterfaceResult: ResolverTypeWrapper<SearchInboundInterfaceResult>;
  SearchInboundProcessResult: ResolverTypeWrapper<SearchInboundProcessResult>;
  SearchInboundQueueResult: ResolverTypeWrapper<SearchInboundQueueResult>;
  SearchInput: SearchInput;
  SearchOutboundInterfaceResult: ResolverTypeWrapper<SearchOutboundInterfaceResult>;
  SearchOutboundRetryResult: ResolverTypeWrapper<SearchOutboundRetryResult>;
  SearchPermissionResult: ResolverTypeWrapper<SearchPermissionResult>;
  SearchProjectConfigurationResult: ResolverTypeWrapper<SearchProjectConfigurationResult>;
  SearchProjectToolCatalogResult: ResolverTypeWrapper<SearchProjectToolCatalogResult>;
  SearchProjectsResult: ResolverTypeWrapper<SearchProjectsResult>;
  SearchRolePermissionScopeResult: ResolverTypeWrapper<SearchRolePermissionScopeResult>;
  SearchRoleResult: ResolverTypeWrapper<SearchRoleResult>;
  SearchScopeResult: ResolverTypeWrapper<SearchScopeResult>;
  SearchToolCatalogImageResult: ResolverTypeWrapper<SearchToolCatalogImageResult>;
  SearchToolCatalogResult: ResolverTypeWrapper<SearchToolCatalogResult>;
  SearchToolCategoryResult: ResolverTypeWrapper<SearchToolCategoryResult>;
  SearchToolCategoryStatsResult: ResolverTypeWrapper<SearchToolCategoryStatsResult>;
  SearchToolCheckInItemsResult: ResolverTypeWrapper<SearchToolCheckInItemsResult>;
  SearchToolCheckInResult: ResolverTypeWrapper<SearchToolCheckInResult>;
  SearchToolInventoryPhysicalCountResult: ResolverTypeWrapper<SearchToolInventoryPhysicalCountResult>;
  SearchToolInventoryResult: ResolverTypeWrapper<SearchToolInventoryResult>;
  SearchToolInventoryStatusResult: ResolverTypeWrapper<SearchToolInventoryStatusResult>;
  SearchToolOrderCatalogResult: ResolverTypeWrapper<SearchToolOrderCatalogResult>;
  SearchToolOrderHistoryResult: ResolverTypeWrapper<SearchToolOrderHistoryResult>;
  SearchToolOrderInventoryResult: ResolverTypeWrapper<SearchToolOrderInventoryResult>;
  SearchToolOrderResult: ResolverTypeWrapper<SearchToolOrderResult>;
  SearchToolRoomResult: ResolverTypeWrapper<SearchToolRoomResult>;
  SearchToolTransferHistoryResult: ResolverTypeWrapper<SearchToolTransferHistoryResult>;
  SearchToolTransferItemResult: ResolverTypeWrapper<SearchToolTransferItemResult>;
  SearchToolTransferResult: ResolverTypeWrapper<SearchToolTransferResult>;
  SearchToolTypeResult: ResolverTypeWrapper<SearchToolTypeResult>;
  SearchToolUserFavoriteResult: ResolverTypeWrapper<SearchToolUserFavoriteResult>;
  SearchUomResult: ResolverTypeWrapper<SearchUomResult>;
  SearchUserProjectResult: ResolverTypeWrapper<SearchUserProjectResult>;
  SearchUserResult: ResolverTypeWrapper<SearchUserResult>;
  SearchUserRoleResult: ResolverTypeWrapper<SearchUserRoleResult>;
  SearchUserToolRoomResult: ResolverTypeWrapper<SearchUserToolRoomResult>;
  SortInput: SortInput;
  SortType: SortType;
  Subscription: ResolverTypeWrapper<{}>;
  Time: ResolverTypeWrapper<Scalars['Time']>;
  ToggleCountRequiredError: ToggleCountRequiredError;
  ToggleCountRequiredInput: ToggleCountRequiredInput;
  ToggleCountRequiredResult: ResolverTypeWrapper<ToggleCountRequiredResult>;
  ToolCatalog: ResolverTypeWrapper<ToolCatalog>;
  ToolCatalogImage: ResolverTypeWrapper<ToolCatalogImage>;
  ToolCatalogImageUrlInput: ToolCatalogImageUrlInput;
  ToolCategory: ResolverTypeWrapper<ToolCategory>;
  ToolCategoryStats: ResolverTypeWrapper<ToolCategoryStats>;
  ToolCheckIn: ResolverTypeWrapper<ToolCheckIn>;
  ToolCheckInErrors: ResolverTypeWrapper<ToolCheckInErrors>;
  ToolCheckInInput: ToolCheckInInput;
  ToolCheckInItems: ResolverTypeWrapper<ToolCheckInItems>;
  ToolCheckInItemsInput: ToolCheckInItemsInput;
  ToolCheckInResult: ResolverTypeWrapper<ToolCheckInResult>;
  ToolHoundOutboundSubscriptionPayload: ResolverTypeWrapper<ToolHoundOutboundSubscriptionPayload>;
  ToolInventory: ResolverTypeWrapper<ToolInventory>;
  ToolInventoryError: ToolInventoryError;
  ToolInventoryInput: ToolInventoryInput;
  ToolInventoryPhysicalCount: ResolverTypeWrapper<ToolInventoryPhysicalCount>;
  ToolInventoryStats: ResolverTypeWrapper<ToolInventoryStats>;
  ToolInventoryStatsResult: ResolverTypeWrapper<ToolInventoryStatsResult>;
  ToolInventoryStatus: ResolverTypeWrapper<ToolInventoryStatus>;
  ToolInventorySubscriptionPayload: ResolverTypeWrapper<ToolInventorySubscriptionPayload>;
  ToolOrder: ResolverTypeWrapper<ToolOrder>;
  ToolOrderAvailableInventory: ResolverTypeWrapper<ToolOrderAvailableInventory>;
  ToolOrderCatalog: ResolverTypeWrapper<ToolOrderCatalog>;
  ToolOrderHistory: ResolverTypeWrapper<ToolOrderHistory>;
  ToolOrderInventory: ResolverTypeWrapper<ToolOrderInventory>;
  ToolOrderInventoryCreatedSubscriptionPayload: ResolverTypeWrapper<ToolOrderInventoryCreatedSubscriptionPayload>;
  ToolOrderInventoryStatus: ToolOrderInventoryStatus;
  ToolOrderItemsStats: ResolverTypeWrapper<ToolOrderItemsStats>;
  ToolOrderStats: ResolverTypeWrapper<ToolOrderStats>;
  ToolOrderStatsError: ToolOrderStatsError;
  ToolOrderStatsInput: ToolOrderStatsInput;
  ToolOrderStatsResponse: ResolverTypeWrapper<ToolOrderStatsResponse>;
  ToolOrderStatsResult: ResolverTypeWrapper<ToolOrderStatsResult>;
  ToolOrderStatus: ToolOrderStatus;
  ToolOrderStatusData: ResolverTypeWrapper<ToolOrderStatusData>;
  ToolOrderStatusSubscriptionPayload: ResolverTypeWrapper<ToolOrderStatusSubscriptionPayload>;
  ToolOrderSubscriptionPayload: ResolverTypeWrapper<ToolOrderSubscriptionPayload>;
  ToolOrderUpdatedSubscriptionPayload: ResolverTypeWrapper<ToolOrderUpdatedSubscriptionPayload>;
  ToolRoom: ResolverTypeWrapper<ToolRoom>;
  ToolRoomSubscriptionPayload: ResolverTypeWrapper<ToolRoomSubscriptionPayload>;
  ToolTransfer: ResolverTypeWrapper<ToolTransfer>;
  ToolTransferHistory: ResolverTypeWrapper<ToolTransferHistory>;
  ToolTransferItem: ResolverTypeWrapper<ToolTransferItem>;
  ToolTransferStats: ResolverTypeWrapper<ToolTransferStats>;
  ToolTransferStatuses: ToolTransferStatuses;
  ToolType: ResolverTypeWrapper<ToolType>;
  ToolUserFavorite: ResolverTypeWrapper<ToolUserFavorite>;
  ToolUserFavoriteStats: ResolverTypeWrapper<ToolUserFavoriteStats>;
  Uom: ResolverTypeWrapper<Uom>;
  UpdateCrewError: UpdateCrewError;
  UpdateCrewInput: UpdateCrewInput;
  UpdateCrewResult: ResolverTypeWrapper<UpdateCrewResult>;
  UpdateEmployeePhotosError: UpdateEmployeePhotosError;
  UpdateEmployeePhotosInput: UpdateEmployeePhotosInput;
  UpdateEmployeePhotosResult: ResolverTypeWrapper<UpdateEmployeePhotosResult>;
  UpdateInboundControlsInput: UpdateInboundControlsInput;
  UpdateOutboundInterfaceError: UpdateOutboundInterfaceError;
  UpdateOutboundInterfaceInput: UpdateOutboundInterfaceInput;
  UpdateOutboundInterfaceResult: ResolverTypeWrapper<UpdateOutboundInterfaceResult>;
  UpdateOutboundRetryError: UpdateOutboundRetryError;
  UpdateOutboundRetryInput: UpdateOutboundRetryInput;
  UpdateOutboundRetryResult: ResolverTypeWrapper<UpdateOutboundRetryResult>;
  UpdatePermissionError: UpdatePermissionError;
  UpdatePermissionInput: UpdatePermissionInput;
  UpdatePermissionResult: ResolverTypeWrapper<UpdatePermissionResult>;
  UpdateProjectConfigurationError: UpdateProjectConfigurationError;
  UpdateProjectConfigurationInput: UpdateProjectConfigurationInput;
  UpdateProjectConfigurationResult: ResolverTypeWrapper<UpdateProjectConfigurationResult>;
  UpdateProjectToolCatalogError: UpdateProjectToolCatalogError;
  UpdateProjectToolCatalogInput: UpdateProjectToolCatalogInput;
  UpdateProjectToolCatalogResult: ResolverTypeWrapper<UpdateProjectToolCatalogResult>;
  UpdateRoleError: UpdateRoleError;
  UpdateRoleInput: UpdateRoleInput;
  UpdateRolePermissionScopeError: UpdateRolePermissionScopeError;
  UpdateRolePermissionScopeInput: UpdateRolePermissionScopeInput;
  UpdateRolePermissionScopeResult: ResolverTypeWrapper<UpdateRolePermissionScopeResult>;
  UpdateRoleResult: ResolverTypeWrapper<UpdateRoleResult>;
  UpdateScopeError: UpdateScopeError;
  UpdateScopeInput: UpdateScopeInput;
  UpdateScopeResult: ResolverTypeWrapper<UpdateScopeResult>;
  UpdateToolCatalogError: UpdateToolCatalogError;
  UpdateToolCatalogImageError: UpdateToolCatalogImageError;
  UpdateToolCatalogImageInput: UpdateToolCatalogImageInput;
  UpdateToolCatalogImageResult: ResolverTypeWrapper<UpdateToolCatalogImageResult>;
  UpdateToolCatalogInput: UpdateToolCatalogInput;
  UpdateToolCatalogResult: ResolverTypeWrapper<UpdateToolCatalogResult>;
  UpdateToolCategoryError: UpdateToolCategoryError;
  UpdateToolCategoryInput: UpdateToolCategoryInput;
  UpdateToolCategoryResult: ResolverTypeWrapper<UpdateToolCategoryResult>;
  UpdateToolCheckInError: UpdateToolCheckInError;
  UpdateToolCheckInInput: UpdateToolCheckInInput;
  UpdateToolCheckInItemsError: UpdateToolCheckInItemsError;
  UpdateToolCheckInItemsInput: UpdateToolCheckInItemsInput;
  UpdateToolCheckInItemsResult: ResolverTypeWrapper<UpdateToolCheckInItemsResult>;
  UpdateToolCheckInResult: ResolverTypeWrapper<UpdateToolCheckInResult>;
  UpdateToolInventoryError: UpdateToolInventoryError;
  UpdateToolInventoryInput: UpdateToolInventoryInput;
  UpdateToolInventoryPhysicalCountError: UpdateToolInventoryPhysicalCountError;
  UpdateToolInventoryPhysicalCountInput: UpdateToolInventoryPhysicalCountInput;
  UpdateToolInventoryPhysicalCountResult: ResolverTypeWrapper<UpdateToolInventoryPhysicalCountResult>;
  UpdateToolInventoryResult: ResolverTypeWrapper<UpdateToolInventoryResult>;
  UpdateToolInventoryStatusError: UpdateToolInventoryStatusError;
  UpdateToolInventoryStatusInput: UpdateToolInventoryStatusInput;
  UpdateToolInventoryStatusResult: ResolverTypeWrapper<UpdateToolInventoryStatusResult>;
  UpdateToolOrderCatalogError: UpdateToolOrderCatalogError;
  UpdateToolOrderCatalogInput: UpdateToolOrderCatalogInput;
  UpdateToolOrderCatalogResult: ResolverTypeWrapper<UpdateToolOrderCatalogResult>;
  UpdateToolOrderError: UpdateToolOrderError;
  UpdateToolOrderHistoryError: UpdateToolOrderHistoryError;
  UpdateToolOrderHistoryInput: UpdateToolOrderHistoryInput;
  UpdateToolOrderHistoryResult: ResolverTypeWrapper<UpdateToolOrderHistoryResult>;
  UpdateToolOrderInput: UpdateToolOrderInput;
  UpdateToolOrderInventoryError: UpdateToolOrderInventoryError;
  UpdateToolOrderInventoryInput: UpdateToolOrderInventoryInput;
  UpdateToolOrderInventoryResult: ResolverTypeWrapper<UpdateToolOrderInventoryResult>;
  UpdateToolOrderResult: ResolverTypeWrapper<UpdateToolOrderResult>;
  UpdateToolRoomError: UpdateToolRoomError;
  UpdateToolRoomInput: UpdateToolRoomInput;
  UpdateToolRoomResult: ResolverTypeWrapper<UpdateToolRoomResult>;
  UpdateToolTransferError: UpdateToolTransferError;
  UpdateToolTransferInput: UpdateToolTransferInput;
  UpdateToolTransferItemError: UpdateToolTransferItemError;
  UpdateToolTransferItemInput: UpdateToolTransferItemInput;
  UpdateToolTransferItemResult: ResolverTypeWrapper<UpdateToolTransferItemResult>;
  UpdateToolTransferResult: ResolverTypeWrapper<UpdateToolTransferResult>;
  UpdateUomError: UpdateUomError;
  UpdateUomInput: UpdateUomInput;
  UpdateUomResult: ResolverTypeWrapper<UpdateUomResult>;
  UpdateUserAccountInput: UpdateUserAccountInput;
  UpdateUserAccountResult: ResolverTypeWrapper<UpdateUserAccountResult>;
  UpdateUserDefaultProjectError: UpdateUserDefaultProjectError;
  UpdateUserDefaultProjectInput: UpdateUserDefaultProjectInput;
  UpdateUserDefaultProjectResult: ResolverTypeWrapper<UpdateUserDefaultProjectResult>;
  UpdateUserError: UpdateUserError;
  UpdateUserInput: UpdateUserInput;
  UpdateUserProjectError: UpdateUserProjectError;
  UpdateUserProjectInput: UpdateUserProjectInput;
  UpdateUserProjectResult: ResolverTypeWrapper<UpdateUserProjectResult>;
  UpdateUserResult: ResolverTypeWrapper<UpdateUserResult>;
  UpdateUserRoleError: UpdateUserRoleError;
  UpdateUserRoleInput: UpdateUserRoleInput;
  UpdateUserRoleResult: ResolverTypeWrapper<UpdateUserRoleResult>;
  UpdateUserToolRoomError: UpdateUserToolRoomError;
  UpdateUserToolRoomInput: UpdateUserToolRoomInput;
  UpdateUserToolRoomResult: ResolverTypeWrapper<UpdateUserToolRoomResult>;
  User: ResolverTypeWrapper<User>;
  UserProject: ResolverTypeWrapper<UserProject>;
  UserRole: ResolverTypeWrapper<UserRole>;
  UserToolRoom: ResolverTypeWrapper<UserToolRoom>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AddDeleteRolePermissionScopeResult: AddDeleteRolePermissionScopeResult;
  AddDeleteRolePermissionsInput: AddDeleteRolePermissionsInput;
  ID: Scalars['ID'];
  AdhocOrderResult: AdhocOrderResult;
  AdvanceToolOrderStatusInput: AdvanceToolOrderStatusInput;
  String: Scalars['String'];
  AdvanceToolOrderStatusResult: AdvanceToolOrderStatusResult;
  BulkMergeResult: BulkMergeResult;
  Int: Scalars['Int'];
  BulkUpdateToolInventoryInput: BulkUpdateToolInventoryInput;
  BulkUpdateToolInventoryResult: BulkUpdateToolInventoryResult;
  CancelToolOrderInput: CancelToolOrderInput;
  Boolean: Scalars['Boolean'];
  CancelToolOrderResult: CancelToolOrderResult;
  CreateAdhocOrderInput: CreateAdhocOrderInput;
  CreateAdhocOrderInventory: CreateAdhocOrderInventory;
  CreateAdhocToolOrderInventoryInput: CreateAdhocToolOrderInventoryInput;
  CreateCrewInput: CreateCrewInput;
  CreateCrewResult: CreateCrewResult;
  CreateEmployeePhotosInput: CreateEmployeePhotosInput;
  CreateEmployeePhotosResult: CreateEmployeePhotosResult;
  CreateInboundControlsInput: CreateInboundControlsInput;
  CreateInboundInterfaceInput: CreateInboundInterfaceInput;
  CreateInboundInterfaceResult: CreateInboundInterfaceResult;
  CreateInboundProcessInput: CreateInboundProcessInput;
  CreateInboundProcessResult: CreateInboundProcessResult;
  CreateInboundQueueInput: CreateInboundQueueInput;
  CreateInboundQueueResult: CreateInboundQueueResult;
  CreateOutboundInterfaceInput: CreateOutboundInterfaceInput;
  CreateOutboundInterfaceResult: CreateOutboundInterfaceResult;
  CreateOutboundRetryInput: CreateOutboundRetryInput;
  CreateOutboundRetryResult: CreateOutboundRetryResult;
  CreatePermissionInput: CreatePermissionInput;
  CreatePermissionResult: CreatePermissionResult;
  CreateProjectConfigurationInput: CreateProjectConfigurationInput;
  CreateProjectConfigurationResult: CreateProjectConfigurationResult;
  CreateProjectToolCatalogInput: CreateProjectToolCatalogInput;
  CreateProjectToolCatalogResult: CreateProjectToolCatalogResult;
  CreateRoleInput: CreateRoleInput;
  CreateRolePermissionScopeInput: CreateRolePermissionScopeInput;
  CreateRolePermissionScopeResult: CreateRolePermissionScopeResult;
  CreateRoleResult: CreateRoleResult;
  CreateScopeInput: CreateScopeInput;
  CreateScopeResult: CreateScopeResult;
  CreateToolCatalogImageInput: CreateToolCatalogImageInput;
  CreateToolCatalogImageResult: CreateToolCatalogImageResult;
  CreateToolCatalogInput: CreateToolCatalogInput;
  CreateToolCatalogResult: CreateToolCatalogResult;
  CreateToolCategoryInput: CreateToolCategoryInput;
  CreateToolCategoryResult: CreateToolCategoryResult;
  CreateToolCheckInInput: CreateToolCheckInInput;
  CreateToolCheckInItemsInput: CreateToolCheckInItemsInput;
  CreateToolCheckInItemsResult: CreateToolCheckInItemsResult;
  CreateToolCheckInResult: CreateToolCheckInResult;
  CreateToolInventoryInput: CreateToolInventoryInput;
  CreateToolInventoryPhysicalCountInput: CreateToolInventoryPhysicalCountInput;
  CreateToolInventoryPhysicalCountResult: CreateToolInventoryPhysicalCountResult;
  CreateToolInventoryResult: CreateToolInventoryResult;
  CreateToolInventoryStatusInput: CreateToolInventoryStatusInput;
  CreateToolInventoryStatusResult: CreateToolInventoryStatusResult;
  CreateToolOrderCatalogInput: CreateToolOrderCatalogInput;
  CreateToolOrderCatalogResult: CreateToolOrderCatalogResult;
  CreateToolOrderHistoryInput: CreateToolOrderHistoryInput;
  CreateToolOrderHistoryResult: CreateToolOrderHistoryResult;
  CreateToolOrderInput: CreateToolOrderInput;
  CreateToolOrderInventoryInput: CreateToolOrderInventoryInput;
  CreateToolOrderInventoryResult: CreateToolOrderInventoryResult;
  CreateToolOrderResult: CreateToolOrderResult;
  CreateToolRoomInput: CreateToolRoomInput;
  Float: Scalars['Float'];
  CreateToolTransferHistoryInput: CreateToolTransferHistoryInput;
  CreateToolTransferHistoryResult: CreateToolTransferHistoryResult;
  CreateToolTransferInput: CreateToolTransferInput;
  CreateToolTransferItemInput: CreateToolTransferItemInput;
  CreateToolTransferItemResult: CreateToolTransferItemResult;
  CreateToolTransferResult: CreateToolTransferResult;
  CreateToolTypeInput: CreateToolTypeInput;
  CreateToolTypeResult: CreateToolTypeResult;
  CreateToolUserFavoriteInput: CreateToolUserFavoriteInput;
  CreateToolUserFavoriteResult: CreateToolUserFavoriteResult;
  CreateUomInput: CreateUomInput;
  CreateUomResult: CreateUomResult;
  CreateUserAccountInput: CreateUserAccountInput;
  CreateUserAccountResult: CreateUserAccountResult;
  CreateUserInput: CreateUserInput;
  CreateUserInputWithProjectIds: CreateUserInputWithProjectIds;
  CreateUserProjectInput: CreateUserProjectInput;
  CreateUserProjectResult: CreateUserProjectResult;
  CreateUserResult: CreateUserResult;
  CreateUserRoleInput: CreateUserRoleInput;
  CreateUserRoleResult: CreateUserRoleResult;
  CreateUserToolRoomInput: CreateUserToolRoomInput;
  CreateUserToolRoomResult: CreateUserToolRoomResult;
  Crew: Crew;
  CursorPaginationInput: CursorPaginationInput;
  Date: Scalars['Date'];
  Datetime: Scalars['Datetime'];
  DeleteCrewInput: DeleteCrewInput;
  DeleteCrewResult: DeleteCrewResult;
  DeleteEmployeePhotosInput: DeleteEmployeePhotosInput;
  DeleteEmployeePhotosResult: DeleteEmployeePhotosResult;
  DeleteOutboundInterfaceInput: DeleteOutboundInterfaceInput;
  DeleteOutboundInterfaceResult: DeleteOutboundInterfaceResult;
  DeleteOutboundRetryInput: DeleteOutboundRetryInput;
  DeleteOutboundRetryResult: DeleteOutboundRetryResult;
  DeletePermissionInput: DeletePermissionInput;
  DeletePermissionResult: DeletePermissionResult;
  DeleteProjectConfigurationInput: DeleteProjectConfigurationInput;
  DeleteProjectConfigurationResult: DeleteProjectConfigurationResult;
  DeleteProjectToolCatalogInput: DeleteProjectToolCatalogInput;
  DeleteProjectToolCatalogResult: DeleteProjectToolCatalogResult;
  DeleteRoleInput: DeleteRoleInput;
  DeleteRolePermissionScopeInput: DeleteRolePermissionScopeInput;
  DeleteRolePermissionScopeResult: DeleteRolePermissionScopeResult;
  DeleteRoleResult: DeleteRoleResult;
  DeleteScopeInput: DeleteScopeInput;
  DeleteScopeResult: DeleteScopeResult;
  DeleteToolCatalogImageInput: DeleteToolCatalogImageInput;
  DeleteToolCatalogImageResult: DeleteToolCatalogImageResult;
  DeleteToolCheckInInput: DeleteToolCheckInInput;
  DeleteToolCheckInItemsInput: DeleteToolCheckInItemsInput;
  DeleteToolCheckInItemsResult: DeleteToolCheckInItemsResult;
  DeleteToolCheckInResult: DeleteToolCheckInResult;
  DeleteToolInventoryInput: DeleteToolInventoryInput;
  DeleteToolInventoryPhysicalCountInput: DeleteToolInventoryPhysicalCountInput;
  DeleteToolInventoryPhysicalCountResult: DeleteToolInventoryPhysicalCountResult;
  DeleteToolInventoryResult: DeleteToolInventoryResult;
  DeleteToolInventoryStatusInput: DeleteToolInventoryStatusInput;
  DeleteToolInventoryStatusResult: DeleteToolInventoryStatusResult;
  DeleteToolOrderCatalogInput: DeleteToolOrderCatalogInput;
  DeleteToolOrderCatalogResult: DeleteToolOrderCatalogResult;
  DeleteToolOrderHistoryInput: DeleteToolOrderHistoryInput;
  DeleteToolOrderHistoryResult: DeleteToolOrderHistoryResult;
  DeleteToolOrderInput: DeleteToolOrderInput;
  DeleteToolOrderInventoryInput: DeleteToolOrderInventoryInput;
  DeleteToolOrderInventoryResult: DeleteToolOrderInventoryResult;
  DeleteToolOrderResult: DeleteToolOrderResult;
  DeleteToolTransferInput: DeleteToolTransferInput;
  DeleteToolTransferItemInput: DeleteToolTransferItemInput;
  DeleteToolTransferItemResult: DeleteToolTransferItemResult;
  DeleteToolTransferResult: DeleteToolTransferResult;
  DeleteToolUserFavoriteResult: DeleteToolUserFavoriteResult;
  DeleteUomInput: DeleteUomInput;
  DeleteUomResult: DeleteUomResult;
  DeleteUserProjectInput: DeleteUserProjectInput;
  DeleteUserProjectResult: DeleteUserProjectResult;
  DeleteUserRoleInput: DeleteUserRoleInput;
  DeleteUserRoleResult: DeleteUserRoleResult;
  DeleteUserToolRoomInput: DeleteUserToolRoomInput;
  DeleteUserToolRoomResult: DeleteUserToolRoomResult;
  DispatchNotFulfilledInventoryInput: DispatchNotFulfilledInventoryInput;
  DispatchToolOrderInput: DispatchToolOrderInput;
  DispatchToolOrderStatusResult: DispatchToolOrderStatusResult;
  EmployeeImageInput: EmployeeImageInput;
  EmployeePhotos: EmployeePhotos;
  FilterConditionInput: FilterConditionInput;
  FilterInput: FilterInput;
  GeoLocation: GeoLocation;
  GeoLocationInput: GeoLocationInput;
  GroupedToolInventory: GroupedToolInventory;
  ImportCatalogStatus: ImportCatalogStatus;
  ImportInput: ImportInput;
  ImportResult: ImportResult;
  InboundControlUpdatedSubscriptionPayload: InboundControlUpdatedSubscriptionPayload;
  InboundControls: InboundControls;
  InboundControlsResult: InboundControlsResult;
  InboundInterface: InboundInterface;
  InboundProcess: InboundProcess;
  InboundQueue: InboundQueue;
  JSON: Scalars['JSON'];
  MergeBulkToolCategoryStatsImportResponse: MergeBulkToolCategoryStatsImportResponse;
  MergeBulkToolCategoryStatsImportResult: MergeBulkToolCategoryStatsImportResult;
  Mutation: {};
  OutboundInterface: OutboundInterface;
  OutboundRetry: OutboundRetry;
  PageInfo: PageInfo;
  PaginationInput: PaginationInput;
  Permission: Permission;
  PermissionScope: PermissionScope;
  PickToolOrderInventoryInput: PickToolOrderInventoryInput;
  PickToolOrderInventoryResponse: PickToolOrderInventoryResponse;
  PickToolOrderInventoryResult: PickToolOrderInventoryResult;
  Project: Project;
  ProjectConfiguration: ProjectConfiguration;
  ProjectToolCatalog: ProjectToolCatalog;
  ProjectToolCatalogCsvPayload: ProjectToolCatalogCsvPayload;
  Query: {};
  RetryFailedOutboundSubscriptionPayload: RetryFailedOutboundSubscriptionPayload;
  RetryOutboundInterfaceInput: RetryOutboundInterfaceInput;
  Role: Role;
  RolePermissionScope: RolePermissionScope;
  SaveToolUserFavoriteInput: SaveToolUserFavoriteInput;
  SaveToolUserFavoriteResult: SaveToolUserFavoriteResult;
  Scope: Scope;
  SearchCrewResult: SearchCrewResult;
  SearchEmployeePhotosResult: SearchEmployeePhotosResult;
  SearchGroupedInventoryResult: SearchGroupedInventoryResult;
  SearchInboundControlsResult: SearchInboundControlsResult;
  SearchInboundInterfaceResult: SearchInboundInterfaceResult;
  SearchInboundProcessResult: SearchInboundProcessResult;
  SearchInboundQueueResult: SearchInboundQueueResult;
  SearchInput: SearchInput;
  SearchOutboundInterfaceResult: SearchOutboundInterfaceResult;
  SearchOutboundRetryResult: SearchOutboundRetryResult;
  SearchPermissionResult: SearchPermissionResult;
  SearchProjectConfigurationResult: SearchProjectConfigurationResult;
  SearchProjectToolCatalogResult: SearchProjectToolCatalogResult;
  SearchProjectsResult: SearchProjectsResult;
  SearchRolePermissionScopeResult: SearchRolePermissionScopeResult;
  SearchRoleResult: SearchRoleResult;
  SearchScopeResult: SearchScopeResult;
  SearchToolCatalogImageResult: SearchToolCatalogImageResult;
  SearchToolCatalogResult: SearchToolCatalogResult;
  SearchToolCategoryResult: SearchToolCategoryResult;
  SearchToolCategoryStatsResult: SearchToolCategoryStatsResult;
  SearchToolCheckInItemsResult: SearchToolCheckInItemsResult;
  SearchToolCheckInResult: SearchToolCheckInResult;
  SearchToolInventoryPhysicalCountResult: SearchToolInventoryPhysicalCountResult;
  SearchToolInventoryResult: SearchToolInventoryResult;
  SearchToolInventoryStatusResult: SearchToolInventoryStatusResult;
  SearchToolOrderCatalogResult: SearchToolOrderCatalogResult;
  SearchToolOrderHistoryResult: SearchToolOrderHistoryResult;
  SearchToolOrderInventoryResult: SearchToolOrderInventoryResult;
  SearchToolOrderResult: SearchToolOrderResult;
  SearchToolRoomResult: SearchToolRoomResult;
  SearchToolTransferHistoryResult: SearchToolTransferHistoryResult;
  SearchToolTransferItemResult: SearchToolTransferItemResult;
  SearchToolTransferResult: SearchToolTransferResult;
  SearchToolTypeResult: SearchToolTypeResult;
  SearchToolUserFavoriteResult: SearchToolUserFavoriteResult;
  SearchUomResult: SearchUomResult;
  SearchUserProjectResult: SearchUserProjectResult;
  SearchUserResult: SearchUserResult;
  SearchUserRoleResult: SearchUserRoleResult;
  SearchUserToolRoomResult: SearchUserToolRoomResult;
  SortInput: SortInput;
  Subscription: {};
  Time: Scalars['Time'];
  ToggleCountRequiredInput: ToggleCountRequiredInput;
  ToggleCountRequiredResult: ToggleCountRequiredResult;
  ToolCatalog: ToolCatalog;
  ToolCatalogImage: ToolCatalogImage;
  ToolCatalogImageUrlInput: ToolCatalogImageUrlInput;
  ToolCategory: ToolCategory;
  ToolCategoryStats: ToolCategoryStats;
  ToolCheckIn: ToolCheckIn;
  ToolCheckInErrors: ToolCheckInErrors;
  ToolCheckInInput: ToolCheckInInput;
  ToolCheckInItems: ToolCheckInItems;
  ToolCheckInItemsInput: ToolCheckInItemsInput;
  ToolCheckInResult: ToolCheckInResult;
  ToolHoundOutboundSubscriptionPayload: ToolHoundOutboundSubscriptionPayload;
  ToolInventory: ToolInventory;
  ToolInventoryInput: ToolInventoryInput;
  ToolInventoryPhysicalCount: ToolInventoryPhysicalCount;
  ToolInventoryStats: ToolInventoryStats;
  ToolInventoryStatsResult: ToolInventoryStatsResult;
  ToolInventoryStatus: ToolInventoryStatus;
  ToolInventorySubscriptionPayload: ToolInventorySubscriptionPayload;
  ToolOrder: ToolOrder;
  ToolOrderAvailableInventory: ToolOrderAvailableInventory;
  ToolOrderCatalog: ToolOrderCatalog;
  ToolOrderHistory: ToolOrderHistory;
  ToolOrderInventory: ToolOrderInventory;
  ToolOrderInventoryCreatedSubscriptionPayload: ToolOrderInventoryCreatedSubscriptionPayload;
  ToolOrderItemsStats: ToolOrderItemsStats;
  ToolOrderStats: ToolOrderStats;
  ToolOrderStatsInput: ToolOrderStatsInput;
  ToolOrderStatsResponse: ToolOrderStatsResponse;
  ToolOrderStatsResult: ToolOrderStatsResult;
  ToolOrderStatusData: ToolOrderStatusData;
  ToolOrderStatusSubscriptionPayload: ToolOrderStatusSubscriptionPayload;
  ToolOrderSubscriptionPayload: ToolOrderSubscriptionPayload;
  ToolOrderUpdatedSubscriptionPayload: ToolOrderUpdatedSubscriptionPayload;
  ToolRoom: ToolRoom;
  ToolRoomSubscriptionPayload: ToolRoomSubscriptionPayload;
  ToolTransfer: ToolTransfer;
  ToolTransferHistory: ToolTransferHistory;
  ToolTransferItem: ToolTransferItem;
  ToolTransferStats: ToolTransferStats;
  ToolType: ToolType;
  ToolUserFavorite: ToolUserFavorite;
  ToolUserFavoriteStats: ToolUserFavoriteStats;
  Uom: Uom;
  UpdateCrewInput: UpdateCrewInput;
  UpdateCrewResult: UpdateCrewResult;
  UpdateEmployeePhotosInput: UpdateEmployeePhotosInput;
  UpdateEmployeePhotosResult: UpdateEmployeePhotosResult;
  UpdateInboundControlsInput: UpdateInboundControlsInput;
  UpdateOutboundInterfaceInput: UpdateOutboundInterfaceInput;
  UpdateOutboundInterfaceResult: UpdateOutboundInterfaceResult;
  UpdateOutboundRetryInput: UpdateOutboundRetryInput;
  UpdateOutboundRetryResult: UpdateOutboundRetryResult;
  UpdatePermissionInput: UpdatePermissionInput;
  UpdatePermissionResult: UpdatePermissionResult;
  UpdateProjectConfigurationInput: UpdateProjectConfigurationInput;
  UpdateProjectConfigurationResult: UpdateProjectConfigurationResult;
  UpdateProjectToolCatalogInput: UpdateProjectToolCatalogInput;
  UpdateProjectToolCatalogResult: UpdateProjectToolCatalogResult;
  UpdateRoleInput: UpdateRoleInput;
  UpdateRolePermissionScopeInput: UpdateRolePermissionScopeInput;
  UpdateRolePermissionScopeResult: UpdateRolePermissionScopeResult;
  UpdateRoleResult: UpdateRoleResult;
  UpdateScopeInput: UpdateScopeInput;
  UpdateScopeResult: UpdateScopeResult;
  UpdateToolCatalogImageInput: UpdateToolCatalogImageInput;
  UpdateToolCatalogImageResult: UpdateToolCatalogImageResult;
  UpdateToolCatalogInput: UpdateToolCatalogInput;
  UpdateToolCatalogResult: UpdateToolCatalogResult;
  UpdateToolCategoryInput: UpdateToolCategoryInput;
  UpdateToolCategoryResult: UpdateToolCategoryResult;
  UpdateToolCheckInInput: UpdateToolCheckInInput;
  UpdateToolCheckInItemsInput: UpdateToolCheckInItemsInput;
  UpdateToolCheckInItemsResult: UpdateToolCheckInItemsResult;
  UpdateToolCheckInResult: UpdateToolCheckInResult;
  UpdateToolInventoryInput: UpdateToolInventoryInput;
  UpdateToolInventoryPhysicalCountInput: UpdateToolInventoryPhysicalCountInput;
  UpdateToolInventoryPhysicalCountResult: UpdateToolInventoryPhysicalCountResult;
  UpdateToolInventoryResult: UpdateToolInventoryResult;
  UpdateToolInventoryStatusInput: UpdateToolInventoryStatusInput;
  UpdateToolInventoryStatusResult: UpdateToolInventoryStatusResult;
  UpdateToolOrderCatalogInput: UpdateToolOrderCatalogInput;
  UpdateToolOrderCatalogResult: UpdateToolOrderCatalogResult;
  UpdateToolOrderHistoryInput: UpdateToolOrderHistoryInput;
  UpdateToolOrderHistoryResult: UpdateToolOrderHistoryResult;
  UpdateToolOrderInput: UpdateToolOrderInput;
  UpdateToolOrderInventoryInput: UpdateToolOrderInventoryInput;
  UpdateToolOrderInventoryResult: UpdateToolOrderInventoryResult;
  UpdateToolOrderResult: UpdateToolOrderResult;
  UpdateToolRoomInput: UpdateToolRoomInput;
  UpdateToolRoomResult: UpdateToolRoomResult;
  UpdateToolTransferInput: UpdateToolTransferInput;
  UpdateToolTransferItemInput: UpdateToolTransferItemInput;
  UpdateToolTransferItemResult: UpdateToolTransferItemResult;
  UpdateToolTransferResult: UpdateToolTransferResult;
  UpdateUomInput: UpdateUomInput;
  UpdateUomResult: UpdateUomResult;
  UpdateUserAccountInput: UpdateUserAccountInput;
  UpdateUserAccountResult: UpdateUserAccountResult;
  UpdateUserDefaultProjectInput: UpdateUserDefaultProjectInput;
  UpdateUserDefaultProjectResult: UpdateUserDefaultProjectResult;
  UpdateUserInput: UpdateUserInput;
  UpdateUserProjectInput: UpdateUserProjectInput;
  UpdateUserProjectResult: UpdateUserProjectResult;
  UpdateUserResult: UpdateUserResult;
  UpdateUserRoleInput: UpdateUserRoleInput;
  UpdateUserRoleResult: UpdateUserRoleResult;
  UpdateUserToolRoomInput: UpdateUserToolRoomInput;
  UpdateUserToolRoomResult: UpdateUserToolRoomResult;
  User: User;
  UserProject: UserProject;
  UserRole: UserRole;
  UserToolRoom: UserToolRoom;
};

export type AuthDirectiveArgs = {
  requires: AuthPermission;
};

export type AuthDirectiveResolver<Result, Parent, ContextType = any, Args = AuthDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AddDeleteRolePermissionScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AddDeleteRolePermissionScopeResult'] = ResolversParentTypes['AddDeleteRolePermissionScopeResult']> = {
  error?: Resolver<Maybe<ResolversTypes['DeleteRolePermissionScopeError']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['RolePermissionScope']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdhocOrderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdhocOrderResult'] = ResolversParentTypes['AdhocOrderResult']> = {
  error?: Resolver<Maybe<ResolversTypes['AdhocOrderError']>, ParentType, ContextType>;
  toolOrder?: Resolver<Maybe<ResolversTypes['ToolOrder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvanceToolOrderStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvanceToolOrderStatusResult'] = ResolversParentTypes['AdvanceToolOrderStatusResult']> = {
  error?: Resolver<Maybe<ResolversTypes['AdvanceToolOrderStatusError']>, ParentType, ContextType>;
  toolOrder?: Resolver<Maybe<ResolversTypes['ToolOrder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkMergeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkMergeResult'] = ResolversParentTypes['BulkMergeResult']> = {
  insertCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updateCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkUpdateToolInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkUpdateToolInventoryResult'] = ResolversParentTypes['BulkUpdateToolInventoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['UpdateToolInventoryError']>, ParentType, ContextType>;
  toolInventoryItems?: Resolver<Maybe<Array<ResolversTypes['ToolInventory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelToolOrderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CancelToolOrderResult'] = ResolversParentTypes['CancelToolOrderResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['CancelToolOrderError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateCrewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateCrewResult'] = ResolversParentTypes['CreateCrewResult']> = {
  crew?: Resolver<Maybe<ResolversTypes['Crew']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['CreateCrewError']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateEmployeePhotosResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateEmployeePhotosResult'] = ResolversParentTypes['CreateEmployeePhotosResult']> = {
  employeePhotos?: Resolver<Maybe<ResolversTypes['EmployeePhotos']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['CreateEmployeePhotosError']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateInboundInterfaceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateInboundInterfaceResult'] = ResolversParentTypes['CreateInboundInterfaceResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateInboundInterfaceError']>, ParentType, ContextType>;
  inboundInterface?: Resolver<Maybe<ResolversTypes['InboundInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateInboundProcessResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateInboundProcessResult'] = ResolversParentTypes['CreateInboundProcessResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateInboundProcessError']>, ParentType, ContextType>;
  inboundProcess?: Resolver<Maybe<ResolversTypes['InboundProcess']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateInboundQueueResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateInboundQueueResult'] = ResolversParentTypes['CreateInboundQueueResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateInboundQueueError']>, ParentType, ContextType>;
  inboundQueue?: Resolver<Maybe<ResolversTypes['InboundQueue']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOutboundInterfaceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOutboundInterfaceResult'] = ResolversParentTypes['CreateOutboundInterfaceResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateOutboundInterfaceError']>, ParentType, ContextType>;
  outboundInterface?: Resolver<Maybe<ResolversTypes['OutboundInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateOutboundRetryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateOutboundRetryResult'] = ResolversParentTypes['CreateOutboundRetryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateOutboundRetryError']>, ParentType, ContextType>;
  outboundRetry?: Resolver<Maybe<ResolversTypes['OutboundRetry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreatePermissionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreatePermissionResult'] = ResolversParentTypes['CreatePermissionResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreatePermissionError']>, ParentType, ContextType>;
  permission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateProjectConfigurationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateProjectConfigurationResult'] = ResolversParentTypes['CreateProjectConfigurationResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateProjectConfigurationError']>, ParentType, ContextType>;
  projectConfiguration?: Resolver<Maybe<ResolversTypes['ProjectConfiguration']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateProjectToolCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateProjectToolCatalogResult'] = ResolversParentTypes['CreateProjectToolCatalogResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateProjectToolCatalogError']>, ParentType, ContextType>;
  projectToolCatalog?: Resolver<Maybe<ResolversTypes['ProjectToolCatalog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateRolePermissionScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateRolePermissionScopeResult'] = ResolversParentTypes['CreateRolePermissionScopeResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateRolePermissionScopeError']>, ParentType, ContextType>;
  rolePermissionScope?: Resolver<Maybe<ResolversTypes['RolePermissionScope']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateRoleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateRoleResult'] = ResolversParentTypes['CreateRoleResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateRoleError']>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateScopeResult'] = ResolversParentTypes['CreateScopeResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateScopeError']>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['Scope']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolCatalogImageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolCatalogImageResult'] = ResolversParentTypes['CreateToolCatalogImageResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolCatalogImageError']>, ParentType, ContextType>;
  toolCatalogImage?: Resolver<Maybe<ResolversTypes['ToolCatalogImage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolCatalogResult'] = ResolversParentTypes['CreateToolCatalogResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolCatalogError']>, ParentType, ContextType>;
  toolCatalog?: Resolver<Maybe<ResolversTypes['ToolCatalog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolCategoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolCategoryResult'] = ResolversParentTypes['CreateToolCategoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolCategoryError']>, ParentType, ContextType>;
  toolCategory?: Resolver<Maybe<ResolversTypes['ToolCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolCheckInItemsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolCheckInItemsResult'] = ResolversParentTypes['CreateToolCheckInItemsResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolCheckInItemsError']>, ParentType, ContextType>;
  toolCheckInItems?: Resolver<Maybe<ResolversTypes['ToolCheckInItems']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolCheckInResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolCheckInResult'] = ResolversParentTypes['CreateToolCheckInResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolCheckInError']>, ParentType, ContextType>;
  toolCheckIn?: Resolver<Maybe<ResolversTypes['ToolCheckIn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolInventoryPhysicalCountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolInventoryPhysicalCountResult'] = ResolversParentTypes['CreateToolInventoryPhysicalCountResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolInventoryPhysicalCountError']>, ParentType, ContextType>;
  toolInventoryPhysicalCount?: Resolver<Maybe<ResolversTypes['ToolInventoryPhysicalCount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolInventoryResult'] = ResolversParentTypes['CreateToolInventoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolInventoryError']>, ParentType, ContextType>;
  toolInventory?: Resolver<Maybe<ResolversTypes['ToolInventory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolInventoryStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolInventoryStatusResult'] = ResolversParentTypes['CreateToolInventoryStatusResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolInventoryStatusError']>, ParentType, ContextType>;
  toolInventoryStatus?: Resolver<Maybe<ResolversTypes['ToolInventoryStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolOrderCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolOrderCatalogResult'] = ResolversParentTypes['CreateToolOrderCatalogResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolOrderCatalogError']>, ParentType, ContextType>;
  toolOrderCatalog?: Resolver<Maybe<ResolversTypes['ToolOrderCatalog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolOrderHistoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolOrderHistoryResult'] = ResolversParentTypes['CreateToolOrderHistoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolOrderHistoryError']>, ParentType, ContextType>;
  toolOrderHistory?: Resolver<Maybe<ResolversTypes['ToolOrderHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolOrderInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolOrderInventoryResult'] = ResolversParentTypes['CreateToolOrderInventoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolOrderInventoryError']>, ParentType, ContextType>;
  toolOrderInventory?: Resolver<Maybe<ResolversTypes['ToolOrderInventory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolOrderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolOrderResult'] = ResolversParentTypes['CreateToolOrderResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolOrderError']>, ParentType, ContextType>;
  toolOrder?: Resolver<Maybe<ResolversTypes['ToolOrder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolTransferHistoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolTransferHistoryResult'] = ResolversParentTypes['CreateToolTransferHistoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolTransferHistoryError']>, ParentType, ContextType>;
  toolTransferHistory?: Resolver<Maybe<ResolversTypes['ToolTransferHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolTransferItemResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolTransferItemResult'] = ResolversParentTypes['CreateToolTransferItemResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolTransferItemError']>, ParentType, ContextType>;
  toolTransferItem?: Resolver<Maybe<ResolversTypes['ToolTransferItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolTransferResult'] = ResolversParentTypes['CreateToolTransferResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolTransferError']>, ParentType, ContextType>;
  toolTransfer?: Resolver<Maybe<ResolversTypes['ToolTransfer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolTypeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolTypeResult'] = ResolversParentTypes['CreateToolTypeResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolTypeError']>, ParentType, ContextType>;
  toolType?: Resolver<Maybe<ResolversTypes['ToolType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateToolUserFavoriteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateToolUserFavoriteResult'] = ResolversParentTypes['CreateToolUserFavoriteResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolUserFavoriteError']>, ParentType, ContextType>;
  toolUserFavorite?: Resolver<Maybe<ResolversTypes['ToolUserFavorite']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUomResult'] = ResolversParentTypes['CreateUomResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateUomError']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['Uom']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserAccountResult'] = ResolversParentTypes['CreateUserAccountResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateUserError']>, ParentType, ContextType>;
  userAccount?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserProjectResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserProjectResult'] = ResolversParentTypes['CreateUserProjectResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateUserProjectError']>, ParentType, ContextType>;
  userProject?: Resolver<Maybe<ResolversTypes['UserProject']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserResult'] = ResolversParentTypes['CreateUserResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateUserError']>, ParentType, ContextType>;
  userAccount?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserRoleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserRoleResult'] = ResolversParentTypes['CreateUserRoleResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateUserRoleError']>, ParentType, ContextType>;
  userRole?: Resolver<Maybe<ResolversTypes['UserRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateUserToolRoomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateUserToolRoomResult'] = ResolversParentTypes['CreateUserToolRoomResult']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateUserToolRoomError']>, ParentType, ContextType>;
  userToolRoom?: Resolver<Maybe<ResolversTypes['UserToolRoom']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CrewResolvers<ContextType = any, ParentType extends ResolversParentTypes['Crew'] = ResolversParentTypes['Crew']> = {
  crewCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  crewNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  foremanId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  generalForemanId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  superintendentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DatetimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Datetime'], any> {
  name: 'Datetime';
}

export type DeleteCrewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteCrewResult'] = ResolversParentTypes['DeleteCrewResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteCrewError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteEmployeePhotosResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteEmployeePhotosResult'] = ResolversParentTypes['DeleteEmployeePhotosResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteEmployeePhotosError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteOutboundInterfaceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOutboundInterfaceResult'] = ResolversParentTypes['DeleteOutboundInterfaceResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteOutboundInterfaceError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteOutboundRetryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteOutboundRetryResult'] = ResolversParentTypes['DeleteOutboundRetryResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteOutboundRetryError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletePermissionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletePermissionResult'] = ResolversParentTypes['DeletePermissionResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeletePermissionError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteProjectConfigurationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteProjectConfigurationResult'] = ResolversParentTypes['DeleteProjectConfigurationResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteProjectConfigurationError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteProjectToolCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteProjectToolCatalogResult'] = ResolversParentTypes['DeleteProjectToolCatalogResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteProjectToolCatalogError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteRolePermissionScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteRolePermissionScopeResult'] = ResolversParentTypes['DeleteRolePermissionScopeResult']> = {
  error?: Resolver<Maybe<ResolversTypes['DeleteRolePermissionScopeError']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteRoleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteRoleResult'] = ResolversParentTypes['DeleteRoleResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteRoleError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteScopeResult'] = ResolversParentTypes['DeleteScopeResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteScopeError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolCatalogImageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolCatalogImageResult'] = ResolversParentTypes['DeleteToolCatalogImageResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolCatalogImageError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolCheckInItemsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolCheckInItemsResult'] = ResolversParentTypes['DeleteToolCheckInItemsResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolCheckInItemsError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolCheckInResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolCheckInResult'] = ResolversParentTypes['DeleteToolCheckInResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolCheckInError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolInventoryPhysicalCountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolInventoryPhysicalCountResult'] = ResolversParentTypes['DeleteToolInventoryPhysicalCountResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolInventoryPhysicalCountError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolInventoryResult'] = ResolversParentTypes['DeleteToolInventoryResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolInventoryError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolInventoryStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolInventoryStatusResult'] = ResolversParentTypes['DeleteToolInventoryStatusResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolInventoryStatusError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolOrderCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolOrderCatalogResult'] = ResolversParentTypes['DeleteToolOrderCatalogResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolOrderCatalogError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolOrderHistoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolOrderHistoryResult'] = ResolversParentTypes['DeleteToolOrderHistoryResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolOrderHistoryError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolOrderInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolOrderInventoryResult'] = ResolversParentTypes['DeleteToolOrderInventoryResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolOrderInventoryError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  toolOrder?: Resolver<ResolversTypes['ToolOrder'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolOrderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolOrderResult'] = ResolversParentTypes['DeleteToolOrderResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolOrderError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolTransferItemResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolTransferItemResult'] = ResolversParentTypes['DeleteToolTransferItemResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolTransferItemError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolTransferResult'] = ResolversParentTypes['DeleteToolTransferResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolTransferError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteToolUserFavoriteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteToolUserFavoriteResult'] = ResolversParentTypes['DeleteToolUserFavoriteResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteToolUserFavoriteError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isFavorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  toolCatalogId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUomResult'] = ResolversParentTypes['DeleteUomResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteUomError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserProjectResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUserProjectResult'] = ResolversParentTypes['DeleteUserProjectResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteUserProjectError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserRoleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUserRoleResult'] = ResolversParentTypes['DeleteUserRoleResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteUserRoleError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserToolRoomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteUserToolRoomResult'] = ResolversParentTypes['DeleteUserToolRoomResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['DeleteUserToolRoomError']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DispatchToolOrderStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['DispatchToolOrderStatusResult'] = ResolversParentTypes['DispatchToolOrderStatusResult']> = {
  error?: Resolver<Maybe<ResolversTypes['DispatchToolOrderStatusError']>, ParentType, ContextType>;
  toolOrder?: Resolver<Maybe<ResolversTypes['ToolOrder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployeePhotosResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployeePhotos'] = ResolversParentTypes['EmployeePhotos']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeoLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeoLocation'] = ResolversParentTypes['GeoLocation']> = {
  latitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  longitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupedToolInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['GroupedToolInventory'] = ResolversParentTypes['GroupedToolInventory']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['GroupedToolInventory']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  barCodeId?: Resolver<ResolversTypes['String'], { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  createdByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"createdBy":true}>, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  isSerialized?: Resolver<ResolversTypes['Boolean'], { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  limitCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  onHandCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolCatalog?: Resolver<Maybe<ResolversTypes['ToolCatalog']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolCatalogId?: Resolver<ResolversTypes['ID'], { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolRoom?: Resolver<Maybe<ResolversTypes['ToolRoom']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  updatedByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"updatedBy":true}>, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'GroupedToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportCatalogStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportCatalogStatus'] = ResolversParentTypes['ImportCatalogStatus']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  itemsErrored?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  itemsImported?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  itemsReceived?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ImportStatus'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImportResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportResult'] = ResolversParentTypes['ImportResult']> = {
  error?: Resolver<Maybe<ResolversTypes['ImportError']>, ParentType, ContextType>;
  errorDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  inboundControls?: Resolver<Maybe<Array<ResolversTypes['InboundControls']>>, ParentType, ContextType>;
  isSuccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboundControlUpdatedSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboundControlUpdatedSubscriptionPayload'] = ResolversParentTypes['InboundControlUpdatedSubscriptionPayload']> = {
  endDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  errorDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorSummary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  importSummary?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  interfaceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboundControlsResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboundControls'] = ResolversParentTypes['InboundControls']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['InboundControls']>, { __typename: 'InboundControls' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  errorDetails?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  errorSummary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  importSummary?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  interfaceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboundControlsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboundControlsResult'] = ResolversParentTypes['InboundControlsResult']> = {
  error?: Resolver<Maybe<ResolversTypes['InboundControlsError']>, ParentType, ContextType>;
  inboundControlsId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboundInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboundInterface'] = ResolversParentTypes['InboundInterface']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboundProcessResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboundProcess'] = ResolversParentTypes['InboundProcess']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InboundQueueResolvers<ContextType = any, ParentType extends ResolversParentTypes['InboundQueue'] = ResolversParentTypes['InboundQueue']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parameters?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type MergeBulkToolCategoryStatsImportResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['MergeBulkToolCategoryStatsImportResponse'] = ResolversParentTypes['MergeBulkToolCategoryStatsImportResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['MergeBulkToolCategoryStatsImportError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['MergeBulkToolCategoryStatsImportResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MergeBulkToolCategoryStatsImportResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['MergeBulkToolCategoryStatsImportResult'] = ResolversParentTypes['MergeBulkToolCategoryStatsImportResult']> = {
  deleteCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  insertCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updateCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addDeleteRolePermissionScope?: Resolver<ResolversTypes['AddDeleteRolePermissionScopeResult'], ParentType, ContextType, RequireFields<MutationAddDeleteRolePermissionScopeArgs, 'addDeleteRolePermissionsInput'>>;
  advanceToolOrderStatus?: Resolver<ResolversTypes['AdvanceToolOrderStatusResult'], ParentType, ContextType, RequireFields<MutationAdvanceToolOrderStatusArgs, 'advanceToolOrderStatusInput'>>;
  bulkUpdateToolInventory?: Resolver<ResolversTypes['BulkUpdateToolInventoryResult'], ParentType, ContextType, RequireFields<MutationBulkUpdateToolInventoryArgs, 'input'>>;
  cancelToolOrder?: Resolver<ResolversTypes['CancelToolOrderResult'], ParentType, ContextType, RequireFields<MutationCancelToolOrderArgs, 'cancelToolOrderInput'>>;
  clearAll?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createAdhocToolOrder?: Resolver<ResolversTypes['AdhocOrderResult'], ParentType, ContextType, RequireFields<MutationCreateAdhocToolOrderArgs, 'createAdhocOrderInput'>>;
  createCrew?: Resolver<ResolversTypes['CreateCrewResult'], ParentType, ContextType, RequireFields<MutationCreateCrewArgs, 'createCrewInput'>>;
  createInboundControls?: Resolver<ResolversTypes['InboundControlsResult'], ParentType, ContextType, RequireFields<MutationCreateInboundControlsArgs, 'createInboundControlsInput'>>;
  createInboundInterface?: Resolver<ResolversTypes['CreateInboundInterfaceResult'], ParentType, ContextType, RequireFields<MutationCreateInboundInterfaceArgs, 'createInboundInterfaceInput'>>;
  createInboundProcess?: Resolver<ResolversTypes['CreateInboundProcessResult'], ParentType, ContextType, RequireFields<MutationCreateInboundProcessArgs, 'createInboundProcessInput'>>;
  createInboundQueue?: Resolver<ResolversTypes['CreateInboundQueueResult'], ParentType, ContextType, RequireFields<MutationCreateInboundQueueArgs, 'createInboundQueueInput'>>;
  createOutboundInterface?: Resolver<ResolversTypes['CreateOutboundInterfaceResult'], ParentType, ContextType, RequireFields<MutationCreateOutboundInterfaceArgs, 'createOutboundInterfaceInput'>>;
  createOutboundRetry?: Resolver<ResolversTypes['CreateOutboundRetryResult'], ParentType, ContextType, RequireFields<MutationCreateOutboundRetryArgs, 'createOutboundRetryInput'>>;
  createPermission?: Resolver<ResolversTypes['CreatePermissionResult'], ParentType, ContextType, RequireFields<MutationCreatePermissionArgs, 'createPermissionInput'>>;
  createProjectConfiguration?: Resolver<ResolversTypes['CreateProjectConfigurationResult'], ParentType, ContextType, RequireFields<MutationCreateProjectConfigurationArgs, 'createProjectConfigurationInput'>>;
  createProjectToolCatalog?: Resolver<ResolversTypes['CreateProjectToolCatalogResult'], ParentType, ContextType, RequireFields<MutationCreateProjectToolCatalogArgs, 'createProjectToolCatalogInput'>>;
  createRole?: Resolver<ResolversTypes['CreateRoleResult'], ParentType, ContextType, RequireFields<MutationCreateRoleArgs, 'createRoleInput'>>;
  createRolePermissionScope?: Resolver<ResolversTypes['CreateRolePermissionScopeResult'], ParentType, ContextType, RequireFields<MutationCreateRolePermissionScopeArgs, 'createRolePermissionScopeInput'>>;
  createScope?: Resolver<ResolversTypes['CreateScopeResult'], ParentType, ContextType, RequireFields<MutationCreateScopeArgs, 'createScopeInput'>>;
  createToolCatalog?: Resolver<ResolversTypes['CreateToolCatalogResult'], ParentType, ContextType, RequireFields<MutationCreateToolCatalogArgs, 'createToolCatalogInput'>>;
  createToolCategory?: Resolver<ResolversTypes['CreateToolCategoryResult'], ParentType, ContextType, RequireFields<MutationCreateToolCategoryArgs, 'createToolCategoryInput'>>;
  createToolCheckIn?: Resolver<ResolversTypes['CreateToolCheckInResult'], ParentType, ContextType, RequireFields<MutationCreateToolCheckInArgs, 'createToolCheckInInput'>>;
  createToolCheckInItems?: Resolver<ResolversTypes['CreateToolCheckInItemsResult'], ParentType, ContextType, RequireFields<MutationCreateToolCheckInItemsArgs, 'createToolCheckInItemsInput'>>;
  createToolInventory?: Resolver<ResolversTypes['CreateToolInventoryResult'], ParentType, ContextType, RequireFields<MutationCreateToolInventoryArgs, 'createToolInventoryInput'>>;
  createToolInventoryPhysicalCount?: Resolver<ResolversTypes['CreateToolInventoryPhysicalCountResult'], ParentType, ContextType, RequireFields<MutationCreateToolInventoryPhysicalCountArgs, 'createToolInventoryPhysicalCountInput'>>;
  createToolOrder?: Resolver<ResolversTypes['CreateToolOrderResult'], ParentType, ContextType, RequireFields<MutationCreateToolOrderArgs, 'createToolOrderInput'>>;
  createToolOrderCatalog?: Resolver<ResolversTypes['CreateToolOrderCatalogResult'], ParentType, ContextType, RequireFields<MutationCreateToolOrderCatalogArgs, 'createToolOrderCatalogInput'>>;
  createToolOrderInventory?: Resolver<ResolversTypes['CreateToolOrderInventoryResult'], ParentType, ContextType, RequireFields<MutationCreateToolOrderInventoryArgs, 'createToolOrderInventoryInput'>>;
  createToolTransfer?: Resolver<ResolversTypes['CreateToolTransferResult'], ParentType, ContextType, RequireFields<MutationCreateToolTransferArgs, 'createToolTransferInput'>>;
  createToolTransferHistory?: Resolver<ResolversTypes['CreateToolTransferHistoryResult'], ParentType, ContextType, RequireFields<MutationCreateToolTransferHistoryArgs, 'createToolTransferHistoryInput'>>;
  createToolTransferItem?: Resolver<ResolversTypes['CreateToolTransferItemResult'], ParentType, ContextType, RequireFields<MutationCreateToolTransferItemArgs, 'createToolTransferItemInput'>>;
  createToolType?: Resolver<ResolversTypes['CreateToolTypeResult'], ParentType, ContextType, RequireFields<MutationCreateToolTypeArgs, 'createToolTypeInput'>>;
  createToolUserFavorite?: Resolver<ResolversTypes['CreateToolUserFavoriteResult'], ParentType, ContextType, RequireFields<MutationCreateToolUserFavoriteArgs, 'createToolUserFavoriteInput'>>;
  createUom?: Resolver<ResolversTypes['CreateUomResult'], ParentType, ContextType, RequireFields<MutationCreateUomArgs, 'createUomInput'>>;
  createUserAccount?: Resolver<Maybe<ResolversTypes['CreateUserAccountResult']>, ParentType, ContextType, RequireFields<MutationCreateUserAccountArgs, 'createUserAccountInput'>>;
  createUserProject?: Resolver<ResolversTypes['CreateUserProjectResult'], ParentType, ContextType, RequireFields<MutationCreateUserProjectArgs, 'createUserProjectInput'>>;
  createUserRole?: Resolver<ResolversTypes['CreateUserRoleResult'], ParentType, ContextType, RequireFields<MutationCreateUserRoleArgs, 'createUserRoleInput'>>;
  createUserToolRoom?: Resolver<ResolversTypes['CreateUserToolRoomResult'], ParentType, ContextType, RequireFields<MutationCreateUserToolRoomArgs, 'createUserToolRoomInput'>>;
  deleteCrew?: Resolver<ResolversTypes['DeleteCrewResult'], ParentType, ContextType, RequireFields<MutationDeleteCrewArgs, 'deleteCrewInput'>>;
  deleteOutboundInterface?: Resolver<ResolversTypes['DeleteOutboundInterfaceResult'], ParentType, ContextType, RequireFields<MutationDeleteOutboundInterfaceArgs, 'deleteOutboundInterfaceInput'>>;
  deleteOutboundRetry?: Resolver<ResolversTypes['DeleteOutboundRetryResult'], ParentType, ContextType, RequireFields<MutationDeleteOutboundRetryArgs, 'deleteOutboundRetryInput'>>;
  deletePermission?: Resolver<ResolversTypes['DeletePermissionResult'], ParentType, ContextType, RequireFields<MutationDeletePermissionArgs, 'deletePermissionInput'>>;
  deleteProjectConfiguration?: Resolver<ResolversTypes['DeleteProjectConfigurationResult'], ParentType, ContextType, RequireFields<MutationDeleteProjectConfigurationArgs, 'deleteProjectConfigurationInput'>>;
  deleteProjectToolCatalog?: Resolver<ResolversTypes['DeleteProjectToolCatalogResult'], ParentType, ContextType, RequireFields<MutationDeleteProjectToolCatalogArgs, 'deleteProjectToolCatalogInput'>>;
  deleteRole?: Resolver<ResolversTypes['DeleteRoleResult'], ParentType, ContextType, RequireFields<MutationDeleteRoleArgs, 'deleteRoleInput'>>;
  deleteRolePermissionScope?: Resolver<ResolversTypes['DeleteRolePermissionScopeResult'], ParentType, ContextType, RequireFields<MutationDeleteRolePermissionScopeArgs, 'deleteRolePermissionScopeInput'>>;
  deleteScope?: Resolver<ResolversTypes['DeleteScopeResult'], ParentType, ContextType, RequireFields<MutationDeleteScopeArgs, 'deleteScopeInput'>>;
  deleteToolCheckIn?: Resolver<ResolversTypes['DeleteToolCheckInResult'], ParentType, ContextType, RequireFields<MutationDeleteToolCheckInArgs, 'deleteToolCheckInInput'>>;
  deleteToolCheckInItems?: Resolver<ResolversTypes['DeleteToolCheckInItemsResult'], ParentType, ContextType, RequireFields<MutationDeleteToolCheckInItemsArgs, 'deleteToolCheckInItemsInput'>>;
  deleteToolInventory?: Resolver<ResolversTypes['DeleteToolInventoryResult'], ParentType, ContextType, RequireFields<MutationDeleteToolInventoryArgs, 'deleteToolInventoryInput'>>;
  deleteToolInventoryPhysicalCount?: Resolver<ResolversTypes['DeleteToolInventoryPhysicalCountResult'], ParentType, ContextType, RequireFields<MutationDeleteToolInventoryPhysicalCountArgs, 'deleteToolInventoryPhysicalCountInput'>>;
  deleteToolOrder?: Resolver<ResolversTypes['DeleteToolOrderResult'], ParentType, ContextType, RequireFields<MutationDeleteToolOrderArgs, 'deleteToolOrderInput'>>;
  deleteToolOrderCatalog?: Resolver<ResolversTypes['DeleteToolOrderCatalogResult'], ParentType, ContextType, RequireFields<MutationDeleteToolOrderCatalogArgs, 'deleteToolOrderCatalogInput'>>;
  deleteToolOrderInventory?: Resolver<ResolversTypes['DeleteToolOrderInventoryResult'], ParentType, ContextType, RequireFields<MutationDeleteToolOrderInventoryArgs, 'deleteToolOrderInventoryInput'>>;
  deleteToolTransfer?: Resolver<ResolversTypes['DeleteToolTransferResult'], ParentType, ContextType, RequireFields<MutationDeleteToolTransferArgs, 'deleteToolTransferInput'>>;
  deleteToolTransferItem?: Resolver<ResolversTypes['DeleteToolTransferItemResult'], ParentType, ContextType, RequireFields<MutationDeleteToolTransferItemArgs, 'deleteToolTransferItemInput'>>;
  deleteToolUserFavorite?: Resolver<ResolversTypes['DeleteToolUserFavoriteResult'], ParentType, ContextType, RequireFields<MutationDeleteToolUserFavoriteArgs, 'toolUserFavoriteId'>>;
  deleteToolUserFavoriteByToolCatalogId?: Resolver<ResolversTypes['DeleteToolUserFavoriteResult'], ParentType, ContextType, RequireFields<MutationDeleteToolUserFavoriteByToolCatalogIdArgs, 'toolCatalogId'>>;
  deleteUom?: Resolver<ResolversTypes['DeleteUomResult'], ParentType, ContextType, RequireFields<MutationDeleteUomArgs, 'deleteUomInput'>>;
  deleteUserProject?: Resolver<ResolversTypes['DeleteUserProjectResult'], ParentType, ContextType, RequireFields<MutationDeleteUserProjectArgs, 'deleteUserProjectInput'>>;
  deleteUserRole?: Resolver<ResolversTypes['DeleteUserRoleResult'], ParentType, ContextType, RequireFields<MutationDeleteUserRoleArgs, 'deleteUserRoleInput'>>;
  deleteUserToolRoom?: Resolver<ResolversTypes['DeleteUserToolRoomResult'], ParentType, ContextType, RequireFields<MutationDeleteUserToolRoomArgs, 'deleteUserToolRoomInput'>>;
  dispatchToolOrder?: Resolver<ResolversTypes['DispatchToolOrderStatusResult'], ParentType, ContextType, RequireFields<MutationDispatchToolOrderArgs, 'dispatchToolOrderInput'>>;
  import?: Resolver<ResolversTypes['ImportResult'], ParentType, ContextType, RequireFields<MutationImportArgs, 'importInput'>>;
  importCatalog?: Resolver<ResolversTypes['ImportCatalogStatus'], ParentType, ContextType>;
  mergeBulkToolCategoryStatsImport?: Resolver<ResolversTypes['MergeBulkToolCategoryStatsImportResponse'], ParentType, ContextType>;
  pickInventory?: Resolver<ResolversTypes['PickToolOrderInventoryResult'], ParentType, ContextType, RequireFields<MutationPickInventoryArgs, 'pickToolOrderInventoryInput'>>;
  retryOutboundInterface?: Resolver<ResolversTypes['UpdateOutboundInterfaceResult'], ParentType, ContextType, RequireFields<MutationRetryOutboundInterfaceArgs, 'retryOutboundInterfaceInput'>>;
  saveToolUserFavorites?: Resolver<ResolversTypes['SaveToolUserFavoriteResult'], ParentType, ContextType, RequireFields<MutationSaveToolUserFavoritesArgs, 'input'>>;
  toggleCountRequired?: Resolver<ResolversTypes['ToggleCountRequiredResult'], ParentType, ContextType, RequireFields<MutationToggleCountRequiredArgs, 'toggleCountRequiredInput'>>;
  toolCheckIn?: Resolver<ResolversTypes['ToolCheckInResult'], ParentType, ContextType, RequireFields<MutationToolCheckInArgs, 'toolCheckInInput'>>;
  updateCrew?: Resolver<ResolversTypes['UpdateCrewResult'], ParentType, ContextType, RequireFields<MutationUpdateCrewArgs, 'updateCrewInput'>>;
  updateInboundControls?: Resolver<ResolversTypes['InboundControlsResult'], ParentType, ContextType, RequireFields<MutationUpdateInboundControlsArgs, 'updateInboundControlsInput'>>;
  updateOutboundInterface?: Resolver<ResolversTypes['UpdateOutboundInterfaceResult'], ParentType, ContextType, RequireFields<MutationUpdateOutboundInterfaceArgs, 'updateOutboundInterfaceInput'>>;
  updateOutboundRetry?: Resolver<ResolversTypes['UpdateOutboundRetryResult'], ParentType, ContextType, RequireFields<MutationUpdateOutboundRetryArgs, 'updateOutboundRetryInput'>>;
  updatePermission?: Resolver<ResolversTypes['UpdatePermissionResult'], ParentType, ContextType, RequireFields<MutationUpdatePermissionArgs, 'updatePermissionInput'>>;
  updateProjectConfiguration?: Resolver<ResolversTypes['UpdateProjectConfigurationResult'], ParentType, ContextType, RequireFields<MutationUpdateProjectConfigurationArgs, 'updateProjectConfigurationInput'>>;
  updateProjectToolCatalog?: Resolver<ResolversTypes['UpdateProjectToolCatalogResult'], ParentType, ContextType, RequireFields<MutationUpdateProjectToolCatalogArgs, 'updateProjectToolCatalogInput'>>;
  updateRole?: Resolver<ResolversTypes['UpdateRoleResult'], ParentType, ContextType, RequireFields<MutationUpdateRoleArgs, 'updateRoleInput'>>;
  updateRolePermissionScope?: Resolver<ResolversTypes['UpdateRolePermissionScopeResult'], ParentType, ContextType, RequireFields<MutationUpdateRolePermissionScopeArgs, 'updateRolePermissionScopeInput'>>;
  updateScope?: Resolver<ResolversTypes['UpdateScopeResult'], ParentType, ContextType, RequireFields<MutationUpdateScopeArgs, 'updateScopeInput'>>;
  updateToolCheckIn?: Resolver<ResolversTypes['UpdateToolCheckInResult'], ParentType, ContextType, RequireFields<MutationUpdateToolCheckInArgs, 'updateToolCheckInInput'>>;
  updateToolCheckInItems?: Resolver<ResolversTypes['UpdateToolCheckInItemsResult'], ParentType, ContextType, RequireFields<MutationUpdateToolCheckInItemsArgs, 'updateToolCheckInItemsInput'>>;
  updateToolInventory?: Resolver<ResolversTypes['UpdateToolInventoryResult'], ParentType, ContextType, RequireFields<MutationUpdateToolInventoryArgs, 'updateToolInventoryInput'>>;
  updateToolInventoryPhysicalCount?: Resolver<ResolversTypes['UpdateToolInventoryPhysicalCountResult'], ParentType, ContextType, RequireFields<MutationUpdateToolInventoryPhysicalCountArgs, 'updateToolInventoryPhysicalCountInput'>>;
  updateToolOrder?: Resolver<Maybe<ResolversTypes['UpdateToolOrderResult']>, ParentType, ContextType, RequireFields<MutationUpdateToolOrderArgs, 'input'>>;
  updateToolOrderCatalog?: Resolver<ResolversTypes['UpdateToolOrderCatalogResult'], ParentType, ContextType, RequireFields<MutationUpdateToolOrderCatalogArgs, 'updateToolOrderCatalogInput'>>;
  updateToolOrderInventory?: Resolver<ResolversTypes['UpdateToolOrderInventoryResult'], ParentType, ContextType, RequireFields<MutationUpdateToolOrderInventoryArgs, 'updateToolOrderInventoryInput'>>;
  updateToolRoom?: Resolver<Maybe<ResolversTypes['UpdateToolRoomResult']>, ParentType, ContextType, RequireFields<MutationUpdateToolRoomArgs, 'input'>>;
  updateToolTransfer?: Resolver<ResolversTypes['UpdateToolTransferResult'], ParentType, ContextType, RequireFields<MutationUpdateToolTransferArgs, 'updateToolTransferInput'>>;
  updateToolTransferItem?: Resolver<ResolversTypes['UpdateToolTransferItemResult'], ParentType, ContextType, RequireFields<MutationUpdateToolTransferItemArgs, 'updateToolTransferItemInput'>>;
  updateUom?: Resolver<ResolversTypes['UpdateUomResult'], ParentType, ContextType, RequireFields<MutationUpdateUomArgs, 'updateUomInput'>>;
  updateUserAccount?: Resolver<Maybe<ResolversTypes['UpdateUserAccountResult']>, ParentType, ContextType, RequireFields<MutationUpdateUserAccountArgs, 'updateUserAccountInput'>>;
  updateUserDefaultProject?: Resolver<ResolversTypes['UpdateUserDefaultProjectResult'], ParentType, ContextType, RequireFields<MutationUpdateUserDefaultProjectArgs, 'updateUserDefaultProjectInput'>>;
  updateUserProject?: Resolver<ResolversTypes['UpdateUserProjectResult'], ParentType, ContextType, RequireFields<MutationUpdateUserProjectArgs, 'updateUserProjectInput'>>;
  updateUserRole?: Resolver<ResolversTypes['UpdateUserRoleResult'], ParentType, ContextType, RequireFields<MutationUpdateUserRoleArgs, 'updateUserRoleInput'>>;
  updateUserToolRoom?: Resolver<ResolversTypes['UpdateUserToolRoomResult'], ParentType, ContextType, RequireFields<MutationUpdateUserToolRoomArgs, 'updateUserToolRoomInput'>>;
};

export type OutboundInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutboundInterface'] = ResolversParentTypes['OutboundInterface']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  errorType?: Resolver<Maybe<ResolversTypes['OutboundErrorType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nextScheduleDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  outboundAction?: Resolver<ResolversTypes['OutboundAction'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  response?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OutboundStatus'], ParentType, ContextType>;
  toolCheckIn?: Resolver<Maybe<ResolversTypes['ToolCheckIn']>, ParentType, ContextType>;
  toolOrder?: Resolver<Maybe<ResolversTypes['ToolOrder']>, ParentType, ContextType>;
  toolTransfer?: Resolver<Maybe<ResolversTypes['ToolTransfer']>, ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutboundRetryResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutboundRetry'] = ResolversParentTypes['OutboundRetry']> = {
  actionType?: Resolver<ResolversTypes['OutboundRetryActionType'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  errorType?: Resolver<Maybe<ResolversTypes['OutboundErrorType']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  nextScheduleDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  outboundInterfaceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  response?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retryCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['OutboundStatus'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Permission'] = ResolversParentTypes['Permission']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  module?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PermissionScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PermissionScope'] = ResolversParentTypes['PermissionScope']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  permission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType>;
  permissionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['Scope']>, ParentType, ContextType>;
  scopeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PickToolOrderInventoryResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PickToolOrderInventoryResponse'] = ResolversParentTypes['PickToolOrderInventoryResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['PickToolOrderInventoryError']>, ParentType, ContextType>;
  toolOrderInventoryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PickToolOrderInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PickToolOrderInventoryResult'] = ResolversParentTypes['PickToolOrderInventoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['PickToolOrderInventoryError']>, ParentType, ContextType>;
  toolOrder?: Resolver<ResolversTypes['ToolOrder'], ParentType, ContextType>;
  toolOrderCatalog?: Resolver<Maybe<ResolversTypes['ToolOrderCatalog']>, ParentType, ContextType>;
  toolOrderInventory?: Resolver<Maybe<ResolversTypes['ToolOrderInventory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['Project'] = ResolversParentTypes['Project']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['Project']>, { __typename: 'Project' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jobNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subJobNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thParentLocationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectConfiguration'] = ResolversParentTypes['ProjectConfiguration']> = {
  configurationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  configurationValue?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectToolCatalogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectToolCatalog'] = ResolversParentTypes['ProjectToolCatalog']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  limitCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  toolCatalogId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectToolCatalogCsvPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProjectToolCatalogCsvPayload'] = ResolversParentTypes['ProjectToolCatalogCsvPayload']> = {
  csvFileId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  crewById?: Resolver<Maybe<ResolversTypes['Crew']>, ParentType, ContextType, RequireFields<QueryCrewByIdArgs, 'id'>>;
  crewCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryCrewCountArgs>>;
  employeeImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryEmployeeImageUrlArgs, 'id'>>;
  employeePhotosCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryEmployeePhotosCountArgs>>;
  groupedParentInventoryCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryGroupedParentInventoryCountArgs>>;
  inboundControlsById?: Resolver<Maybe<ResolversTypes['InboundControls']>, ParentType, ContextType, RequireFields<QueryInboundControlsByIdArgs, 'id'>>;
  inboundInterfaceById?: Resolver<Maybe<ResolversTypes['InboundInterface']>, ParentType, ContextType, RequireFields<QueryInboundInterfaceByIdArgs, 'id'>>;
  inboundProcessById?: Resolver<Maybe<ResolversTypes['InboundProcess']>, ParentType, ContextType, RequireFields<QueryInboundProcessByIdArgs, 'id'>>;
  inboundQueueById?: Resolver<Maybe<ResolversTypes['InboundQueue']>, ParentType, ContextType, RequireFields<QueryInboundQueueByIdArgs, 'id'>>;
  latestCatalogImport?: Resolver<Maybe<ResolversTypes['ImportCatalogStatus']>, ParentType, ContextType>;
  outboundInterfaceById?: Resolver<Maybe<ResolversTypes['OutboundInterface']>, ParentType, ContextType, RequireFields<QueryOutboundInterfaceByIdArgs, 'id'>>;
  outboundInterfaceCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryOutboundInterfaceCountArgs>>;
  outboundRetryById?: Resolver<Maybe<ResolversTypes['OutboundRetry']>, ParentType, ContextType, RequireFields<QueryOutboundRetryByIdArgs, 'id'>>;
  outboundRetryCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryOutboundRetryCountArgs>>;
  permissionById?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType, RequireFields<QueryPermissionByIdArgs, 'id'>>;
  project?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType, RequireFields<QueryProjectArgs, 'id'>>;
  projectConfigurationById?: Resolver<Maybe<ResolversTypes['ProjectConfiguration']>, ParentType, ContextType, RequireFields<QueryProjectConfigurationByIdArgs, 'id'>>;
  projectConfigurationCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryProjectConfigurationCountArgs>>;
  projectToolCatalogById?: Resolver<Maybe<ResolversTypes['ProjectToolCatalog']>, ParentType, ContextType, RequireFields<QueryProjectToolCatalogByIdArgs, 'id'>>;
  projectToolCatalogCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryProjectToolCatalogCountArgs>>;
  projects?: Resolver<Array<Maybe<ResolversTypes['Project']>>, ParentType, ContextType>;
  roleById?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType, RequireFields<QueryRoleByIdArgs, 'id'>>;
  rolePermissionScopeById?: Resolver<Maybe<ResolversTypes['RolePermissionScope']>, ParentType, ContextType, RequireFields<QueryRolePermissionScopeByIdArgs, 'id'>>;
  scopeById?: Resolver<Maybe<ResolversTypes['Scope']>, ParentType, ContextType, RequireFields<QueryScopeByIdArgs, 'id'>>;
  searchCrews?: Resolver<Maybe<ResolversTypes['SearchCrewResult']>, ParentType, ContextType, Partial<QuerySearchCrewsArgs>>;
  searchEmployeePhotoss?: Resolver<Maybe<ResolversTypes['SearchEmployeePhotosResult']>, ParentType, ContextType, Partial<QuerySearchEmployeePhotossArgs>>;
  searchGroupedParentInventories?: Resolver<Maybe<ResolversTypes['SearchGroupedInventoryResult']>, ParentType, ContextType, Partial<QuerySearchGroupedParentInventoriesArgs>>;
  searchInboundControlss?: Resolver<Maybe<ResolversTypes['SearchInboundControlsResult']>, ParentType, ContextType, Partial<QuerySearchInboundControlssArgs>>;
  searchInboundInterfaces?: Resolver<Maybe<ResolversTypes['SearchInboundInterfaceResult']>, ParentType, ContextType, Partial<QuerySearchInboundInterfacesArgs>>;
  searchInboundProcesss?: Resolver<Maybe<ResolversTypes['SearchInboundProcessResult']>, ParentType, ContextType, Partial<QuerySearchInboundProcesssArgs>>;
  searchInboundQueues?: Resolver<Maybe<ResolversTypes['SearchInboundQueueResult']>, ParentType, ContextType, Partial<QuerySearchInboundQueuesArgs>>;
  searchOutboundInterfaces?: Resolver<Maybe<ResolversTypes['SearchOutboundInterfaceResult']>, ParentType, ContextType, Partial<QuerySearchOutboundInterfacesArgs>>;
  searchOutboundRetries?: Resolver<Maybe<ResolversTypes['SearchOutboundRetryResult']>, ParentType, ContextType, Partial<QuerySearchOutboundRetriesArgs>>;
  searchPermissions?: Resolver<Maybe<ResolversTypes['SearchPermissionResult']>, ParentType, ContextType, Partial<QuerySearchPermissionsArgs>>;
  searchProjectConfigurations?: Resolver<Maybe<ResolversTypes['SearchProjectConfigurationResult']>, ParentType, ContextType, Partial<QuerySearchProjectConfigurationsArgs>>;
  searchProjectToolCatalogs?: Resolver<Maybe<ResolversTypes['SearchProjectToolCatalogResult']>, ParentType, ContextType, Partial<QuerySearchProjectToolCatalogsArgs>>;
  searchProjects?: Resolver<Maybe<ResolversTypes['SearchProjectsResult']>, ParentType, ContextType, Partial<QuerySearchProjectsArgs>>;
  searchRolePermissionScopes?: Resolver<Maybe<ResolversTypes['SearchRolePermissionScopeResult']>, ParentType, ContextType, Partial<QuerySearchRolePermissionScopesArgs>>;
  searchRoles?: Resolver<Maybe<ResolversTypes['SearchRoleResult']>, ParentType, ContextType, Partial<QuerySearchRolesArgs>>;
  searchScopes?: Resolver<Maybe<ResolversTypes['SearchScopeResult']>, ParentType, ContextType, Partial<QuerySearchScopesArgs>>;
  searchToolCatalogImages?: Resolver<Maybe<ResolversTypes['SearchToolCatalogImageResult']>, ParentType, ContextType, Partial<QuerySearchToolCatalogImagesArgs>>;
  searchToolCatalogs?: Resolver<Maybe<ResolversTypes['SearchToolCatalogResult']>, ParentType, ContextType, Partial<QuerySearchToolCatalogsArgs>>;
  searchToolCategories?: Resolver<Maybe<ResolversTypes['SearchToolCategoryResult']>, ParentType, ContextType, Partial<QuerySearchToolCategoriesArgs>>;
  searchToolCategoryStatss?: Resolver<Maybe<ResolversTypes['SearchToolCategoryStatsResult']>, ParentType, ContextType, Partial<QuerySearchToolCategoryStatssArgs>>;
  searchToolCheckInItemss?: Resolver<Maybe<ResolversTypes['SearchToolCheckInItemsResult']>, ParentType, ContextType, Partial<QuerySearchToolCheckInItemssArgs>>;
  searchToolCheckIns?: Resolver<Maybe<ResolversTypes['SearchToolCheckInResult']>, ParentType, ContextType, Partial<QuerySearchToolCheckInsArgs>>;
  searchToolInventories?: Resolver<Maybe<ResolversTypes['SearchToolInventoryResult']>, ParentType, ContextType, Partial<QuerySearchToolInventoriesArgs>>;
  searchToolInventoryPhysicalCounts?: Resolver<Maybe<ResolversTypes['SearchToolInventoryPhysicalCountResult']>, ParentType, ContextType, Partial<QuerySearchToolInventoryPhysicalCountsArgs>>;
  searchToolInventoryStatuss?: Resolver<Maybe<ResolversTypes['SearchToolInventoryStatusResult']>, ParentType, ContextType, Partial<QuerySearchToolInventoryStatussArgs>>;
  searchToolOrderCatalogs?: Resolver<Maybe<ResolversTypes['SearchToolOrderCatalogResult']>, ParentType, ContextType, Partial<QuerySearchToolOrderCatalogsArgs>>;
  searchToolOrderHistorys?: Resolver<Maybe<ResolversTypes['SearchToolOrderHistoryResult']>, ParentType, ContextType, Partial<QuerySearchToolOrderHistorysArgs>>;
  searchToolOrderInventory?: Resolver<Maybe<ResolversTypes['SearchToolOrderInventoryResult']>, ParentType, ContextType, Partial<QuerySearchToolOrderInventoryArgs>>;
  searchToolOrderInventoryByOrderedFor?: Resolver<Maybe<ResolversTypes['SearchToolOrderInventoryResult']>, ParentType, ContextType, Partial<QuerySearchToolOrderInventoryByOrderedForArgs>>;
  searchToolOrders?: Resolver<Maybe<ResolversTypes['SearchToolOrderResult']>, ParentType, ContextType, Partial<QuerySearchToolOrdersArgs>>;
  searchToolRooms?: Resolver<Maybe<ResolversTypes['SearchToolRoomResult']>, ParentType, ContextType, Partial<QuerySearchToolRoomsArgs>>;
  searchToolTransferHistorys?: Resolver<Maybe<ResolversTypes['SearchToolTransferHistoryResult']>, ParentType, ContextType, Partial<QuerySearchToolTransferHistorysArgs>>;
  searchToolTransferItems?: Resolver<Maybe<ResolversTypes['SearchToolTransferItemResult']>, ParentType, ContextType, Partial<QuerySearchToolTransferItemsArgs>>;
  searchToolTransfers?: Resolver<Maybe<ResolversTypes['SearchToolTransferResult']>, ParentType, ContextType, Partial<QuerySearchToolTransfersArgs>>;
  searchToolTypes?: Resolver<Maybe<ResolversTypes['SearchToolTypeResult']>, ParentType, ContextType, Partial<QuerySearchToolTypesArgs>>;
  searchToolUserFavorites?: Resolver<Maybe<ResolversTypes['SearchToolUserFavoriteResult']>, ParentType, ContextType, Partial<QuerySearchToolUserFavoritesArgs>>;
  searchUoms?: Resolver<Maybe<ResolversTypes['SearchUomResult']>, ParentType, ContextType, Partial<QuerySearchUomsArgs>>;
  searchUserProjects?: Resolver<Maybe<ResolversTypes['SearchUserProjectResult']>, ParentType, ContextType, Partial<QuerySearchUserProjectsArgs>>;
  searchUserRoles?: Resolver<Maybe<ResolversTypes['SearchUserRoleResult']>, ParentType, ContextType, Partial<QuerySearchUserRolesArgs>>;
  searchUserToolRooms?: Resolver<Maybe<ResolversTypes['SearchUserToolRoomResult']>, ParentType, ContextType, Partial<QuerySearchUserToolRoomsArgs>>;
  searchUsers?: Resolver<Maybe<ResolversTypes['SearchUserResult']>, ParentType, ContextType, Partial<QuerySearchUsersArgs>>;
  toolCatalogById?: Resolver<Maybe<ResolversTypes['ToolCatalog']>, ParentType, ContextType, RequireFields<QueryToolCatalogByIdArgs, 'id'>>;
  toolCatalogImageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolCatalogImageCountArgs>>;
  toolCatalogImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryToolCatalogImageUrlArgs, 'id'>>;
  toolCatalogsCountForSearch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolCatalogsCountForSearchArgs>>;
  toolCategoriesCountForSearch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolCategoriesCountForSearchArgs>>;
  toolCategoryById?: Resolver<Maybe<ResolversTypes['ToolCategory']>, ParentType, ContextType, RequireFields<QueryToolCategoryByIdArgs, 'id'>>;
  toolCategoryGroupByName?: Resolver<Array<ResolversTypes['ToolCategory']>, ParentType, ContextType>;
  toolCategoryStatsById?: Resolver<Maybe<ResolversTypes['ToolCategoryStats']>, ParentType, ContextType, RequireFields<QueryToolCategoryStatsByIdArgs, 'id'>>;
  toolCheckInById?: Resolver<Maybe<ResolversTypes['ToolCheckIn']>, ParentType, ContextType, RequireFields<QueryToolCheckInByIdArgs, 'id'>>;
  toolCheckInCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolCheckInCountArgs>>;
  toolCheckInItemsById?: Resolver<Maybe<ResolversTypes['ToolCheckInItems']>, ParentType, ContextType, RequireFields<QueryToolCheckInItemsByIdArgs, 'id'>>;
  toolCheckInItemsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolCheckInItemsCountArgs>>;
  toolInventoryById?: Resolver<Maybe<ResolversTypes['ToolInventory']>, ParentType, ContextType, RequireFields<QueryToolInventoryByIdArgs, 'id'>>;
  toolInventoryCountForSearch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolInventoryCountForSearchArgs>>;
  toolInventoryPhysicalCountById?: Resolver<Maybe<ResolversTypes['ToolInventoryPhysicalCount']>, ParentType, ContextType, RequireFields<QueryToolInventoryPhysicalCountByIdArgs, 'id'>>;
  toolInventoryPhysicalCountCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolInventoryPhysicalCountCountArgs>>;
  toolInventoryStats?: Resolver<Maybe<ResolversTypes['ToolInventoryStatsResult']>, ParentType, ContextType, Partial<QueryToolInventoryStatsArgs>>;
  toolInventoryStatusById?: Resolver<Maybe<ResolversTypes['ToolInventoryStatus']>, ParentType, ContextType, RequireFields<QueryToolInventoryStatusByIdArgs, 'id'>>;
  toolInventoryStatusCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolInventoryStatusCountArgs>>;
  toolOrderById?: Resolver<Maybe<ResolversTypes['ToolOrder']>, ParentType, ContextType, RequireFields<QueryToolOrderByIdArgs, 'id'>>;
  toolOrderCatalogById?: Resolver<Maybe<ResolversTypes['ToolOrderCatalog']>, ParentType, ContextType, RequireFields<QueryToolOrderCatalogByIdArgs, 'id'>>;
  toolOrderFamilyTree?: Resolver<Maybe<ResolversTypes['SearchToolOrderResult']>, ParentType, ContextType, RequireFields<QueryToolOrderFamilyTreeArgs, 'id'>>;
  toolOrderHistoryById?: Resolver<Maybe<ResolversTypes['ToolOrderHistory']>, ParentType, ContextType, RequireFields<QueryToolOrderHistoryByIdArgs, 'id'>>;
  toolOrderInventoryById?: Resolver<Maybe<ResolversTypes['ToolOrderInventory']>, ParentType, ContextType, RequireFields<QueryToolOrderInventoryByIdArgs, 'id'>>;
  toolOrderStats?: Resolver<Maybe<ResolversTypes['ToolOrderStatsResponse']>, ParentType, ContextType, RequireFields<QueryToolOrderStatsArgs, 'toolOrderStatsInput'>>;
  toolOrderStatuses?: Resolver<Array<ResolversTypes['ToolOrderStatusData']>, ParentType, ContextType>;
  toolOrdersCountForSearch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolOrdersCountForSearchArgs>>;
  toolRoom?: Resolver<Maybe<ResolversTypes['ToolRoom']>, ParentType, ContextType, RequireFields<QueryToolRoomArgs, 'id'>>;
  toolRooms?: Resolver<Array<ResolversTypes['ToolRoom']>, ParentType, ContextType>;
  toolRoomsCountForSearch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolRoomsCountForSearchArgs>>;
  toolTransferById?: Resolver<Maybe<ResolversTypes['ToolTransfer']>, ParentType, ContextType, RequireFields<QueryToolTransferByIdArgs, 'id'>>;
  toolTransferCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolTransferCountArgs>>;
  toolTransferHistoryById?: Resolver<Maybe<ResolversTypes['ToolTransferHistory']>, ParentType, ContextType, RequireFields<QueryToolTransferHistoryByIdArgs, 'id'>>;
  toolTransferHistoryCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolTransferHistoryCountArgs>>;
  toolTransferItemById?: Resolver<Maybe<ResolversTypes['ToolTransferItem']>, ParentType, ContextType, RequireFields<QueryToolTransferItemByIdArgs, 'id'>>;
  toolTransferItemCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryToolTransferItemCountArgs>>;
  toolTypeById?: Resolver<Maybe<ResolversTypes['ToolType']>, ParentType, ContextType, RequireFields<QueryToolTypeByIdArgs, 'id'>>;
  toolUserFavoriteById?: Resolver<Maybe<ResolversTypes['ToolUserFavorite']>, ParentType, ContextType, RequireFields<QueryToolUserFavoriteByIdArgs, 'id'>>;
  uomById?: Resolver<Maybe<ResolversTypes['Uom']>, ParentType, ContextType, RequireFields<QueryUomByIdArgs, 'id'>>;
  uomCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryUomCountArgs>>;
  userByAuth?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userById?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserByIdArgs, 'id'>>;
  userProjectById?: Resolver<Maybe<ResolversTypes['UserProject']>, ParentType, ContextType, RequireFields<QueryUserProjectByIdArgs, 'id'>>;
  userRoleById?: Resolver<Maybe<ResolversTypes['UserRole']>, ParentType, ContextType, RequireFields<QueryUserRoleByIdArgs, 'id'>>;
  userRoleCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryUserRoleCountArgs>>;
  userToolRoomById?: Resolver<Maybe<ResolversTypes['UserToolRoom']>, ParentType, ContextType, RequireFields<QueryUserToolRoomByIdArgs, 'id'>>;
  userToolRoomCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryUserToolRoomCountArgs>>;
  usersCountForSearch?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, Partial<QueryUsersCountForSearchArgs>>;
};

export type RetryFailedOutboundSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RetryFailedOutboundSubscriptionPayload'] = ResolversParentTypes['RetryFailedOutboundSubscriptionPayload']> = {
  id?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RolePermissionScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RolePermissionScope'] = ResolversParentTypes['RolePermissionScope']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  permission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType>;
  permissionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scopeId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveToolUserFavoriteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveToolUserFavoriteResult'] = ResolversParentTypes['SaveToolUserFavoriteResult']> = {
  error?: Resolver<Maybe<ResolversTypes['SaveToolUserFavoriteError']>, ParentType, ContextType>;
  recordsAffected?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Scope'] = ResolversParentTypes['Scope']> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchCrewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchCrewResult'] = ResolversParentTypes['SearchCrewResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['Crew']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchEmployeePhotosResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchEmployeePhotosResult'] = ResolversParentTypes['SearchEmployeePhotosResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['EmployeePhotos']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchGroupedInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchGroupedInventoryResult'] = ResolversParentTypes['SearchGroupedInventoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['SearchGroupedInventoryError']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['GroupedToolInventory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchInboundControlsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchInboundControlsResult'] = ResolversParentTypes['SearchInboundControlsResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['InboundControls']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchInboundInterfaceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchInboundInterfaceResult'] = ResolversParentTypes['SearchInboundInterfaceResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['InboundInterface']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchInboundProcessResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchInboundProcessResult'] = ResolversParentTypes['SearchInboundProcessResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['InboundProcess']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchInboundQueueResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchInboundQueueResult'] = ResolversParentTypes['SearchInboundQueueResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['InboundQueue']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchOutboundInterfaceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchOutboundInterfaceResult'] = ResolversParentTypes['SearchOutboundInterfaceResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['OutboundInterface']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchOutboundRetryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchOutboundRetryResult'] = ResolversParentTypes['SearchOutboundRetryResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['OutboundRetry']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchPermissionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchPermissionResult'] = ResolversParentTypes['SearchPermissionResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['Permission']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchProjectConfigurationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchProjectConfigurationResult'] = ResolversParentTypes['SearchProjectConfigurationResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ProjectConfiguration']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchProjectToolCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchProjectToolCatalogResult'] = ResolversParentTypes['SearchProjectToolCatalogResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ProjectToolCatalog']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchProjectsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchProjectsResult'] = ResolversParentTypes['SearchProjectsResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['Project']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchRolePermissionScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchRolePermissionScopeResult'] = ResolversParentTypes['SearchRolePermissionScopeResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['RolePermissionScope']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchRoleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchRoleResult'] = ResolversParentTypes['SearchRoleResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['Role']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchScopeResult'] = ResolversParentTypes['SearchScopeResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['Scope']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolCatalogImageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolCatalogImageResult'] = ResolversParentTypes['SearchToolCatalogImageResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolCatalogImage']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolCatalogResult'] = ResolversParentTypes['SearchToolCatalogResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolCatalog']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolCategoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolCategoryResult'] = ResolversParentTypes['SearchToolCategoryResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolCategory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolCategoryStatsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolCategoryStatsResult'] = ResolversParentTypes['SearchToolCategoryStatsResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolCategoryStats']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolCheckInItemsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolCheckInItemsResult'] = ResolversParentTypes['SearchToolCheckInItemsResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolCheckInItems']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolCheckInResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolCheckInResult'] = ResolversParentTypes['SearchToolCheckInResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolCheckIn']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolInventoryPhysicalCountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolInventoryPhysicalCountResult'] = ResolversParentTypes['SearchToolInventoryPhysicalCountResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolInventoryPhysicalCount']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolInventoryResult'] = ResolversParentTypes['SearchToolInventoryResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolInventory']>>, ParentType, ContextType>;
  pageInfo?: Resolver<Maybe<ResolversTypes['PageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolInventoryStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolInventoryStatusResult'] = ResolversParentTypes['SearchToolInventoryStatusResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolInventoryStatus']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolOrderCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolOrderCatalogResult'] = ResolversParentTypes['SearchToolOrderCatalogResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolOrderCatalog']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolOrderHistoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolOrderHistoryResult'] = ResolversParentTypes['SearchToolOrderHistoryResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolOrderHistory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolOrderInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolOrderInventoryResult'] = ResolversParentTypes['SearchToolOrderInventoryResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolOrderInventory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolOrderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolOrderResult'] = ResolversParentTypes['SearchToolOrderResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolOrder']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolRoomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolRoomResult'] = ResolversParentTypes['SearchToolRoomResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolRoom']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolTransferHistoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolTransferHistoryResult'] = ResolversParentTypes['SearchToolTransferHistoryResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolTransferHistory']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolTransferItemResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolTransferItemResult'] = ResolversParentTypes['SearchToolTransferItemResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolTransferItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolTransferResult'] = ResolversParentTypes['SearchToolTransferResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolTransfer']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolTypeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolTypeResult'] = ResolversParentTypes['SearchToolTypeResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolType']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchToolUserFavoriteResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchToolUserFavoriteResult'] = ResolversParentTypes['SearchToolUserFavoriteResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['ToolUserFavorite']>>, ParentType, ContextType>;
  stats?: Resolver<Maybe<ResolversTypes['ToolUserFavoriteStats']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchUomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchUomResult'] = ResolversParentTypes['SearchUomResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['Uom']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchUserProjectResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchUserProjectResult'] = ResolversParentTypes['SearchUserProjectResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['UserProject']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchUserResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchUserResult'] = ResolversParentTypes['SearchUserResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchUserRoleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchUserRoleResult'] = ResolversParentTypes['SearchUserRoleResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['UserRole']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchUserToolRoomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchUserToolRoomResult'] = ResolversParentTypes['SearchUserToolRoomResult']> = {
  items?: Resolver<Maybe<Array<ResolversTypes['UserToolRoom']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  inboundControlUpdated?: SubscriptionResolver<ResolversTypes['InboundControlUpdatedSubscriptionPayload'], "inboundControlUpdated", ParentType, ContextType>;
  inventoryUpdated?: SubscriptionResolver<ResolversTypes['ToolInventorySubscriptionPayload'], "inventoryUpdated", ParentType, ContextType>;
  projectToolCatalogCsv?: SubscriptionResolver<ResolversTypes['ProjectToolCatalogCsvPayload'], "projectToolCatalogCsv", ParentType, ContextType>;
  retryFailedOutbound?: SubscriptionResolver<ResolversTypes['RetryFailedOutboundSubscriptionPayload'], "retryFailedOutbound", ParentType, ContextType>;
  toolHoundOutBound?: SubscriptionResolver<ResolversTypes['ToolHoundOutboundSubscriptionPayload'], "toolHoundOutBound", ParentType, ContextType>;
  toolOrderCreated?: SubscriptionResolver<ResolversTypes['ToolOrderSubscriptionPayload'], "toolOrderCreated", ParentType, ContextType>;
  toolOrderInventoryCreated?: SubscriptionResolver<ResolversTypes['ToolOrderInventoryCreatedSubscriptionPayload'], "toolOrderInventoryCreated", ParentType, ContextType>;
  toolOrderStatusUpdated?: SubscriptionResolver<ResolversTypes['ToolOrderStatusSubscriptionPayload'], "toolOrderStatusUpdated", ParentType, ContextType>;
  toolOrderUpdated?: SubscriptionResolver<ResolversTypes['ToolOrderUpdatedSubscriptionPayload'], "toolOrderUpdated", ParentType, ContextType>;
  toolRoomUpdated?: SubscriptionResolver<ResolversTypes['ToolRoomSubscriptionPayload'], "toolRoomUpdated", ParentType, ContextType>;
};

export interface TimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Time'], any> {
  name: 'Time';
}

export type ToggleCountRequiredResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToggleCountRequiredResult'] = ResolversParentTypes['ToggleCountRequiredResult']> = {
  error?: Resolver<Maybe<ResolversTypes['ToggleCountRequiredError']>, ParentType, ContextType>;
  toolInventory?: Resolver<Maybe<ResolversTypes['ToolInventory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolCatalogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolCatalog'] = ResolversParentTypes['ToolCatalog']> = {
  bscnPartNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inventoryType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isFavorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  limitCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectToolCatalog?: Resolver<Maybe<Array<Maybe<ResolversTypes['ProjectToolCatalog']>>>, ParentType, ContextType>;
  thToolCatalogId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolCatalogImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolCategory?: Resolver<Maybe<ResolversTypes['ToolCategory']>, ParentType, ContextType>;
  toolCategoryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['Uom']>, ParentType, ContextType>;
  uomId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolCatalogImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolCatalogImage'] = ResolversParentTypes['ToolCatalogImage']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolCategory'] = ResolversParentTypes['ToolCategory']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolCategoryStats?: Resolver<Maybe<ResolversTypes['ToolCategoryStats']>, ParentType, ContextType>;
  toolHoundId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolType?: Resolver<Maybe<ResolversTypes['ToolType']>, ParentType, ContextType>;
  toolTypeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolCategoryStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolCategoryStats'] = ResolversParentTypes['ToolCategoryStats']> = {
  consumablesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  equipmentCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  riggingCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  safetyCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toolCategoryName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolCheckInResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolCheckIn'] = ResolversParentTypes['ToolCheckIn']> = {
  checkInNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  parentCheckInId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  recipientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thTransactionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolCheckInItems?: Resolver<Maybe<Array<ResolversTypes['ToolCheckInItems']>>, ParentType, ContextType>;
  toolRoomId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolCheckInErrorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolCheckInErrors'] = ResolversParentTypes['ToolCheckInErrors']> = {
  error?: Resolver<Maybe<ResolversTypes['CreateToolCheckInError']>, ParentType, ContextType>;
  toolCatalogId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolInventoryId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolRoomId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  warning?: Resolver<Maybe<ResolversTypes['CreateToolCheckInWarning']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolCheckInItemsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolCheckInItems'] = ResolversParentTypes['ToolCheckInItems']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  originallyIssuedToThId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  toolCatalogId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolCheckInId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolInventoryId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolCheckInResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolCheckInResult'] = ResolversParentTypes['ToolCheckInResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['ToolCheckInErrors']>>>, ParentType, ContextType>;
  toolCheckIn?: Resolver<Maybe<ResolversTypes['ToolCheckIn']>, ParentType, ContextType>;
  warnings?: Resolver<Maybe<Array<Maybe<ResolversTypes['ToolCheckInErrors']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolHoundOutboundSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolHoundOutboundSubscriptionPayload'] = ResolversParentTypes['ToolHoundOutboundSubscriptionPayload']> = {
  referenceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolInventory'] = ResolversParentTypes['ToolInventory']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolInventory']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  barCode?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  barCodeId?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  countRequired?: Resolver<Maybe<ResolversTypes['Boolean']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  createdByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"createdBy":true}>, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  currentlyIssuedToUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"currentlyIssuedToId":true}>, ContextType>;
  deletedDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  inTransitCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  isLocked?: Resolver<Maybe<ResolversTypes['Boolean']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  isSerialized?: Resolver<ResolversTypes['Boolean'], { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  issuedCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  limitCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  onHandCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  onOrderCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  thInventoryId?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  thInventoryIdIdentifier?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolCatalog?: Resolver<Maybe<ResolversTypes['ToolCatalog']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolCatalogId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolRoom?: Resolver<Maybe<ResolversTypes['ToolRoom']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolRoomId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  updatedByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"updatedBy":true}>, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  vendor?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolInventoryPhysicalCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolInventoryPhysicalCount'] = ResolversParentTypes['ToolInventoryPhysicalCount']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolInventoryPhysicalCount']>, { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  adjustedCount?: Resolver<ResolversTypes['Int'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  lastStatusByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"lastStatusBy":true}>, ContextType>;
  lastStatusDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  originalCount?: Resolver<ResolversTypes['Int'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  physicalCount?: Resolver<ResolversTypes['Int'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolInventoryId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolRoomId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  updatedByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"updatedBy":true}>, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolInventoryPhysicalCount' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolInventoryStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolInventoryStats'] = ResolversParentTypes['ToolInventoryStats']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  onHandCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toolCatalogId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolInventoryStatsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolInventoryStatsResult'] = ResolversParentTypes['ToolInventoryStatsResult']> = {
  error?: Resolver<Maybe<ResolversTypes['ToolInventoryError']>, ParentType, ContextType>;
  stats?: Resolver<Maybe<Array<Maybe<ResolversTypes['ToolInventoryStats']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolInventoryStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolInventoryStatus'] = ResolversParentTypes['ToolInventoryStatus']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolInventorySubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolInventorySubscriptionPayload'] = ResolversParentTypes['ToolInventorySubscriptionPayload']> = {
  toolInventoryIds?: Resolver<Array<Maybe<ResolversTypes['ID']>>, ParentType, ContextType>;
  toolRoomId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrder'] = ResolversParentTypes['ToolOrder']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolOrder']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  availableToolInventories?: Resolver<Maybe<Array<ResolversTypes['ToolOrderAvailableInventory']>>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  checkedOutByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"checkedOutBy":true}>, ContextType>;
  checkedOutDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  createdByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"createdBy":true}>, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  crewCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  dispatchedByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"dispatchedBy":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  orderDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  orderNumber?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  orderPlacedForUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"orderPlacedFor":true}>, ContextType>;
  outOfStockToolOrder?: Resolver<Maybe<ResolversTypes['ToolOrder']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  parentToolOrder?: Resolver<Maybe<ResolversTypes['ToolOrder']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  parentToolOrderId?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  preppedBy?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  preppedDate?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  recipientEmployee?: Resolver<Maybe<ResolversTypes['UserProject']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"recipientId":true}>, ContextType>;

  requiredStartDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  stats?: Resolver<ResolversTypes['ToolOrderItemsStats'], { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  status?: Resolver<ResolversTypes['String'], { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  statusHistory?: Resolver<Array<ResolversTypes['ToolOrderHistory']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  thTransactionId?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  thTransactionNo?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolOrderCatalogs?: Resolver<Maybe<Array<ResolversTypes['ToolOrderCatalog']>>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolRoom?: Resolver<Maybe<ResolversTypes['ToolRoom']>, { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolRoomId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolOrder' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderAvailableInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderAvailableInventory'] = ResolversParentTypes['ToolOrderAvailableInventory']> = {
  quantityOnHand?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  toolCatalogId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolOrderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderCatalogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderCatalog'] = ResolversParentTypes['ToolOrderCatalog']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolOrderCatalog']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  alreadyIssuedCount?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  dispatcherComments?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  dispatcherCommentsBy?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  nonCatalogDescription?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  nonCatalogReferenceUrl?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  nonCatalogSimilarToId?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  nonCatalogUomId?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  quantity?: Resolver<ResolversTypes['Int'], { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  requesterComments?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  requesterCommentsByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"requesterCommentsBy":true}>, ContextType>;
  similarToolCatalog?: Resolver<Maybe<ResolversTypes['ToolCatalog']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolCatalog?: Resolver<Maybe<ResolversTypes['ToolCatalog']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolCatalogId?: Resolver<Maybe<ResolversTypes['ID']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolOrderId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolOrderInventories?: Resolver<Array<ResolversTypes['ToolOrderInventory']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['Uom']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'ToolOrderCatalog' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderHistory'] = ResolversParentTypes['ToolOrderHistory']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolOrderHistory']>, { __typename: 'ToolOrderHistory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  createdByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolOrderHistory' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"createdBy":true}>, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolOrderHistory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrderHistory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  stats?: Resolver<ResolversTypes['ToolOrderItemsStats'], { __typename: 'ToolOrderHistory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  status?: Resolver<ResolversTypes['String'], { __typename: 'ToolOrderHistory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolOrderId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrderHistory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderInventoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderInventory'] = ResolversParentTypes['ToolOrderInventory']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolOrderInventory']>, { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  dispatchQuantity?: Resolver<ResolversTypes['Int'], { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  dispatcherComments?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  dispatcherCommentsByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"dispatcherCommentsBy":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  status?: Resolver<ResolversTypes['String'], { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolInventory?: Resolver<Maybe<ResolversTypes['ToolInventory']>, { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolInventoryId?: Resolver<Maybe<ResolversTypes['ID']>, { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolOrderCatalog?: Resolver<Maybe<ResolversTypes['ToolOrderCatalog']>, { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolOrderCatalogId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'ToolOrderInventory' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderInventoryCreatedSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderInventoryCreatedSubscriptionPayload'] = ResolversParentTypes['ToolOrderInventoryCreatedSubscriptionPayload']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  quantityPicked?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  toolOrderCatalogId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolOrderId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolOrderInventoryId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderItemsStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderItemsStats'] = ResolversParentTypes['ToolOrderItemsStats']> = {
  consumablesCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolsCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderStats'] = ResolversParentTypes['ToolOrderStats']> = {
  orderCount?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderStatsResponseResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderStatsResponse'] = ResolversParentTypes['ToolOrderStatsResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['ToolOrderStatsError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ToolOrderStatsResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderStatsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderStatsResult'] = ResolversParentTypes['ToolOrderStatsResult']> = {
  cancelledCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  completedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  openCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  outOfStockCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  preparedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderStatusDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderStatusData'] = ResolversParentTypes['ToolOrderStatusData']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sortOrder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderStatusSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderStatusSubscriptionPayload'] = ResolversParentTypes['ToolOrderStatusSubscriptionPayload']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolOrderStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderSubscriptionPayload'] = ResolversParentTypes['ToolOrderSubscriptionPayload']> = {
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolOrderStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolRoomId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolOrderUpdatedSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolOrderUpdatedSubscriptionPayload'] = ResolversParentTypes['ToolOrderUpdatedSubscriptionPayload']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolOrderStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolRoomId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolRoomResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolRoom'] = ResolversParentTypes['ToolRoom']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolRoom']>, { __typename: 'ToolRoom' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  adhocEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attendantIds?: Resolver<Maybe<Array<ResolversTypes['ID']>>, ParentType, ContextType>;
  attendants?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  barCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  thLocationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  transferEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolRoomSubscriptionPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolRoomSubscriptionPayload'] = ResolversParentTypes['ToolRoomSubscriptionPayload']> = {
  toolRoomId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTransferResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolTransfer'] = ResolversParentTypes['ToolTransfer']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolTransfer']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  createdByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"createdBy":true}>, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  destinationToolRoom?: Resolver<Maybe<ResolversTypes['ToolRoom']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  destinationToolRoomId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  receivedByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"receivedBy":true}>, ContextType>;
  receivedDate?: Resolver<Maybe<ResolversTypes['Datetime']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  sourceAction?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  sourceToolRoom?: Resolver<Maybe<ResolversTypes['ToolRoom']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  sourceToolRoomId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  stats?: Resolver<Maybe<ResolversTypes['ToolTransferStats']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  status?: Resolver<ResolversTypes['String'], { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  thReceiptId?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  thTransferId?: Resolver<Maybe<ResolversTypes['String']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolTransferItems?: Resolver<Array<ResolversTypes['ToolTransferItem']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolTransferNumber?: Resolver<ResolversTypes['String'], { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  updatedByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"updatedBy":true}>, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolTransfer' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTransferHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolTransferHistory'] = ResolversParentTypes['ToolTransferHistory']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolTransferId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  toolTransferStats?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTransferItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolTransferItem'] = ResolversParentTypes['ToolTransferItem']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['ToolTransferItem']>, { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  createdByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"createdBy":true}>, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  id?: Resolver<ResolversTypes['ID'], { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  receivedQuantity?: Resolver<Maybe<ResolversTypes['Int']>, { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  requestedQuantity?: Resolver<ResolversTypes['Int'], { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolInventory?: Resolver<Maybe<ResolversTypes['ToolInventory']>, { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolInventoryId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  toolTransferId?: Resolver<ResolversTypes['ID'], { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;

  updatedByUser?: Resolver<Maybe<ResolversTypes['User']>, { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}> & GraphQLRecursivePick<ParentType, {"updatedBy":true}>, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], { __typename: 'ToolTransferItem' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTransferStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolTransferStats'] = ResolversParentTypes['ToolTransferStats']> = {
  consumables?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tools?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolType'] = ResolversParentTypes['ToolType']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toolHoundId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolUserFavoriteResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolUserFavorite'] = ResolversParentTypes['ToolUserFavorite']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFavorite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  projectId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  toolCatalog?: Resolver<Maybe<ResolversTypes['ToolCatalog']>, ParentType, ContextType>;
  toolCatalogId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ToolUserFavoriteStatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ToolUserFavoriteStats'] = ResolversParentTypes['ToolUserFavoriteStats']> = {
  consumables?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tools?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UomResolvers<ContextType = any, ParentType extends ResolversParentTypes['Uom'] = ResolversParentTypes['Uom']> = {
  abbreviation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateCrewResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateCrewResult'] = ResolversParentTypes['UpdateCrewResult']> = {
  crew?: Resolver<Maybe<ResolversTypes['Crew']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateCrewError']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateEmployeePhotosResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateEmployeePhotosResult'] = ResolversParentTypes['UpdateEmployeePhotosResult']> = {
  employeePhotos?: Resolver<Maybe<ResolversTypes['EmployeePhotos']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateEmployeePhotosError']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateOutboundInterfaceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOutboundInterfaceResult'] = ResolversParentTypes['UpdateOutboundInterfaceResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateOutboundInterfaceError']>>, ParentType, ContextType>;
  outboundInterface?: Resolver<Maybe<ResolversTypes['OutboundInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateOutboundRetryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOutboundRetryResult'] = ResolversParentTypes['UpdateOutboundRetryResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateOutboundRetryError']>>, ParentType, ContextType>;
  outboundRetry?: Resolver<Maybe<ResolversTypes['OutboundRetry']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePermissionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePermissionResult'] = ResolversParentTypes['UpdatePermissionResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdatePermissionError']>>, ParentType, ContextType>;
  permission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateProjectConfigurationResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateProjectConfigurationResult'] = ResolversParentTypes['UpdateProjectConfigurationResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateProjectConfigurationError']>>, ParentType, ContextType>;
  projectConfiguration?: Resolver<Maybe<ResolversTypes['ProjectConfiguration']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateProjectToolCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateProjectToolCatalogResult'] = ResolversParentTypes['UpdateProjectToolCatalogResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateProjectToolCatalogError']>>, ParentType, ContextType>;
  projectToolCatalog?: Resolver<Maybe<ResolversTypes['ProjectToolCatalog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateRolePermissionScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateRolePermissionScopeResult'] = ResolversParentTypes['UpdateRolePermissionScopeResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateRolePermissionScopeError']>>, ParentType, ContextType>;
  rolePermissionScope?: Resolver<Maybe<ResolversTypes['RolePermissionScope']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateRoleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateRoleResult'] = ResolversParentTypes['UpdateRoleResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateRoleError']>>, ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateScopeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateScopeResult'] = ResolversParentTypes['UpdateScopeResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateScopeError']>>, ParentType, ContextType>;
  scope?: Resolver<Maybe<ResolversTypes['Scope']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolCatalogImageResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolCatalogImageResult'] = ResolversParentTypes['UpdateToolCatalogImageResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolCatalogImageError']>>, ParentType, ContextType>;
  toolCatalogImage?: Resolver<Maybe<ResolversTypes['ToolCatalogImage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolCatalogResult'] = ResolversParentTypes['UpdateToolCatalogResult']> = {
  error?: Resolver<Maybe<ResolversTypes['UpdateToolCatalogError']>, ParentType, ContextType>;
  toolRoom?: Resolver<Maybe<ResolversTypes['ToolCatalog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolCategoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolCategoryResult'] = ResolversParentTypes['UpdateToolCategoryResult']> = {
  error?: Resolver<Maybe<ResolversTypes['UpdateToolCategoryError']>, ParentType, ContextType>;
  toolRoom?: Resolver<Maybe<ResolversTypes['ToolCategory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolCheckInItemsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolCheckInItemsResult'] = ResolversParentTypes['UpdateToolCheckInItemsResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolCheckInItemsError']>>, ParentType, ContextType>;
  toolCheckInItems?: Resolver<Maybe<ResolversTypes['ToolCheckInItems']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolCheckInResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolCheckInResult'] = ResolversParentTypes['UpdateToolCheckInResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolCheckInError']>>, ParentType, ContextType>;
  toolCheckIn?: Resolver<Maybe<ResolversTypes['ToolCheckIn']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolInventoryPhysicalCountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolInventoryPhysicalCountResult'] = ResolversParentTypes['UpdateToolInventoryPhysicalCountResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolInventoryPhysicalCountError']>>, ParentType, ContextType>;
  toolInventoryPhysicalCount?: Resolver<Maybe<ResolversTypes['ToolInventoryPhysicalCount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolInventoryResult'] = ResolversParentTypes['UpdateToolInventoryResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolInventoryError']>>, ParentType, ContextType>;
  toolInventory?: Resolver<Maybe<ResolversTypes['ToolInventory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolInventoryStatusResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolInventoryStatusResult'] = ResolversParentTypes['UpdateToolInventoryStatusResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolInventoryStatusError']>>, ParentType, ContextType>;
  toolInventoryStatus?: Resolver<Maybe<ResolversTypes['ToolInventoryStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolOrderCatalogResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolOrderCatalogResult'] = ResolversParentTypes['UpdateToolOrderCatalogResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolOrderCatalogError']>>, ParentType, ContextType>;
  toolOrderCatalog?: Resolver<Maybe<ResolversTypes['ToolOrderCatalog']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolOrderHistoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolOrderHistoryResult'] = ResolversParentTypes['UpdateToolOrderHistoryResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolOrderHistoryError']>>, ParentType, ContextType>;
  toolOrderHistory?: Resolver<Maybe<ResolversTypes['ToolOrderHistory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolOrderInventoryResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolOrderInventoryResult'] = ResolversParentTypes['UpdateToolOrderInventoryResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolOrderInventoryError']>>, ParentType, ContextType>;
  toolOrderInventory?: Resolver<Maybe<ResolversTypes['ToolOrderInventory']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolOrderResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolOrderResult'] = ResolversParentTypes['UpdateToolOrderResult']> = {
  error?: Resolver<Maybe<ResolversTypes['UpdateToolOrderError']>, ParentType, ContextType>;
  toolOrder?: Resolver<Maybe<ResolversTypes['ToolOrder']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolRoomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolRoomResult'] = ResolversParentTypes['UpdateToolRoomResult']> = {
  error?: Resolver<Maybe<ResolversTypes['UpdateToolRoomError']>, ParentType, ContextType>;
  toolRoom?: Resolver<Maybe<ResolversTypes['ToolRoom']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolTransferItemResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolTransferItemResult'] = ResolversParentTypes['UpdateToolTransferItemResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolTransferItemError']>>, ParentType, ContextType>;
  toolTransferItem?: Resolver<Maybe<ResolversTypes['ToolTransferItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateToolTransferResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateToolTransferResult'] = ResolversParentTypes['UpdateToolTransferResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateToolTransferError']>>, ParentType, ContextType>;
  toolTransfer?: Resolver<Maybe<ResolversTypes['ToolTransfer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUomResult'] = ResolversParentTypes['UpdateUomResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateUomError']>>, ParentType, ContextType>;
  uom?: Resolver<Maybe<ResolversTypes['Uom']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserAccountResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserAccountResult'] = ResolversParentTypes['UpdateUserAccountResult']> = {
  error?: Resolver<Maybe<ResolversTypes['UpdateUserError']>, ParentType, ContextType>;
  userAccount?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserDefaultProjectResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserDefaultProjectResult'] = ResolversParentTypes['UpdateUserDefaultProjectResult']> = {
  errors?: Resolver<Maybe<Array<Maybe<ResolversTypes['UpdateUserDefaultProjectError']>>>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserProjectResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserProjectResult'] = ResolversParentTypes['UpdateUserProjectResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateUserProjectError']>>, ParentType, ContextType>;
  userProject?: Resolver<Maybe<ResolversTypes['UserProject']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserResult'] = ResolversParentTypes['UpdateUserResult']> = {
  error?: Resolver<Maybe<ResolversTypes['UpdateUserError']>, ParentType, ContextType>;
  userAccount?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserRoleResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserRoleResult'] = ResolversParentTypes['UpdateUserRoleResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateUserRoleError']>>, ParentType, ContextType>;
  userRole?: Resolver<Maybe<ResolversTypes['UserRole']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateUserToolRoomResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateUserToolRoomResult'] = ResolversParentTypes['UpdateUserToolRoomResult']> = {
  errors?: Resolver<Maybe<Array<ResolversTypes['UpdateUserToolRoomError']>>, ParentType, ContextType>;
  userToolRoom?: Resolver<Maybe<ResolversTypes['UserToolRoom']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  __resolveReference?: ReferenceResolver<Maybe<ResolversTypes['User']>, { __typename: 'User' } & GraphQLRecursivePick<ParentType, {"id":true}>, ContextType>;
  bun?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  defaultProject?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  defaultProjectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  employee?: Resolver<Maybe<ResolversTypes['UserProject']>, ParentType, ContextType>;
  employeeImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lobEmployeeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  permissionScopes?: Resolver<Maybe<Array<ResolversTypes['PermissionScope']>>, ParentType, ContextType>;
  projects?: Resolver<Maybe<Array<Maybe<ResolversTypes['Project']>>>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['Role']>>, ParentType, ContextType>;
  toolRooms?: Resolver<Maybe<Array<Maybe<ResolversTypes['ToolRoom']>>>, ParentType, ContextType>;
  upn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserProjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserProject'] = ResolversParentTypes['UserProject']> = {
  badgeBarcodeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  crew?: Resolver<Maybe<ResolversTypes['Crew']>, ParentType, ContextType>;
  crewId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crewNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exemptedFromImport?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lobEmployeeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  persona?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  project?: Resolver<Maybe<ResolversTypes['Project']>, ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  supervisor?: Resolver<Maybe<ResolversTypes['UserProject']>, ParentType, ContextType>;
  supervisorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thRole?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thUserLogin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toolHoundId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserRole'] = ResolversParentTypes['UserRole']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdByUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  projectId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserToolRoomResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserToolRoom'] = ResolversParentTypes['UserToolRoom']> = {
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['Datetime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  toolRoom?: Resolver<Maybe<ResolversTypes['ToolRoom']>, ParentType, ContextType>;
  toolRoomId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updatedDate?: Resolver<Maybe<ResolversTypes['Datetime']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AddDeleteRolePermissionScopeResult?: AddDeleteRolePermissionScopeResultResolvers<ContextType>;
  AdhocOrderResult?: AdhocOrderResultResolvers<ContextType>;
  AdvanceToolOrderStatusResult?: AdvanceToolOrderStatusResultResolvers<ContextType>;
  BulkMergeResult?: BulkMergeResultResolvers<ContextType>;
  BulkUpdateToolInventoryResult?: BulkUpdateToolInventoryResultResolvers<ContextType>;
  CancelToolOrderResult?: CancelToolOrderResultResolvers<ContextType>;
  CreateCrewResult?: CreateCrewResultResolvers<ContextType>;
  CreateEmployeePhotosResult?: CreateEmployeePhotosResultResolvers<ContextType>;
  CreateInboundInterfaceResult?: CreateInboundInterfaceResultResolvers<ContextType>;
  CreateInboundProcessResult?: CreateInboundProcessResultResolvers<ContextType>;
  CreateInboundQueueResult?: CreateInboundQueueResultResolvers<ContextType>;
  CreateOutboundInterfaceResult?: CreateOutboundInterfaceResultResolvers<ContextType>;
  CreateOutboundRetryResult?: CreateOutboundRetryResultResolvers<ContextType>;
  CreatePermissionResult?: CreatePermissionResultResolvers<ContextType>;
  CreateProjectConfigurationResult?: CreateProjectConfigurationResultResolvers<ContextType>;
  CreateProjectToolCatalogResult?: CreateProjectToolCatalogResultResolvers<ContextType>;
  CreateRolePermissionScopeResult?: CreateRolePermissionScopeResultResolvers<ContextType>;
  CreateRoleResult?: CreateRoleResultResolvers<ContextType>;
  CreateScopeResult?: CreateScopeResultResolvers<ContextType>;
  CreateToolCatalogImageResult?: CreateToolCatalogImageResultResolvers<ContextType>;
  CreateToolCatalogResult?: CreateToolCatalogResultResolvers<ContextType>;
  CreateToolCategoryResult?: CreateToolCategoryResultResolvers<ContextType>;
  CreateToolCheckInItemsResult?: CreateToolCheckInItemsResultResolvers<ContextType>;
  CreateToolCheckInResult?: CreateToolCheckInResultResolvers<ContextType>;
  CreateToolInventoryPhysicalCountResult?: CreateToolInventoryPhysicalCountResultResolvers<ContextType>;
  CreateToolInventoryResult?: CreateToolInventoryResultResolvers<ContextType>;
  CreateToolInventoryStatusResult?: CreateToolInventoryStatusResultResolvers<ContextType>;
  CreateToolOrderCatalogResult?: CreateToolOrderCatalogResultResolvers<ContextType>;
  CreateToolOrderHistoryResult?: CreateToolOrderHistoryResultResolvers<ContextType>;
  CreateToolOrderInventoryResult?: CreateToolOrderInventoryResultResolvers<ContextType>;
  CreateToolOrderResult?: CreateToolOrderResultResolvers<ContextType>;
  CreateToolTransferHistoryResult?: CreateToolTransferHistoryResultResolvers<ContextType>;
  CreateToolTransferItemResult?: CreateToolTransferItemResultResolvers<ContextType>;
  CreateToolTransferResult?: CreateToolTransferResultResolvers<ContextType>;
  CreateToolTypeResult?: CreateToolTypeResultResolvers<ContextType>;
  CreateToolUserFavoriteResult?: CreateToolUserFavoriteResultResolvers<ContextType>;
  CreateUomResult?: CreateUomResultResolvers<ContextType>;
  CreateUserAccountResult?: CreateUserAccountResultResolvers<ContextType>;
  CreateUserProjectResult?: CreateUserProjectResultResolvers<ContextType>;
  CreateUserResult?: CreateUserResultResolvers<ContextType>;
  CreateUserRoleResult?: CreateUserRoleResultResolvers<ContextType>;
  CreateUserToolRoomResult?: CreateUserToolRoomResultResolvers<ContextType>;
  Crew?: CrewResolvers<ContextType>;
  Date?: GraphQLScalarType;
  Datetime?: GraphQLScalarType;
  DeleteCrewResult?: DeleteCrewResultResolvers<ContextType>;
  DeleteEmployeePhotosResult?: DeleteEmployeePhotosResultResolvers<ContextType>;
  DeleteOutboundInterfaceResult?: DeleteOutboundInterfaceResultResolvers<ContextType>;
  DeleteOutboundRetryResult?: DeleteOutboundRetryResultResolvers<ContextType>;
  DeletePermissionResult?: DeletePermissionResultResolvers<ContextType>;
  DeleteProjectConfigurationResult?: DeleteProjectConfigurationResultResolvers<ContextType>;
  DeleteProjectToolCatalogResult?: DeleteProjectToolCatalogResultResolvers<ContextType>;
  DeleteRolePermissionScopeResult?: DeleteRolePermissionScopeResultResolvers<ContextType>;
  DeleteRoleResult?: DeleteRoleResultResolvers<ContextType>;
  DeleteScopeResult?: DeleteScopeResultResolvers<ContextType>;
  DeleteToolCatalogImageResult?: DeleteToolCatalogImageResultResolvers<ContextType>;
  DeleteToolCheckInItemsResult?: DeleteToolCheckInItemsResultResolvers<ContextType>;
  DeleteToolCheckInResult?: DeleteToolCheckInResultResolvers<ContextType>;
  DeleteToolInventoryPhysicalCountResult?: DeleteToolInventoryPhysicalCountResultResolvers<ContextType>;
  DeleteToolInventoryResult?: DeleteToolInventoryResultResolvers<ContextType>;
  DeleteToolInventoryStatusResult?: DeleteToolInventoryStatusResultResolvers<ContextType>;
  DeleteToolOrderCatalogResult?: DeleteToolOrderCatalogResultResolvers<ContextType>;
  DeleteToolOrderHistoryResult?: DeleteToolOrderHistoryResultResolvers<ContextType>;
  DeleteToolOrderInventoryResult?: DeleteToolOrderInventoryResultResolvers<ContextType>;
  DeleteToolOrderResult?: DeleteToolOrderResultResolvers<ContextType>;
  DeleteToolTransferItemResult?: DeleteToolTransferItemResultResolvers<ContextType>;
  DeleteToolTransferResult?: DeleteToolTransferResultResolvers<ContextType>;
  DeleteToolUserFavoriteResult?: DeleteToolUserFavoriteResultResolvers<ContextType>;
  DeleteUomResult?: DeleteUomResultResolvers<ContextType>;
  DeleteUserProjectResult?: DeleteUserProjectResultResolvers<ContextType>;
  DeleteUserRoleResult?: DeleteUserRoleResultResolvers<ContextType>;
  DeleteUserToolRoomResult?: DeleteUserToolRoomResultResolvers<ContextType>;
  DispatchToolOrderStatusResult?: DispatchToolOrderStatusResultResolvers<ContextType>;
  EmployeePhotos?: EmployeePhotosResolvers<ContextType>;
  GeoLocation?: GeoLocationResolvers<ContextType>;
  GroupedToolInventory?: GroupedToolInventoryResolvers<ContextType>;
  ImportCatalogStatus?: ImportCatalogStatusResolvers<ContextType>;
  ImportResult?: ImportResultResolvers<ContextType>;
  InboundControlUpdatedSubscriptionPayload?: InboundControlUpdatedSubscriptionPayloadResolvers<ContextType>;
  InboundControls?: InboundControlsResolvers<ContextType>;
  InboundControlsResult?: InboundControlsResultResolvers<ContextType>;
  InboundInterface?: InboundInterfaceResolvers<ContextType>;
  InboundProcess?: InboundProcessResolvers<ContextType>;
  InboundQueue?: InboundQueueResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  MergeBulkToolCategoryStatsImportResponse?: MergeBulkToolCategoryStatsImportResponseResolvers<ContextType>;
  MergeBulkToolCategoryStatsImportResult?: MergeBulkToolCategoryStatsImportResultResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  OutboundInterface?: OutboundInterfaceResolvers<ContextType>;
  OutboundRetry?: OutboundRetryResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Permission?: PermissionResolvers<ContextType>;
  PermissionScope?: PermissionScopeResolvers<ContextType>;
  PickToolOrderInventoryResponse?: PickToolOrderInventoryResponseResolvers<ContextType>;
  PickToolOrderInventoryResult?: PickToolOrderInventoryResultResolvers<ContextType>;
  Project?: ProjectResolvers<ContextType>;
  ProjectConfiguration?: ProjectConfigurationResolvers<ContextType>;
  ProjectToolCatalog?: ProjectToolCatalogResolvers<ContextType>;
  ProjectToolCatalogCsvPayload?: ProjectToolCatalogCsvPayloadResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RetryFailedOutboundSubscriptionPayload?: RetryFailedOutboundSubscriptionPayloadResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RolePermissionScope?: RolePermissionScopeResolvers<ContextType>;
  SaveToolUserFavoriteResult?: SaveToolUserFavoriteResultResolvers<ContextType>;
  Scope?: ScopeResolvers<ContextType>;
  SearchCrewResult?: SearchCrewResultResolvers<ContextType>;
  SearchEmployeePhotosResult?: SearchEmployeePhotosResultResolvers<ContextType>;
  SearchGroupedInventoryResult?: SearchGroupedInventoryResultResolvers<ContextType>;
  SearchInboundControlsResult?: SearchInboundControlsResultResolvers<ContextType>;
  SearchInboundInterfaceResult?: SearchInboundInterfaceResultResolvers<ContextType>;
  SearchInboundProcessResult?: SearchInboundProcessResultResolvers<ContextType>;
  SearchInboundQueueResult?: SearchInboundQueueResultResolvers<ContextType>;
  SearchOutboundInterfaceResult?: SearchOutboundInterfaceResultResolvers<ContextType>;
  SearchOutboundRetryResult?: SearchOutboundRetryResultResolvers<ContextType>;
  SearchPermissionResult?: SearchPermissionResultResolvers<ContextType>;
  SearchProjectConfigurationResult?: SearchProjectConfigurationResultResolvers<ContextType>;
  SearchProjectToolCatalogResult?: SearchProjectToolCatalogResultResolvers<ContextType>;
  SearchProjectsResult?: SearchProjectsResultResolvers<ContextType>;
  SearchRolePermissionScopeResult?: SearchRolePermissionScopeResultResolvers<ContextType>;
  SearchRoleResult?: SearchRoleResultResolvers<ContextType>;
  SearchScopeResult?: SearchScopeResultResolvers<ContextType>;
  SearchToolCatalogImageResult?: SearchToolCatalogImageResultResolvers<ContextType>;
  SearchToolCatalogResult?: SearchToolCatalogResultResolvers<ContextType>;
  SearchToolCategoryResult?: SearchToolCategoryResultResolvers<ContextType>;
  SearchToolCategoryStatsResult?: SearchToolCategoryStatsResultResolvers<ContextType>;
  SearchToolCheckInItemsResult?: SearchToolCheckInItemsResultResolvers<ContextType>;
  SearchToolCheckInResult?: SearchToolCheckInResultResolvers<ContextType>;
  SearchToolInventoryPhysicalCountResult?: SearchToolInventoryPhysicalCountResultResolvers<ContextType>;
  SearchToolInventoryResult?: SearchToolInventoryResultResolvers<ContextType>;
  SearchToolInventoryStatusResult?: SearchToolInventoryStatusResultResolvers<ContextType>;
  SearchToolOrderCatalogResult?: SearchToolOrderCatalogResultResolvers<ContextType>;
  SearchToolOrderHistoryResult?: SearchToolOrderHistoryResultResolvers<ContextType>;
  SearchToolOrderInventoryResult?: SearchToolOrderInventoryResultResolvers<ContextType>;
  SearchToolOrderResult?: SearchToolOrderResultResolvers<ContextType>;
  SearchToolRoomResult?: SearchToolRoomResultResolvers<ContextType>;
  SearchToolTransferHistoryResult?: SearchToolTransferHistoryResultResolvers<ContextType>;
  SearchToolTransferItemResult?: SearchToolTransferItemResultResolvers<ContextType>;
  SearchToolTransferResult?: SearchToolTransferResultResolvers<ContextType>;
  SearchToolTypeResult?: SearchToolTypeResultResolvers<ContextType>;
  SearchToolUserFavoriteResult?: SearchToolUserFavoriteResultResolvers<ContextType>;
  SearchUomResult?: SearchUomResultResolvers<ContextType>;
  SearchUserProjectResult?: SearchUserProjectResultResolvers<ContextType>;
  SearchUserResult?: SearchUserResultResolvers<ContextType>;
  SearchUserRoleResult?: SearchUserRoleResultResolvers<ContextType>;
  SearchUserToolRoomResult?: SearchUserToolRoomResultResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  Time?: GraphQLScalarType;
  ToggleCountRequiredResult?: ToggleCountRequiredResultResolvers<ContextType>;
  ToolCatalog?: ToolCatalogResolvers<ContextType>;
  ToolCatalogImage?: ToolCatalogImageResolvers<ContextType>;
  ToolCategory?: ToolCategoryResolvers<ContextType>;
  ToolCategoryStats?: ToolCategoryStatsResolvers<ContextType>;
  ToolCheckIn?: ToolCheckInResolvers<ContextType>;
  ToolCheckInErrors?: ToolCheckInErrorsResolvers<ContextType>;
  ToolCheckInItems?: ToolCheckInItemsResolvers<ContextType>;
  ToolCheckInResult?: ToolCheckInResultResolvers<ContextType>;
  ToolHoundOutboundSubscriptionPayload?: ToolHoundOutboundSubscriptionPayloadResolvers<ContextType>;
  ToolInventory?: ToolInventoryResolvers<ContextType>;
  ToolInventoryPhysicalCount?: ToolInventoryPhysicalCountResolvers<ContextType>;
  ToolInventoryStats?: ToolInventoryStatsResolvers<ContextType>;
  ToolInventoryStatsResult?: ToolInventoryStatsResultResolvers<ContextType>;
  ToolInventoryStatus?: ToolInventoryStatusResolvers<ContextType>;
  ToolInventorySubscriptionPayload?: ToolInventorySubscriptionPayloadResolvers<ContextType>;
  ToolOrder?: ToolOrderResolvers<ContextType>;
  ToolOrderAvailableInventory?: ToolOrderAvailableInventoryResolvers<ContextType>;
  ToolOrderCatalog?: ToolOrderCatalogResolvers<ContextType>;
  ToolOrderHistory?: ToolOrderHistoryResolvers<ContextType>;
  ToolOrderInventory?: ToolOrderInventoryResolvers<ContextType>;
  ToolOrderInventoryCreatedSubscriptionPayload?: ToolOrderInventoryCreatedSubscriptionPayloadResolvers<ContextType>;
  ToolOrderItemsStats?: ToolOrderItemsStatsResolvers<ContextType>;
  ToolOrderStats?: ToolOrderStatsResolvers<ContextType>;
  ToolOrderStatsResponse?: ToolOrderStatsResponseResolvers<ContextType>;
  ToolOrderStatsResult?: ToolOrderStatsResultResolvers<ContextType>;
  ToolOrderStatusData?: ToolOrderStatusDataResolvers<ContextType>;
  ToolOrderStatusSubscriptionPayload?: ToolOrderStatusSubscriptionPayloadResolvers<ContextType>;
  ToolOrderSubscriptionPayload?: ToolOrderSubscriptionPayloadResolvers<ContextType>;
  ToolOrderUpdatedSubscriptionPayload?: ToolOrderUpdatedSubscriptionPayloadResolvers<ContextType>;
  ToolRoom?: ToolRoomResolvers<ContextType>;
  ToolRoomSubscriptionPayload?: ToolRoomSubscriptionPayloadResolvers<ContextType>;
  ToolTransfer?: ToolTransferResolvers<ContextType>;
  ToolTransferHistory?: ToolTransferHistoryResolvers<ContextType>;
  ToolTransferItem?: ToolTransferItemResolvers<ContextType>;
  ToolTransferStats?: ToolTransferStatsResolvers<ContextType>;
  ToolType?: ToolTypeResolvers<ContextType>;
  ToolUserFavorite?: ToolUserFavoriteResolvers<ContextType>;
  ToolUserFavoriteStats?: ToolUserFavoriteStatsResolvers<ContextType>;
  Uom?: UomResolvers<ContextType>;
  UpdateCrewResult?: UpdateCrewResultResolvers<ContextType>;
  UpdateEmployeePhotosResult?: UpdateEmployeePhotosResultResolvers<ContextType>;
  UpdateOutboundInterfaceResult?: UpdateOutboundInterfaceResultResolvers<ContextType>;
  UpdateOutboundRetryResult?: UpdateOutboundRetryResultResolvers<ContextType>;
  UpdatePermissionResult?: UpdatePermissionResultResolvers<ContextType>;
  UpdateProjectConfigurationResult?: UpdateProjectConfigurationResultResolvers<ContextType>;
  UpdateProjectToolCatalogResult?: UpdateProjectToolCatalogResultResolvers<ContextType>;
  UpdateRolePermissionScopeResult?: UpdateRolePermissionScopeResultResolvers<ContextType>;
  UpdateRoleResult?: UpdateRoleResultResolvers<ContextType>;
  UpdateScopeResult?: UpdateScopeResultResolvers<ContextType>;
  UpdateToolCatalogImageResult?: UpdateToolCatalogImageResultResolvers<ContextType>;
  UpdateToolCatalogResult?: UpdateToolCatalogResultResolvers<ContextType>;
  UpdateToolCategoryResult?: UpdateToolCategoryResultResolvers<ContextType>;
  UpdateToolCheckInItemsResult?: UpdateToolCheckInItemsResultResolvers<ContextType>;
  UpdateToolCheckInResult?: UpdateToolCheckInResultResolvers<ContextType>;
  UpdateToolInventoryPhysicalCountResult?: UpdateToolInventoryPhysicalCountResultResolvers<ContextType>;
  UpdateToolInventoryResult?: UpdateToolInventoryResultResolvers<ContextType>;
  UpdateToolInventoryStatusResult?: UpdateToolInventoryStatusResultResolvers<ContextType>;
  UpdateToolOrderCatalogResult?: UpdateToolOrderCatalogResultResolvers<ContextType>;
  UpdateToolOrderHistoryResult?: UpdateToolOrderHistoryResultResolvers<ContextType>;
  UpdateToolOrderInventoryResult?: UpdateToolOrderInventoryResultResolvers<ContextType>;
  UpdateToolOrderResult?: UpdateToolOrderResultResolvers<ContextType>;
  UpdateToolRoomResult?: UpdateToolRoomResultResolvers<ContextType>;
  UpdateToolTransferItemResult?: UpdateToolTransferItemResultResolvers<ContextType>;
  UpdateToolTransferResult?: UpdateToolTransferResultResolvers<ContextType>;
  UpdateUomResult?: UpdateUomResultResolvers<ContextType>;
  UpdateUserAccountResult?: UpdateUserAccountResultResolvers<ContextType>;
  UpdateUserDefaultProjectResult?: UpdateUserDefaultProjectResultResolvers<ContextType>;
  UpdateUserProjectResult?: UpdateUserProjectResultResolvers<ContextType>;
  UpdateUserResult?: UpdateUserResultResolvers<ContextType>;
  UpdateUserRoleResult?: UpdateUserRoleResultResolvers<ContextType>;
  UpdateUserToolRoomResult?: UpdateUserToolRoomResultResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserProject?: UserProjectResolvers<ContextType>;
  UserRole?: UserRoleResolvers<ContextType>;
  UserToolRoom?: UserToolRoomResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  auth?: AuthDirectiveResolver<any, any, ContextType>;
};
